// import { React, useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   RightLayoutContainer,
//   PageTitleComp,
//   DetailFields,
//   DownArrowDraw,
//   DropDownSearchDraw,
//   TableLayoutData,
//   // PaginationStyle
// } from "../../styledElements";
// import {
//   Styled,
//   DatePickerY,
//   DisabledButtonStyle,
//   GlobalSet,
// } from "../../pageStyled";
// import { DatePicker } from "antd";
// import Iconmoon from "../../../Components/IconsFiles/icon";
// import {
//   Button,
//   Row,
//   Col,
//   Form,
//   Input,
//   Select,
//   PageHeader,
//   Checkbox,
//   Tooltip,
//   Pagination,
// } from "antd";
// import { HaberForm } from "../../styledElements";
// import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
// import {
//   getProductDetails,
//   getProductsData,
// } from "../../../Services/productServices";
// import {
//   saveUploadedOrders,
//   getPackagingList,
// } from "../../../Services/orderServices";
// import {
//   getAllGradesForConfig,
//   getGradeQualitiesForConfig,
//   getJobCardSerialNumberParam,
//   getMachineGradeSelect,
//   getReelCoreValues,
// } from "../../../Services/settingsServices";
// import AlertContainer from "../../../Components/AlertBoxes/alertBox";
// import alertGreen from "../../../Assets/Icons/alertGreen.svg";
// import alertRed from "../../../Assets/Icons/alertRed.svg";
// import moment from "moment";
// import {
//   calculatePlannedReels,
//   calculatePlannedWeight,
//   plannedReelsCalculations
// } from "../../../Utils/helper/calculatePlannedWeight";
// import styled from "styled-components";
// import { FixedSizeList } from "react-window";
// import AutoSizer from "react-virtualized-auto-sizer";
// import { getUnitData } from "../../../Services/measurementService";
// import {
//   lengthUnit,
//   weightUnit,
//   weight_Unit_Conversions,
//   orderDim_Rewinder_Unit_Conversion,
//   currency_List,
//   conversionFactorTonneToUnits,
// } from "../../../Utils/Constant/MeasurementUnitList";
// import AddProductDrawer from "../ConflictingOrders/AddProductDrawer";
// const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
// const UploadedPoOrders = (props) => {
//   const location = useLocation();
//   const history = useNavigate();
//   const { height, width } = useWindowDimensions();
//   const { Option } = Select;
//   const [form] = Form.useForm();
//   const [ordersForSelectedPo, setOrdersForSelectedPo] = useState(
//     location.state.uploadedData
//   );
//   const [filteredOrders, setFilteredOrders] = useState(
//     location.state.uploadedData.data.pos[location.state.selectedPoIndex].orders
//   );
//   const [ordersToShow, setOrdersToShow] = useState();
//   const [poDataToSave, setPoDataToSave] = useState();
//   const [orderWeightUnit, setOrderWeightUnit] = useState("");
//   const [rerendering, setRerendering] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [orderTypes, setOrderTypes] = useState([]);
//   const [savedState, setSavedState] = useState(false);
//   const [isProductDropdownOpen, setProductDropdown] = useState(false);
//   const [productData, setProductData] = useState({
//     bulk: "",
//     gsm: "",
//   });
//   const [actionToaster, setActionToaster] = useState({
//     error: "",
//     msg: "",
//   });
//   const [visibleToaster, setVisibleToaster] = useState(false);
//   const [show, setShow] = useState(false);
//   const [defaultMixedGrain, setDefaultMixedGrain] = useState(false);
//   const [upperTolerance, setUpperTol] = useState("");
//   const [lowerTolerance, setLowerTol] = useState("");
//   const [isVisible, setIsVisible] = useState(false);
//   const [dimesionUnitList, setDimesionUnitList] = useState([]);
//   const [measurementData, setMeasurementData] = useState();
//   const [weightUnitList, setWeightUnitList] = useState([]);
//   const [currencyUnitData, setCurrencyUnitData] = useState([]);
//   const [reelPackagingData, setReelPackagingData] = useState([]);
//   const [sheetPackagingData, setSheetPackagingData] = useState([]);
//   const [otherButtonLoading, setOtherButtonLoadingLoadings] = useState(false);
//   const [loadings, setLoadings] = useState(false);
//   const [resendAppLoading, setResendApprovalLoading] = useState(false);
//   const [resendAppOtherButtonLoading, setResendAppOtherButtonLoading] =
//     useState(false);
//   // const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [gobackLoading, setGobackLoading] = useState(false);
//   // const listRef = useRef(null);

//   const [productDrawerVisible, setProductDrawerVisible] = useState(false);
//   const [allGrades, setAllGrades] = useState([]);
//   const [allQualities, setAllQualities] = useState([]);
//   const [orderConfigSettings, setOrderConfigSettings] = useState(null);
//   const [selectedOrderIndex, setSelectedOrderIndex] = useState();
//   const [reelvalues,setReelvalues] = useState([]);
//   const [corevalues,setCoreValues] = useState([]);
//   const [productSpecFormat, setProductSpecFormat] = useState("");

//   const [plyData, setPlyData] = useState([
//     { label: "1", value: 1 },
//     { label: "2", value: 2 },
//     { label: "3", value: 3 },
//     { label: "4", value: 4 },
//   ]);

//   const OrderSummary = styled.div`
//   .orderSummaryStyle {
//     display: block;
//     padding-bottom: 16px;
//     font-size: 12px;
//     font-family: var(--sf-pro-display-m);
//     color: black;
//     font-style: italic,
//     line-height: 16px;
//   }
//   .orderWeightStyle {
//     margin-right: -10px;
//   }
// `;
//   const rowCount = useRef(false);

//   const OnProductToggleSelect = () => {
//     setProductDropdown((prevState) => !prevState);
//   };

//   const onFinish = async () => {
//     // let dataToSave = poDataToSave.data;
//     // try {
//     //   const response = await getReelCoreValues();
//     //   if (!response.error) {
//     //     for (let index = 0; index < dataToSave.pos[0].orders.length; index++) {
//     //       let order = dataToSave.pos[0].orders[index].order;
//     //       order["category"] = dataToSave.pos[0].po["po/so"];
//     //       let productNo = order.product.split(" -");
//     //       if (
//     //         dataToSave.pos[0].po["po/so"] === "so" &&
//     //         dataToSave.pos[0].po.number
//     //       ) {
//     //         dataToSave.pos[0].po["reference_number"] =
//     //           dataToSave.pos[0].po.number;
//     //       }
//     //       else{
//     //         dataToSave.pos[index].po.number =`${dataToSave.pos[index].po.number}#%#${dataToSave.pos[index].po.customer?.split(" - ")[0] ?? ''}`;
//     //       }
//     //       if (dataToSave.pos[0].po["po/so"] === "so") {
//     //         order.po = "";
//     //         order.delivery_date = null;
//     //       }
//     //       else{
//     //         order.po = dataToSave.pos[index].po.number;
//     //         // order.delivery_date = dataToSave.pos[index].po.delivery_date;
//     //       }
//     //       // await getProductDetails(productNo[0]).then((productResp) => {
//     //       let productResp = products?.filter(
//     //         (ele) => productNo[0] === ele.code
//     //       );
//     //       let coreIdUnit;
//     //       let reelOdUnit;
//     //       if (
//     //         order.type === "reel" &&
//     //         response.default_reel_od &&
//     //         response.default_core_id
//     //       ) {
//     //         if (order.type === "reel") {
//     //           let widthData = (
//     //             order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //           ).toFixed(3);
//     //           let diaArr = [];
//     //           order.reel_od = response.default_reel_od
//     //             ? response.default_reel_od
//     //             : 0;
//     //           order.core_id = response.default_core_id
//     //             ? response.default_core_id
//     //             : 0;

//     //           // let productNo = order.product.split(" -");
//     //           // await getProductDetails(productNo[0]).then((productResp) => {
//     //           if (
//     //             (order.outer_dia?.length && order.inner_dia) ||
//     //             (order.outer_dia?.length &&
//     //               (order.inner_dia == 0 || order.inner_dia == ""))
//     //           ) {
//     //             coreIdUnit = response.default_reel_unit;
//     //             reelOdUnit = response.default_reel_unit;
//     //           } else if (order.outer_dia?.length == 0 && order.inner_dia) {
//     //             coreIdUnit = response.default_core_unit;
//     //             reelOdUnit = response.default_core_unit;
//     //           } else if (
//     //             order.outer_dia?.length == 0 &&
//     //             (order.inner_dia == 0 || order.inner_dia == "")
//     //           ) {
//     //             coreIdUnit =
//     //               measurementData.data.units_management.length.default;
//     //             reelOdUnit =
//     //               measurementData.data.units_management.length.default;
//     //           }

//     //           let outerDiaArr = [];
//     //           outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
//     //           order.outer_dia = response.default_reel_od ? outerDiaArr : diaArr;
//     //           order.inner_dia = response.default_core_id
//     //             ? response.default_core_id + " " + coreIdUnit
//     //             : "";

//     //           if (
//     //             order.type === "reel" &&
//     //             order.quantity_type === "reel_sheet" &&
//     //             order.no_of_reel_sheet
//     //           ) {
//     //             order.quantity = order.no_of_reel_sheet;
//     //             order.weight_unit =
//     //               measurementData.data.units_management.weight.default;
//     //             order["planning_quantity"] = order.no_of_reel_sheet;
//     //           } else {
//     //             let plannedReels = calculatePlannedReels(
//     //               parseFloat(widthData),
//     //               order.weight * weight_Unit_Conversions[order.weight_unit],
//     //               productResp[0].bulk,
//     //               order.outer_dia[0]?.split(" ")[0] *
//     //                 orderDim_Rewinder_Unit_Conversion[reelOdUnit],
//     //               order.inner_dia?.split(" ")[0] *
//     //                 orderDim_Rewinder_Unit_Conversion[coreIdUnit]
//     //             );
//     //             order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
//     //               ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
//     //               : 1;
//     //             order["planning_weight"] = order.weight;
//     //           }
//     //           let planned_weight = calculatePlannedWeight(
//     //             parseFloat(widthData),
//     //             productResp[0].bulk,
//     //             order.outer_dia[0]?.split(" ")[0] *
//     //               orderDim_Rewinder_Unit_Conversion[reelOdUnit],
//     //             order.inner_dia?.split(" ")[0] *
//     //               orderDim_Rewinder_Unit_Conversion[coreIdUnit],
//     //             order.quantity
//     //           );
//     //           let plannedWt =
//     //             planned_weight *
//     //             conversionFactorTonneToUnits[order.weight_unit];
//     //           order.planned_weight = plannedWt
//     //             ? parseFloat(plannedWt).toFixed(3)
//     //             : 0;

//     //           let plannedWtConversion;
//     //           if (
//     //             productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //             order?.per_weight_unit.toLowerCase()
//     //           ) {
//     //             order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //           }
//     //           // if(order?.weight_unit?.toLowerCase() !== order?.per_weight_unit?.toLowerCase()){
//     //           //   let unitToTonneConv = order.planned_weight * weight_Unit_Conversions[order?.weight_unit];
//     //           //   plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[order?.per_weight_unit];
//     //           // } else{
//     //           //     plannedWtConversion  = order.planned_weight;
//     //           // }
//     //           // const netPrice = parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //           //       ? parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //           //       : "";
//     //           let netPrice;
//     //           if (order.quantity_type == "weight") {
//     //             netPrice =
//     //               parseFloat(order.dealer_price) *
//     //               parseFloat(order.weight)?.toFixed(3);
//     //           }
//     //           order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //           order.quantity = Math.round(order.quantity);
//     //         }
//     //       } else if (order.type === "sheet") {
//     //         let widthData = (
//     //           order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //         ).toFixed(3);
//     //         let lengthData = (
//     //           order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //         ).toFixed(3);

//     //         if (
//     //           order.outer_dia?.length == 0 &&
//     //           (order.inner_dia == 0 || order.inner_dia == "")
//     //         ) {
//     //           if (order.quantity_type === "reel_sheet") {
//     //             let widthValue = parseFloat(widthData);
//     //             let lengthValue = parseFloat(lengthData);
//     //             order.weight_unit =
//     //               measurementData.data.units_management.weight.default;
//     //             const plannedWeight =
//     //               (lengthValue *
//     //                 widthValue *
//     //                 order.no_of_reel_sheet *
//     //                 productResp[0].gsm) /
//     //               (10000 * 1000000);
//     //             let plannedWt =
//     //               plannedWeight *
//     //               conversionFactorTonneToUnits[order.weight_unit];
//     //             order.planned_weight = plannedWt?.toFixed(3);
//     //             order["planning_quantity"] = order.no_of_reel_sheet;
//     //             // if(order.planned_weight){
//     //             //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
//     //             //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
//     //             //   // order.lower_tolerance = lowerTolerance;
//     //             //   // order.upper_tolerance = upperTolerance;
//     //             //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
//     //             //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
//     //             // }else{
//     //             //   // order.lower_tolerance = lowerTolerance;
//     //             //   // order.upper_tolerance = upperTolerance;
//     //             //   // order.calculated_lower_tolerance = parseFloat(order.calculated_lower_tolerance)?.toFixed(3);
//     //             //   // order.calculated_upper_tolerance = parseFloat(order.calculated_upper_tolerance)?.toFixed(3);
//     //             // }
//     //           } else {
//     //             order.weight = order.weight?.toFixed(3);
//     //             order.planned_weight = order.weight;
//     //             order["planning_weight"] = order.weight;
//     //             // if(order.planned_weight){
//     //             //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
//     //             //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
//     //             //   order.lower_tolerance = lowerTolerance;
//     //             //   order.upper_tolerance = upperTolerance;
//     //             //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
//     //             //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
//     //             // }else{
//     //             //   order.lower_tolerance = lowerTolerance;
//     //             //   order.upper_tolerance = upperTolerance;
//     //             //   // order.calculated_lower_tolerance = order.calculated_lower_tolerance?.toFixed(3);
//     //             //   // order.calculated_upper_tolerance = order.calculated_upper_tolerance?.toFixed(3);
//     //             // }
//     //             delete order.no_of_reel_sheet;
//     //           }
//     //           let plannedWtConversion;
//     //           if (
//     //             productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //             order?.per_weight_unit.toLowerCase()
//     //           ) {
//     //             order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //           }
//     //           if (
//     //             order?.weight_unit?.toLowerCase() !==
//     //             order?.per_weight_unit?.toLowerCase()
//     //           ) {
//     //             let unitToTonneConv =
//     //               order.planned_weight *
//     //               weight_Unit_Conversions[order?.weight_unit];
//     //             plannedWtConversion =
//     //               unitToTonneConv *
//     //               conversionFactorTonneToUnits[order?.per_weight_unit];
//     //           } else {
//     //             plannedWtConversion = order.planned_weight;
//     //           }
//     //           const netPrice =
//     //             parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //               ? parseFloat(order.dealer_price) *
//     //                 parseFloat(plannedWtConversion)
//     //               : "";
//     //           order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //         }
//     //         order.quantity = Math.round(order.quantity);
//     //       } else if (
//     //         order.type === "reel" &&
//     //         (!response.default_reel_od || !response.default_core_id)
//     //       ) {
//     //         if (order.type === "reel" && order.quantity_type === "reel_sheet") {
//     //           order.quantity = order.no_of_reel_sheet;
//     //           order.weight_unit =
//     //             measurementData.data.units_management.weight.default;
//     //           order["planning_quantity"] = order.no_of_reel_sheet;
//     //         } else {
//     //           order.quantity = 0;
//     //           order["planning_weight"] = order.weight;
//     //         }
//     //       }

//     //       if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
//     //         order["planned_sheets"] = order.no_of_reel_sheet;
//     //       }

//     //       if (order.quantity_type === "weight") {
//     //         let calculated_lower_tolerance = 0;
//     //         let calculated_upper_tolerance = 0;
//     //         if (order.weight) {
//     //           let upperTol =
//     //             (parseFloat(order.weight)?.toFixed(3) *
//     //               (100 + parseFloat(upperTolerance))) /
//     //             100;
//     //           let lowerTol =
//     //             (parseFloat(order.weight)?.toFixed(3) *
//     //               (100 - parseFloat(lowerTolerance))) /
//     //             100;
//     //           calculated_lower_tolerance = lowerTol.toFixed(3);
//     //           calculated_upper_tolerance = upperTol.toFixed(3);
//     //         }
//     //         order["tolerances"] = {
//     //           weight: {
//     //             upper_tolerance: parseFloat(upperTolerance),
//     //             lower_tolerance: parseFloat(lowerTolerance),
//     //             calculated_lower_tolerance: parseFloat(
//     //               calculated_lower_tolerance
//     //             ),
//     //             calculated_upper_tolerance: parseFloat(
//     //               calculated_upper_tolerance
//     //             ),
//     //             units: order.weight_unit
//     //               ? order.weight_unit
//     //               : measurementData.data.units_management.weight.default,
//     //           },
//     //         };
//     //       } else {
//     //         order["tolerances"] = {};
//     //       }

//     //       order["packaging_details"] = order.packaging_details.id;
//     //       order["ply"] = parseFloat(order.ply);
//     //       order.units = {
//     //         weight: order.weight_unit
//     //           ? order.weight_unit
//     //           : measurementData.data.units_management.weight.default,
//     //         ...(order.type === "sheet" && { length: order.size_unit }),
//     //         width: order.size_unit,
//     //         planned_weight:
//     //           order.quantity_type === "reel_sheet"
//     //             ? measurementData.data.units_management.weight.default
//     //             : order.weight_unit,
//     //         // ...order.type === "sheet" && {calculated_upper_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
//     //         // ...order.type === "sheet" && {calculated_lower_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
//     //         // core_id: order.type === "sheet" ? measurementData?.data.units_management.length.default : coreIdUnit,
//     //         // reel_od: order.type === "sheet" ? measurementData?.data.units_management.length.default : reelOdUnit,
//     //         dealer_price: order.currency,
//     //         customer_price: order.currency,
//     //         net_price: order.currency,
//     //         per_weight_unit: order?.per_weight_unit,
//     //       };
//     //       dataToSave.pos[0].orders[index].order = order;
//     //       // });
//     //     }
//     //   }
//     // } catch (error) {
//     //   console.log(error);
//     //   setLoadings(false);
//     //   setResendApprovalLoading(false);
//     // }
//     // console.log(dataToSave);

//     let dataToSave = poDataToSave.data;
//     // try {
//     //   const response = await getReelCoreValues();
//     //   if (!response.error) {
//     //     for (let index = 0; index < dataToSave.pos[0].orders.length; index++) {
//     //       let order = dataToSave.pos[0].orders[index].order;
//     //       order["category"] = dataToSave.pos[0].po["po/so"];
//     //       let productNo = order.product.split(" -");
//     //       if (
//     //         dataToSave.pos[0].po["po/so"] === "so" &&
//     //         dataToSave.pos[0].po.number
//     //       ) {
//     //         dataToSave.pos[0].po["reference_number"] =
//     //           dataToSave.pos[0].po.number;
//     //       }
//     //       if (dataToSave.pos[0].po["po/so"] === "so") {
//     //         order.po = "";
//     //         order.delivery_date = null;
//     //       }
//     //       // await getProductDetails(productNo[0]).then((productResp) => {
//     //       let productResp = products?.filter(
//     //         (ele) => productNo[0] === ele.code
//     //       );
//     //       let coreIdUnit;
//     //       let reelOdUnit;

//     //       if (!order?.reel_od && !order?.core_id) {
//     //         if (
//     //           order.type === "reel" &&
//     //           response.default_reel_od &&
//     //           response.default_core_id
//     //         ) {
//     //           if (order.type === "reel") {
//     //             let widthData = (
//     //               order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //             ).toFixed(3);
//     //             let diaArr = [];
//     //             order.reel_od = response.default_reel_od
//     //               ? response.default_reel_od
//     //               : 0;
//     //             order.core_id = response.default_core_id
//     //               ? response.default_core_id
//     //               : 0;

//     //             // let productNo = order.product.split(" -");
//     //             // await getProductDetails(productNo[0]).then((productResp) => {
//     //             if (
//     //               (order.outer_dia?.length && order.inner_dia) ||
//     //               (order.outer_dia?.length &&
//     //                 (order.inner_dia == 0 || order.inner_dia == ""))
//     //             ) {
//     //               coreIdUnit = response.default_reel_unit;
//     //               reelOdUnit = response.default_reel_unit;
//     //             } else if (order.outer_dia?.length == 0 && order.inner_dia) {
//     //               coreIdUnit = response.default_core_unit;
//     //               reelOdUnit = response.default_core_unit;
//     //             } else if (
//     //               order.outer_dia?.length == 0 &&
//     //               (order.inner_dia == 0 || order.inner_dia == "")
//     //             ) {
//     //               coreIdUnit =
//     //                 measurementData.data.units_management.length.default;
//     //               reelOdUnit =
//     //                 measurementData.data.units_management.length.default;
//     //             }

//     //             let outerDiaArr = [];
//     //             outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
//     //             order.outer_dia = response.default_reel_od ? outerDiaArr : diaArr;
//     //             order.inner_dia = response.default_core_id
//     //               ? response.default_core_id + " " + coreIdUnit
//     //               : "";

//     //             if (
//     //               order.type === "reel" &&
//     //               order.quantity_type === "reel_sheet" &&
//     //               order.no_of_reel_sheet
//     //             ) {
//     //               order.quantity = order.no_of_reel_sheet;
//     //               order.weight_unit =
//     //                 measurementData.data.units_management.weight.default;
//     //               order["planning_quantity"] = order.no_of_reel_sheet;
//     //             } else {
//     //               let plannedReels = calculatePlannedReels(
//     //                 parseFloat(widthData),
//     //                 order.weight * weight_Unit_Conversions[order.weight_unit],
//     //                 productResp[0].bulk,
//     //                 order.outer_dia[0]?.split(" ")[0] *
//     //                 orderDim_Rewinder_Unit_Conversion[reelOdUnit],
//     //                 order.inner_dia?.split(" ")[0] *
//     //                 orderDim_Rewinder_Unit_Conversion[coreIdUnit]
//     //               );
//     //               order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
//     //                 ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
//     //                 : 1;
//     //               order["planning_weight"] = order.weight;
//     //             }
//     //             let planned_weight = calculatePlannedWeight(
//     //               parseFloat(widthData),
//     //               productResp[0].bulk,
//     //               parseFloat(order.outer_dia[0]?.split(" ")[0]) *
//     //               orderDim_Rewinder_Unit_Conversion[reelOdUnit],
//     //               parseFloat(order.inner_dia?.split(" ")[0]) *
//     //               orderDim_Rewinder_Unit_Conversion[coreIdUnit],
//     //               order.quantity
//     //             );
//     //             let plannedWt =
//     //               planned_weight *
//     //               conversionFactorTonneToUnits[order.weight_unit];
//     //             order.planned_weight = plannedWt
//     //               ? parseFloat(plannedWt).toFixed(3)
//     //               : 0;

//     //             let plannedWtConversion;
//     //             if (
//     //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //               order?.per_weight_unit.toLowerCase()
//     //             ) {
//     //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //             }
//     //             // if(order?.weight_unit?.toLowerCase() !== order?.per_weight_unit?.toLowerCase()){
//     //             //   let unitToTonneConv = order.planned_weight * weight_Unit_Conversions[order?.weight_unit];
//     //             //   plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[order?.per_weight_unit];
//     //             // } else{
//     //             //     plannedWtConversion  = order.planned_weight;
//     //             // }
//     //             // const netPrice = parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //             //       ? parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //             //       : "";
//     //             let netPrice;
//     //             if (order.quantity_type == "weight") {
//     //               netPrice =
//     //                 parseFloat(order.dealer_price) *
//     //                 parseFloat(order.weight)?.toFixed(3);
//     //             }
//     //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //             order.quantity = Math.round(order.quantity);
//     //           }
//     //         } else if (order.type === "sheet") {
//     //           let widthData = (
//     //             order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //           ).toFixed(3);
//     //           let lengthData = (
//     //             order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //           ).toFixed(3);

//     //           if (!order?.core_id) {
//     //             order.core_id = response.default_core_id ? response.default_core_id : 0;
//     //             if (!order.units.core_id_unit) {
//     //               order.units.core_id_unit = response.default_core_id
//     //                 ? response.default_core_unit
//     //                 : measurementData.data.units_management.default;
//     //             }
//     //             order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
//     //           }

//     //           if (
//     //             order.outer_dia?.length == 0 &&
//     //             (order.inner_dia == 0 || order.inner_dia == "")
//     //           ) {
//     //             if (order.quantity_type === "reel_sheet") {
//     //               let widthValue = parseFloat(widthData);
//     //               let lengthValue = parseFloat(lengthData);
//     //               order.weight_unit =
//     //                 measurementData.data.units_management.weight.default;
//     //               const plannedWeight =
//     //                 (lengthValue *
//     //                   widthValue *
//     //                   order.no_of_reel_sheet *
//     //                   productResp[0].gsm) /
//     //                 (10000 * 1000000);
//     //               let plannedWt =
//     //                 plannedWeight *
//     //                 conversionFactorTonneToUnits[order.weight_unit];
//     //               order.planned_weight = plannedWt?.toFixed(3);
//     //               order["planning_quantity"] = order.no_of_reel_sheet;
//     //               // if(order.planned_weight){
//     //               //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
//     //               //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
//     //               //   // order.lower_tolerance = lowerTolerance;
//     //               //   // order.upper_tolerance = upperTolerance;
//     //               //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
//     //               //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
//     //               // }else{
//     //               //   // order.lower_tolerance = lowerTolerance;
//     //               //   // order.upper_tolerance = upperTolerance;
//     //               //   // order.calculated_lower_tolerance = parseFloat(order.calculated_lower_tolerance)?.toFixed(3);
//     //               //   // order.calculated_upper_tolerance = parseFloat(order.calculated_upper_tolerance)?.toFixed(3);
//     //               // }
//     //             } else {
//     //               order.weight = order.weight?.toFixed(3);
//     //               order.planned_weight = order.weight;
//     //               order["planning_weight"] = order.weight;
//     //               // if(order.planned_weight){
//     //               //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
//     //               //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
//     //               //   order.lower_tolerance = lowerTolerance;
//     //               //   order.upper_tolerance = upperTolerance;
//     //               //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
//     //               //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
//     //               // }else{
//     //               //   order.lower_tolerance = lowerTolerance;
//     //               //   order.upper_tolerance = upperTolerance;
//     //               //   // order.calculated_lower_tolerance = order.calculated_lower_tolerance?.toFixed(3);
//     //               //   // order.calculated_upper_tolerance = order.calculated_upper_tolerance?.toFixed(3);
//     //               // }
//     //               delete order.no_of_reel_sheet;
//     //             }
//     //             let plannedWtConversion;
//     //             if (
//     //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //               order?.per_weight_unit.toLowerCase()
//     //             ) {
//     //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //             }
//     //             if (
//     //               order?.weight_unit?.toLowerCase() !==
//     //               order?.per_weight_unit?.toLowerCase()
//     //             ) {
//     //               let unitToTonneConv =
//     //                 order.planned_weight *
//     //                 weight_Unit_Conversions[order?.weight_unit];
//     //               plannedWtConversion =
//     //                 unitToTonneConv *
//     //                 conversionFactorTonneToUnits[order?.per_weight_unit];
//     //             } else {
//     //               plannedWtConversion = order.planned_weight;
//     //             }
//     //             const netPrice =
//     //               parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //                 ? parseFloat(order.dealer_price) *
//     //                 parseFloat(plannedWtConversion)
//     //                 : "";
//     //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //           }
//     //           order.quantity = Math.round(order.quantity);
//     //         } else if (
//     //           order.type === "reel" &&
//     //           (!response.default_reel_od || !response.default_core_id)
//     //         ) {
//     //           if (order.type === "reel" && order.quantity_type === "reel_sheet") {
//     //             order.quantity = order.no_of_reel_sheet;
//     //             order.weight_unit =
//     //               measurementData.data.units_management.weight.default;
//     //             order["planning_quantity"] = order.no_of_reel_sheet;
//     //           } else {
//     //             order.quantity = 0;
//     //             order["planning_weight"] = order.weight;
//     //           }
//     //         }
//     //       } else {
//     //         // if sheet and core id but no reel od = it will work like !reel and !core id
//     //         if (order?.type == "sheet" && !order?.reel_od && order?.core_id) {
//     //           let widthData = (
//     //             order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //           ).toFixed(3);
//     //           let lengthData = (
//     //             order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //           ).toFixed(3);

//     //           if (
//     //             order.outer_dia?.length == 0 &&
//     //             (order.inner_dia == 0 || order.inner_dia == "")
//     //           ) {
//     //             order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
//     //             if (order.quantity_type === "reel_sheet") {
//     //               let widthValue = parseFloat(widthData);
//     //               let lengthValue = parseFloat(lengthData);
//     //               order.weight_unit =
//     //                 measurementData.data.units_management.weight.default;
//     //               const plannedWeight =
//     //                 (lengthValue *
//     //                   widthValue *
//     //                   order.no_of_reel_sheet *
//     //                   productResp[0].gsm) /
//     //                 (10000 * 1000000);
//     //               let plannedWt =
//     //                 plannedWeight *
//     //                 conversionFactorTonneToUnits[order.weight_unit];
//     //               order.planned_weight = plannedWt?.toFixed(3);
//     //               order["planning_quantity"] = order.no_of_reel_sheet;
//     //             } else {
//     //               order.weight = order.weight?.toFixed(3);
//     //               order.planned_weight = order.weight;
//     //               order["planning_weight"] = order.weight;
//     //               delete order.no_of_reel_sheet;
//     //             }
//     //             let plannedWtConversion;
//     //             if (
//     //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //               order?.per_weight_unit.toLowerCase()
//     //             ) {
//     //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //             }
//     //             if (
//     //               order?.weight_unit?.toLowerCase() !==
//     //               order?.per_weight_unit?.toLowerCase()
//     //             ) {
//     //               let unitToTonneConv =
//     //                 order.planned_weight *
//     //                 weight_Unit_Conversions[order?.weight_unit];
//     //               plannedWtConversion =
//     //                 unitToTonneConv *
//     //                 conversionFactorTonneToUnits[order?.per_weight_unit];
//     //             } else {
//     //               plannedWtConversion = order.planned_weight;
//     //             }
//     //             const netPrice =
//     //               parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
//     //                 ? parseFloat(order.dealer_price) *
//     //                 parseFloat(plannedWtConversion)
//     //                 : "";
//     //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //           }
//     //           order.quantity = Math.round(order.quantity);
//     //         } else {
//     //           if (!order?.reel_od) {
//     //             order.reel_od = response.default_reel_od ? response.default_reel_od : 0;
//     //             if (!order.units.reel_od_unit) {
//     //               order.units.reel_od_unit = response.default_reel_od
//     //                 ? response.default_reel_unit
//     //                 : measurementData.data.units_management.default;
//     //             }
//     //           }

//     //           if (!order?.core_id) {
//     //             order.core_id = response.default_core_id ? response.default_core_id : 0;
//     //             if (!order.units.core_id_unit) {
//     //               order.units.core_id_unit = response.default_core_id
//     //                 ? response.default_core_unit
//     //                 : measurementData.data.units_management.default;
//     //             }
//     //           }

//     //           let outerDiaArr = [];
//     //           outerDiaArr.push(order?.reel_od + " " + (order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit));
//     //           order.outer_dia = outerDiaArr;
//     //           order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);

//     //           if (order.type === "reel") {
//     //             let widthData = (
//     //               order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //             ).toFixed(3);

//     //             if (
//     //               order.type === "reel" &&
//     //               order.quantity_type === "reel_sheet" &&
//     //               order.no_of_reel_sheet
//     //             ) {
//     //               order.quantity = order.no_of_reel_sheet;
//     //               order.weight_unit =
//     //                 measurementData.data.units_management.weight.default;
//     //               order["planning_quantity"] = order.no_of_reel_sheet;
//     //             } else {
//     //               let plannedReels = calculatePlannedReels(
//     //                 parseFloat(widthData),
//     //                 order.weight * weight_Unit_Conversions[order.weight_unit],
//     //                 productResp[0].bulk,
//     //                 order.outer_dia[0]?.split(" ")[0] *
//     //                 orderDim_Rewinder_Unit_Conversion[order.units.reel_od_unit],
//     //                 order.inner_dia?.split(" ")[0] *
//     //                 orderDim_Rewinder_Unit_Conversion[order.units.core_id_unit]
//     //               );
//     //               order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
//     //                 ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
//     //                 : 1;
//     //               order["planning_weight"] = order.weight;
//     //             }
//     //             //calculate planned weight
//     //             let planned_weight = calculatePlannedWeight(
//     //               parseFloat(widthData),
//     //               productResp[0].bulk,
//     //               parseFloat(order.outer_dia[0]?.split(" ")[0]) *
//     //               orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
//     //               parseFloat(order.inner_dia?.split(" ")[0]) *
//     //               orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
//     //               order.quantity
//     //             );
//     //             let plannedWt =
//     //               planned_weight *
//     //               conversionFactorTonneToUnits[order.weight_unit];
//     //             order.planned_weight = plannedWt
//     //               ? parseFloat(plannedWt).toFixed(3)
//     //               : 0;

//     //             let plannedWtConversion;
//     //             if (
//     //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //               order?.per_weight_unit.toLowerCase()
//     //             ) {
//     //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //             }
//     //             let netPrice;
//     //             if (order.quantity_type == "weight") {
//     //               netPrice =
//     //                 parseFloat(order.dealer_price) *
//     //                 parseFloat(order.weight)?.toFixed(3);
//     //             }
//     //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //             order.quantity = Math.round(order.quantity);

//     //           }
//     //           // else if (order.type === "reel" && (!order?.reel_od || !order?.core_id)) {
//     //           //   if (order.type === "reel" && order.quantity_type === "reel_sheet") {
//     //           //     order.quantity = order.no_of_reel_sheet;
//     //           //     order.weight_unit =
//     //           //       measurementData.data.units_management.weight.default;
//     //           //     order["planning_quantity"] = order.no_of_reel_sheet;
//     //           //   } else {
//     //           //     order.quantity = 0;
//     //           //     order["planning_weight"] = order.weight;
//     //           //   }
//     //           // } else
//     //           else {
//     //             let size =
//     //               (order?.grain === "Long Grain" ||
//     //                 order?.grain === "long" ||
//     //                 order?.grain === "long grain"
//     //                 ? parseFloat(order?.width) > parseFloat(order?.length)
//     //                   ? order?.length
//     //                   : order?.width
//     //                 : parseFloat(order?.length) > parseFloat(order?.width)
//     //                   ? order?.length
//     //                   : order?.width);

//     //             let widthData = (
//     //               size * orderDim_Rewinder_Unit_Conversion[order.size_unit]
//     //             ).toFixed(3);

//     //             let quantityValue;
//     //             let plannedReels;

//     //             if (order?.quantity_type == "weight") {
//     //               quantityValue = order.weight * weight_Unit_Conversions[order.weight_unit];
//     //               plannedReels = plannedReelsCalculations(
//     //                 parseFloat(widthData),
//     //                 order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
//     //                 order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
//     //                 productResp[0].bulk,
//     //                 productResp[0].gsm,
//     //                 order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
//     //                 order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
//     //                 quantityValue,
//     //                 order?.quantity_type
//     //               );
//     //               order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
//     //                 ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
//     //                 : 1;
//     //               order["planning_weight"] = order.weight;
//     //             } else {
//     //               //in ordertype = sheet && quantity type = sheet ? order?.no_of_reel_sheet means user entered value and same in planning qty
//     //               // quantity = calculated reels
//     //               quantityValue = order.no_of_reel_sheet;
//     //               plannedReels = plannedReelsCalculations(
//     //                 parseFloat(widthData),
//     //                 order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
//     //                 order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
//     //                 productResp[0].bulk,
//     //                 productResp[0].gsm,
//     //                 order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
//     //                 order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
//     //                 quantityValue,
//     //                 order?.quantity_type
//     //               );
//     //               order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
//     //                 ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
//     //                 : 1;
//     //               order["planning_quantity"] = order.no_of_reel_sheet;
//     //             }

//     //             //calculate planned weight
//     //             let planned_weight = calculatePlannedWeight(
//     //               parseFloat(widthData),
//     //               productResp[0].bulk,
//     //               parseFloat(order.outer_dia[0]?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
//     //               parseFloat(order.inner_dia?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
//     //               order.quantity
//     //             );
//     //             let plannedWt =
//     //               planned_weight *
//     //               conversionFactorTonneToUnits[order.weight_unit];
//     //             order.planned_weight = plannedWt
//     //               ? parseFloat(plannedWt).toFixed(3)
//     //               : 0;

//     //             if (
//     //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
//     //               order?.per_weight_unit.toLowerCase()
//     //             ) {
//     //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
//     //             }
//     //             let netPrice;
//     //             if (order.quantity_type == "weight") {
//     //               netPrice =
//     //                 parseFloat(order.dealer_price) *
//     //                 parseFloat(order.weight)?.toFixed(3);
//     //             }
//     //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
//     //             order.quantity = Math.round(order.quantity);
//     //           }

//     //         }
//     //       }

//     //       if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
//     //         order["planned_sheets"] = order.no_of_reel_sheet;
//     //       }

//     //       if (order.quantity_type === "weight") {
//     //         let calculated_lower_tolerance = 0;
//     //         let calculated_upper_tolerance = 0;
//     //         if (order.weight) {
//     //           let upperTol =
//     //             (parseFloat(order.weight)?.toFixed(3) *
//     //               (100 + parseFloat(upperTolerance))) /
//     //             100;
//     //           let lowerTol =
//     //             (parseFloat(order.weight)?.toFixed(3) *
//     //               (100 - parseFloat(lowerTolerance))) /
//     //             100;
//     //           calculated_lower_tolerance = lowerTol.toFixed(3);
//     //           calculated_upper_tolerance = upperTol.toFixed(3);
//     //         }
//     //         order["tolerances"] = {
//     //           weight: {
//     //             upper_tolerance: parseFloat(upperTolerance),
//     //             lower_tolerance: parseFloat(lowerTolerance),
//     //             calculated_lower_tolerance: parseFloat(
//     //               calculated_lower_tolerance
//     //             ),
//     //             calculated_upper_tolerance: parseFloat(
//     //               calculated_upper_tolerance
//     //             ),
//     //             units: order.weight_unit
//     //               ? order.weight_unit
//     //               : measurementData.data.units_management.weight.default,
//     //           },
//     //         };
//     //       } else {
//     //         order["tolerances"] = {};
//     //       }

//     //       order["packaging_details"] = order.packaging_details.id;
//     //       order["ply"] = parseFloat(order.ply);
//     //       order.units = {
//     //         weight: order.weight_unit
//     //           ? order.weight_unit
//     //           : measurementData.data.units_management.weight.default,
//     //         ...(order.type === "sheet" && { length: order.size_unit }),
//     //         width: order.size_unit,
//     //         planned_weight:
//     //           order.quantity_type === "reel_sheet"
//     //             ? measurementData.data.units_management.weight.default
//     //             : order.weight_unit,
//     //         // ...order.type === "sheet" && {calculated_upper_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
//     //         // ...order.type === "sheet" && {calculated_lower_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
//     //         // core_id: order.type === "sheet" ? measurementData?.data.units_management.length.default : coreIdUnit,
//     //         // reel_od: order.type === "sheet" ? measurementData?.data.units_management.length.default : reelOdUnit,
//     //         dealer_price: order.currency,
//     //         customer_price: order.currency,
//     //         net_price: order.currency,
//     //         per_weight_unit: order?.per_weight_unit,
//     //       };
//     //       dataToSave.pos[0].orders[index].order = order;
//     //       // });
//     //     }
//     //   }
//     // } catch (error) {
//     //   console.log(error);
//     //   setLoadings(false);
//     //   setResendApprovalLoading(false);
//     // }
//     // console.log(dataToSave);

//     // await saveUploadedOrders(dataToSave, location.state.format)
//     //   .then((response) => {
//     //     if (!response.error) {
//     //       setSavedState(true);
//     //     } else {
//     //       setSavedState(false);
//     //     }
//     //     let orders = ordersForSelectedPo;
//     //     orders.data.pos[location.state.selectedPoIndex]["isPOSaved"] = true;
//     //     setOrdersForSelectedPo(orders);
//     //     setActionToaster({
//     //       error: response.error,
//     //       msg: "Orders are successfully uploaded",
//     //     });
//     //     setLoadings(false);
//     //     showToaster();
//     //     setTimeout(() => {
//     //       history("../order-records/upload-summary", {
//     //         state: { action: orders, format: location.state.format },
//     //       });
//     //     }, 2000);
//     //   })
//     //   .catch((error) => {
//     //     setLoadings(false);
//     //     setResendApprovalLoading(false);
//     //     setActionToaster({
//     //       error: error.response.data.error,
//     //       msg: error.response.data.msg,
//     //     });
//     //     showToaster();
//     //   });
//   };

//   const handleType = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.type =
//       form.getFieldValue(`type${orderNumber}`);
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors.type
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["type"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//     }
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const handleProduct = (orderNumber,e) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.product = e;
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .product
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["product"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//     }

//     // setRerendering(true);
//     getProductDetails(form.getFieldValue(`product${orderNumber}`))
//       .then((response) => {
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].order.product_spec = response.data.product_spec;
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].order.product_data = {
//           grade: response.data.grade,
//           quality: response.data.quality,
//           bulk: response.data?.bulk,
//           gsm: response.data?.gsm,
//           burst_factor: response.data?.burst_factor,
//           moisture: response.data?.moisture,
//         };
//         setPlyData(
//           response.data.ply.map((ply) => ({ label: ply, value: ply }))
//         );
//         form.setFieldsValue({
//           [`gsm${orderNumber}`]: response.data?.gsm,
//         });
//         form.setFieldsValue({
//           [`bulk${orderNumber}`]: response.data?.bulk,
//         });
//         form.setFieldsValue({ [`grade${orderNumber}`]: response.data.grade });

//         setOrdersForSelectedPo(orders);
//         setRerendering(true);
//       })
//       .catch((error) => {
//         console.log("Error in getting product specification list");
//       });
//   };

//   const handlePly = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.ply =
//       form.getFieldValue(`ply${orderNumber}`);
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors.ply
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["ply"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//     }
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onSizeChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order
//         .type == "sheet"
//     ) {
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].order.width = form.getFieldValue(`size${orderNumber}`).split("x")[0]
//         ? parseFloat(form.getFieldValue(`size${orderNumber}`).split("x")[0])
//         : "";
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].order.length = form.getFieldValue(`size${orderNumber}`).split("x")[1]
//         ? parseFloat(form.getFieldValue(`size${orderNumber}`).split("x")[1])
//         : "";
//     } else {
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].order.width = form.getFieldValue(`size${orderNumber}`)
//         ? parseFloat(form.getFieldValue(`size${orderNumber}`))
//         : "";
//     }
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .width ||
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .length
//     ) {
//       if (
//         orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//           .width
//       ) {
//         delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .errors["width"];
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].error_count =
//           orders.data.pos[location.state.selectedPoIndex].orders[index]
//             .error_count - 1;
//       } else if (
//         orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//           .length
//       ) {
//         delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .errors["length"];
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].error_count =
//           orders.data.pos[location.state.selectedPoIndex].orders[index]
//             .error_count - 1;
//       }
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const onSizeUnitChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     orders.data.pos[location.state.selectedPoIndex].orders.map(
//       (order, index1) => {
//         if (orderNumber === order.order.orderNumber) {
//           // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'cm') {
//           //   order.order.width = (order.order.width * 10).toFixed(3);
//           // }
//           // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'inch') {
//           //   order.order.width = (order.order.width * 25.4).toFixed(3);
//           // }

//           // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'inch') {
//           //   order.order.width = (order.order.width * 2.54).toFixed(3);
//           // }

//           // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'mm') {
//           //   order.order.width = (order.order.width / 10).toFixed(3);
//           // }

//           // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'mm') {
//           //   order.order.width = (order.order.width / 25.4).toFixed(3);
//           // }

//           // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'cm') {
//           //   order.order.width = (order.order.width / 2.54).toFixed(3);
//           // }

//           // form.setFieldsValue({ [`size${order.order.orderNumber}`]: order.order.width });

//           // if(order.order.type == 'sheet')
//           // {
//           //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'cm') {
//           //     order.order.length = (order.order.length * 10).toFixed(3);
//           //   }
//           //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'inch') {
//           //     order.order.length = (order.order.length * 25.4).toFixed(3);
//           //   }

//           //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'inch') {
//           //     order.order.length = (order.order.length * 2.54).toFixed(3);
//           //   }

//           //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'mm') {
//           //     order.order.length = (order.order.length / 10).toFixed(3);
//           //   }

//           //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'mm') {
//           //     order.order.length = (order.order.length / 25.4).toFixed(3);
//           //   }

//           //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'cm') {
//           //     order.order.length = (order.order.length / 2.54).toFixed(3);
//           //   }
//           //   form.setFieldsValue({ [`size${order.order.orderNumber}`]: order.order.length });

//           // }
//           order.order.size_unit = form.getFieldValue(`sizeUnit${orderNumber}`);
//           form.setFieldsValue({
//             [`sizeUnit${order.order.orderNumber}`]: form.getFieldValue(
//               `sizeUnit${orderNumber}`
//             ),
//           });
//           if (order.errors.size_unit) {
//             delete order.errors["size_unit"];
//             order.error_count = order.error_count - 1;
//           }
//         }
//       }
//     );
//     let failedOrders = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.filter((item) => (show ? item.error_count > 0 : item));
//     setFilteredOrders(failedOrders);
//     setOrdersForSelectedPo(orders);
//     // form.resetFields();
//     setRerendering(true);
//   };

//   const onOrderWeightChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.weight =
//       form.getFieldValue(`orderWeight${orderNumber}`)
//         ? parseFloat(form.getFieldValue(`orderWeight${orderNumber}`))
//         : "";
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .weight
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["weight"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const onOrderWeightUnitChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     orders.data.pos[location.state.selectedPoIndex].orders.map(
//       (order, index1) => {
//         if (orderNumber === order.order.orderNumber) {
//           // if (order.order.weight_unit == 'tonne' && form.getFieldValue(`orderWeightUnit${orderNumber}`) == 'kg') {
//           //   order.order.weight = order.order.weight * 1000;
//           // }
//           // else {
//           //   order.order.weight = order.order.weight / 1000;
//           // }
//           // form.setFieldsValue({ [`orderWeight${order.order.orderNumber}`]: order.order.weight });
//           order.order.weight_unit = form.getFieldValue(
//             `orderWeightUnit${orderNumber}`
//           );
//           form.setFieldsValue({
//             [`orderWeightUnit${order.order.orderNumber}`]: form.getFieldValue(
//               `orderWeightUnit${orderNumber}`
//             ),
//           });

//           if (order.errors.weight_unit) {
//             delete order.errors["weight_unit"];
//             order.error_count = order.error_count - 1;
//           }
//         }
//       }
//     );
//     let failedOrders = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.filter((item) => (show ? item.error_count > 0 : item));
//     setFilteredOrders(failedOrders);
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onCurrencyChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     orders.data.pos[location.state.selectedPoIndex].orders.map(
//       (order, index1) => {
//         if (orderNumber === order.order.orderNumber) {
//           order.order.currency = form.getFieldValue(`currency${orderNumber}`);
//           form.setFieldsValue({
//             [`currency${order.order.orderNumber}`]: form.getFieldValue(
//               `currency${orderNumber}`
//             ),
//           });
//           if (order.errors.currency) {
//             delete order.errors["currency"];
//             order.error_count = order.error_count - 1;
//           }
//         }
//       }
//     );
//     let failedOrders = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.filter((item) => (show ? item.error_count > 0 : item));
//     setFilteredOrders(failedOrders);
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onWeightUnitChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     orders.data.pos[location.state.selectedPoIndex].orders.map(
//       (order, index1) => {
//         if (orderNumber === order.order.orderNumber) {
//           order.order.per_weight_unit = form.getFieldValue(
//             `per_weight_unit${orderNumber}`
//           );
//           form.setFieldsValue({
//             [`per_weight_unit${order.order.orderNumber}`]: form.getFieldValue(
//               `per_weight_unit${orderNumber}`
//             ),
//           });
//           if (order.errors.per_weight_unit) {
//             delete order.errors["per_weight_unit"];
//             order.error_count = order.error_count - 1;
//           }
//         }
//       }
//     );
//     let failedOrders = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.filter((item) => (show ? item.error_count > 0 : item));
//     setFilteredOrders(failedOrders);
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onPackagingChange = (orderNumber, e) => {
//     let orders = ordersForSelectedPo;
//     orders.data.pos[location.state.selectedPoIndex].orders.map(
//       (order, index1) => {
//         let packagingValue;
//         if (orderNumber === order.order.orderNumber) {
//           order.order.packaging_details = {};
//           if (order?.order?.type?.toLowerCase() == "sheet") {
//             packagingValue = sheetPackagingData?.filter(
//               (ele) =>
//                 ele.id == form.getFieldValue(`packagingType${orderNumber}`)
//             );
//           } else {
//             packagingValue = reelPackagingData?.filter(
//               (ele) =>
//                 ele.id == form.getFieldValue(`packagingType${orderNumber}`)
//             );
//           }
//           order.order.packaging_details = packagingValue[0];
//           form.setFieldsValue({
//             [`packagingType${order.order.orderNumber}`]: form
//               .getFieldValue(`packagingType${orderNumber}`)
//               .toString(),
//           });

//           if (order.errors.packaging_details) {
//             delete order.errors["packaging_details"];
//             order.error_count = order.error_count - 1;
//           }
//         }
//       }
//     );
//     let failedOrders = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.filter((item) => (show ? item.error_count > 0 : item));
//     setFilteredOrders(failedOrders);
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onQuantityChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.no_of_reel_sheet = form.getFieldValue(`quantity${orderNumber}`)
//       ? parseFloat(form.getFieldValue(`quantity${orderNumber}`))
//       : "";
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .no_of_reel_sheet
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["no_of_reel_sheet"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const onPriceChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.dealer_price = form.getFieldValue(`price${orderNumber}`)
//       ? parseFloat(form.getFieldValue(`price${orderNumber}`))
//       : "";
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .dealer_price
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["dealer_price"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const onCustPriceChange = (orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.customer_price = form.getFieldValue(`customerPrice${orderNumber}`)
//       ? parseFloat(form.getFieldValue(`customerPrice${orderNumber}`))
//       : "";
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .dealer_price
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["customer_price"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const onDeliveryDateChange = (orderNumber, newDate) => {
//     if (!newDate || !moment(newDate).isValid()) return;

//     const orders = { ...ordersForSelectedPo };
//     const poIndex = location.state.selectedPoIndex;
//     const dateStr = moment(newDate).format("YYYY-MM-DD 00:00:00");

//     const index = orders.data.pos[poIndex].orders.findIndex(
//       (item) => item.order.orderNumber === orderNumber
//     );
//     const targetOrder = orders.data.pos[poIndex].orders[index];
//     targetOrder.order.delivery_date = dateStr;

//     form.setFieldsValue({
//       [`deliveryDate${orderNumber}`]: moment(dateStr),
//     });

//     if (targetOrder.errors.delivery_date) {
//       delete targetOrder.errors["delivery_date"];
//       targetOrder.error_count -= 1;
//     }

//     if (orders.data.pos[poIndex].errors.delivery_date) {
//       delete orders.data.pos[poIndex].errors["delivery_date"];
//       orders.data.pos[poIndex].error_count -= 1;
//     }

//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onGrainChanges = (orderNumber,e) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.grain =
//       e;
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors.grain
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["grain"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//     }
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const handleGradeChange = async (orderNumber, e) => {
//     console.log(e);

//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });

//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data.grade = form.getFieldValue(`grade${orderNumber}`);

//     const generatedProductSpec = generateProductSpec(
//       productSpecFormat,
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data
//     );

//     const matchedProduct = products?.find(
//       (product) => product.complete_product_spec === generatedProductSpec
//     );

//     if (matchedProduct) {
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_spec = generatedProductSpec;
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = matchedProduct?.code;
//       form.setFieldsValue({
//         [`product${orderNumber}`]: matchedProduct?.code,
//       });
//       if (
//         orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product
//       ) {
//         delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .errors["product"];
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].error_count =
//           orders.data.pos[location.state.selectedPoIndex].orders[index]
//             .error_count - 1;
//       }
//     } else {
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_spec = "";
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = "";
//       form.setFieldsValue({
//         [`product${orderNumber}`]: "",
//       });

//       // if (
//       //   !orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//       //     .product
//       // ) {
//       //   orders.data.pos[location.state.selectedPoIndex].orders[index].errors[
//       //     "product"
//       //   ] = "Product not found";

//       //   orders.data.pos[location.state.selectedPoIndex].orders[index].error_count =
//       //     orders.data.pos[location.state.selectedPoIndex].orders[index]
//       //       .error_count + 1;
//       // }

//       const hasProductError =
//         !!orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product;

//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors[
//         "product"
//       ] = "Product not found";

//       if (!hasProductError) {
//         orders.data.pos[location.state.selectedPoIndex].orders[index].error_count += 1;
//       }
//     }
//     setOrdersForSelectedPo(orders);
//     // setRerendering(true);

//     // const response = await getAllQualities(currentOrder?.grade);
//     // const qualities = response.map((quality) => quality?.name);

//     // delete currentOrder?.errors?.grade;
//     // currentOrder.error_count = currentOrder?.error_count - 1;
//     // currentOrder.order.product_data.grade = e.target.value;

//     // if (qualities?.includes(currentOrder?.quality)) {
//     //   delete currentOrder?.errors?.quality;
//     //   currentOrder.error_count = currentOrder?.error_count - 1;
//     // }

//     // const updatedPOData = {
//     //   ...ordersForSelectedPo,
//     //   data: {
//     //     ...ordersForSelectedPo.data,
//     //     pos: ordersForSelectedPo?.data?.pos.map((po, ind) => {
//     //       if (ind == selectedPOIndex) {
//     //         return {
//     //           ...ordersForSelectedPo?.data?.pos[selectedPOIndex],
//     //           orders: ordersForSelectedPo?.data?.pos[
//     //             selectedPOIndex
//     //           ]?.orders.map((order) => {
//     //             if (order.orderNumber == orderNumber) {
//     //               return currentOrder;
//     //             } else return order;
//     //           }),
//     //         };
//     //       } else return po;
//     //     }),
//     //   },
//     // };

//     // console.log(updatedPOData);
//     // setOrdersForSelectedPo(updatedPOData);
//   };

//   const onGSMChange = async (orderNumber, e) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });

//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data.gsm = form.getFieldValue(`gsm${orderNumber}`);
//     // orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data.gsm = e.target.value;

//     const generatedProductSpec = generateProductSpec(
//       productSpecFormat,
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data
//     );

//     const matchedProduct = products?.find(
//       (product) => product.complete_product_spec === generatedProductSpec
//     );

//     if (matchedProduct) {
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_spec = generatedProductSpec;
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = matchedProduct?.code;
//       form.setFieldsValue({
//         [`product${orderNumber}`]: matchedProduct?.code,
//       });
//       if (
//         orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product
//       ) {
//         delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .errors["product"];
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].error_count =
//           orders.data.pos[location.state.selectedPoIndex].orders[index]
//             .error_count - 1;
//       }
//     } 
//     else {
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_spec = "";
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = "";
//       form.setFieldsValue({
//         [`product${orderNumber}`]: "",
//       });

//       const hasProductError =
//         !!orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product;

//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors[
//         "product"
//       ] = "Product not found";

//       if (!hasProductError) {
//         orders.data.pos[location.state.selectedPoIndex].orders[index].error_count += 1;
//       }
//     }
//     setOrdersForSelectedPo(orders);
//     // setRerendering(true);
//   };

//   const onBulkChange = (orderNumber,e) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });

//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data.bulk = form.getFieldValue(`bulk${orderNumber}`);

//     const generatedProductSpec = generateProductSpec(
//       productSpecFormat,
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_data
//     );

//     const matchedProduct = products?.find(
//       (product) => product.complete_product_spec === generatedProductSpec
//     );

//     if (matchedProduct) {
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_spec = generatedProductSpec;
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = matchedProduct?.code;
//       form.setFieldsValue({
//         [`product${orderNumber}`]: matchedProduct?.code,
//       });
//       if (
//         orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product
//       ) {
//         delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .errors["product"];
//         orders.data.pos[location.state.selectedPoIndex].orders[
//           index
//         ].error_count =
//           orders.data.pos[location.state.selectedPoIndex].orders[index]
//             .error_count - 1;
//       }
//     } else {
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product_spec = "";
//       orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = "";
//       form.setFieldsValue({
//         [`product${orderNumber}`]: "",
//       });

//       const hasProductError =
//         !!orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product;

//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors[
//         "product"
//       ] = "Product not found";

//       if (!hasProductError) {
//         orders.data.pos[location.state.selectedPoIndex].orders[index].error_count += 1;
//       }
//     }
//     setOrdersForSelectedPo(orders);
//     // setRerendering(true);
//   };

//   const onRemarkChange = (orderNumber,e) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.remarks = (form.getFieldValue(`remark${orderNumber}`));
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .remarks
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["remarks"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const onBalanceQtyChange = (orderNumber, e) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.balance_weight =
//       parseFloat(e.target.value)
//         ? parseFloat(e.target.value)
//         : "";
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .balance_weight
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["balance_weight"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   };

//   const saveDetails = () => {
//     // let orders = ordersForSelectedPo;
//     let orders = {
//       data: {
//         pos: [ordersForSelectedPo.data.pos[location.state.selectedPoIndex]],
//       },
//     };
//     setPoDataToSave(orders);
//     setIsVisible(false);
//     // setOrdersForSelectedPo(orders);
//     // setRerendering(true);
//       setLoadings(true);
//       setOtherButtonLoadingLoadings(true);
//     form.submit();
//   };

//   const goBack = () => {
//     setGobackLoading(true);
//     let originalArr = location.state.originalArr;
//     // let selectedPOInd = originalArr.data.pos.findIndex(
//     //   (ele) =>
//     //     ele.po.number ==
//     //     ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po.number
//     // );
//     originalArr.data.pos[location.state.selectedPoIndex]["orders"] =
//       ordersForSelectedPo.data.pos[location.state.selectedPoIndex].orders;

//     setTimeout(() => {
//       history("../order-records/upload-summary", {
//         state: {
//           // action: ordersForSelectedPo,
//           action: originalArr,
//           // filterState: location.state.filterState,
//           format: location.state.format,
//           currentPage: location.state.currentPage,
//         },
//       });
//     }, 400);
//   };

//   const showToaster = () => {
//     setVisibleToaster(true);
//     setTimeout(() => setVisibleToaster(false), 2000);
//   };

//   const setNewProductData = async (response) => {
//     try {
//       const updatedData = ordersForSelectedPo;
//       await ordersForSelectedPo?.data?.pos?.forEach((po, poIndex) => {
//         po.orders.forEach((order, orderIndex) => {
//           let orderMatches = true;
//           Object.keys(order.order.product_data).forEach((item) => {
//             orderMatches =
//               orderMatches && order.order.product_data[item] == response[item];
//           });
//           if (
//             updatedData?.data?.pos[poIndex]?.orders[orderIndex]?.error_count &&
//             orderMatches
//           ) {
//             Object.keys(
//               updatedData?.data?.pos[poIndex]?.orders[orderIndex]?.errors
//             ).forEach((item) => {
//               if (Object.keys(response).includes(item)) {
//                 delete updatedData.data.pos[poIndex].orders[orderIndex].errors[
//                   item
//                 ];
//                 updatedData.data.pos[poIndex].orders[orderIndex].error_count =
//                   updatedData?.data?.pos[poIndex]?.orders[orderIndex]
//                     ?.error_count - 1;
//                 updatedData.data.pos[poIndex].orders[
//                   orderIndex
//                 ].order.product_data[item] = response[item];
//               }
//             });
//             delete updatedData.data.pos[poIndex].orders[orderIndex].errors
//               .product;
//             updatedData.data.pos[poIndex].orders[orderIndex].error_count =
//               updatedData?.data?.pos[poIndex]?.orders[orderIndex]?.error_count -
//               1;
//             updatedData.data.pos[poIndex].orders[orderIndex].order.product =
//               response.code + " - " + response.name;
//           }
//         });
//       });
//       setOrdersForSelectedPo(updatedData);
//       setRerendering(true);
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   // const generateProductSpec = (format, productData) => {
//   //   if (!format) return "";

//   //   const fieldMap = {
//   //     grade: "grade",
//   //     gsm: "gsm",
//   //     bf: "burst_factor",
//   //     quality: "quality",
//   //     bulk: "bulk",
//   //     moisture: "moisture",
//   //   };

//   //   // return format
//   //   //   .split("/")
//   //   //   .map((field) => {
//   //   //     const key = fieldMap[field.trim().toLowerCase()];
//   //   //     return key ? productData[key] ?? "" : "";
//   //   //   })
//   //   //   .join("/");

//   //   return format
//   // .split("/")
//   // .map((field) => {
//   //   const fieldName = field.trim().toLowerCase();
//   //   const key = fieldMap[fieldName];

//   //   if (!key) return "";

//   //   if (fieldName === "grade") {
//   //     const gradeData = allGrades?.find(
//   //       (ele) => ele.value === productData.grade
//   //     );
//   //     return gradeData?.alias ?? "";
//   //   }

//   //   return productData[key] ?? "";
//   // })
//   // .join("/");
//   // };

//   const generateProductSpec = (format, productData) => {
//     if (!format) return "";

//     const fieldMap = {
//       grade: "grade",
//       gsm: "gsm",
//       bf: "burst_factor",
//       quality: "quality",
//       bulk: "bulk",
//       moisture: "moisture",
//     };

//     return format
//       .split("/")
//       .map((field) => {
//         const fieldName = field.trim().toLowerCase();
//         const key = fieldMap[fieldName];

//         if (!key) return "";

//         if (fieldName === "grade") {
//           const gradeData = allGrades?.find(
//             (ele) => ele.value === productData.grade
//           );
//           return gradeData?.alias ?? "";
//         }

//         return productData[key] ?? "";

//         // const value = productData[key];

//         // // Keep quality as it is
//         // if (fieldName === "quality") {
//         //   return value ?? "";
//         // }

//         // // For numeric fields, remove decimal part
//         // return value !== null && value !== undefined && value !== ""
//         //   ? parseInt(value, 10)
//         //   : "";
//       })
//       .join("/");
//   };
  
//   const handleQualityChange = (orderNumber, e) => {
//     console.log(e);
//     const selectedPOIndex = location?.state?.selectedPOIndex;
//     const currentOrder = ordersForSelectedPo?.data?.pos[
//       selectedPOIndex
//     ]?.orders?.find((item) => item?.order?.orderNumber == orderNumber);
//     delete currentOrder?.errors?.quality;
//     currentOrder.error_count = currentOrder?.error_count - 1;
//     currentOrder.order.product_data.quality = e.target.value;
//     const updatedPOData = {
//       ...ordersForSelectedPo,
//       data: {
//         ...ordersForSelectedPo.data,
//         pos: ordersForSelectedPo?.data?.pos.map((po, ind) => {
//           if (ind == selectedPOIndex) {
//             return {
//               ...ordersForSelectedPo?.data?.pos[selectedPOIndex],
//               orders: ordersForSelectedPo?.data?.pos[
//                 selectedPOIndex
//               ]?.orders.map((order) => {
//                 if (order.orderNumber == orderNumber) {
//                   return currentOrder;
//                 } else return order;
//               }),
//             };
//           } else return po;
//         }),
//       },
//     };

//     console.log(updatedPOData);
//     setOrdersForSelectedPo(updatedPOData);
//     setRerendering(true);
//   };

//   const getAllQualities = async (grade) => {
//     try {
//       const response = grade ? await getGradeQualitiesForConfig(grade) : [];
//       setAllQualities(
//         response.map((quality) => ({
//           label: quality?.name,
//           value: quality?.name,
//         }))
//       );
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   // const onProductChange = (index) => {
//   //   let orders = ordersForSelectedPo;
//   //   orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = form.getFieldValue(`product${index}`);
//   //   if (orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product) {
//   //     delete orders.data.pos[location.state.selectedPoIndex].orders[index].errors['product'];
//   //     orders.data.pos[location.state.selectedPoIndex].orders[index].error_count = orders.data.pos[location.state.selectedPoIndex].orders[index].error_count - 1;
//   //     setOrdersForSelectedPo(orders);
//   //     setRerendering(true);
//   //   }
//   // }

//   useEffect(() => {
//     (async () => {
//       document.body.style.overflow = "hidden";
//       ordersForSelectedPo.data.pos[0].orders.map((item) => {
//         if (item.order.type === "sheet") {
//           setIsVisible(true);
//         }
//       });

//       try {
//         const response = await getReelCoreValues();
//         if (!response.error) {
//           // setReelCoreData(response);
//           const reelData = response.reel_data.map((item) => {
//             return {
//               value: item[0] + " " + item[1],
//             };
//           });
//           const coreData = response.core_data.map((item) => {
//             return {
//               value: item[0] + " " + item[1],
//             };
//           });
//           setCoreValues(coreData);
//           setReelvalues(reelData);
//         }
//       } catch (error) {
//         console.log(error);
//       }

//       getProductsData({ status: "active" })
//         .then((response) => {
//           setProducts(response);
//         })
//         .catch((error) => {
//           console.log("Error in fetching products list:", error);
//         });

//       getMachineGradeSelect()
//         .then((response) => {
//           const reelValue = response.data.data.settings.order_types[0].value;
//           const sheetValue = response.data.data.settings.order_types[1].value;
//           let productSpecValue = response?.data?.data?.settings?.product_spec?.format;
//           setProductSpecFormat(productSpecValue);
//           setUpperTol(
//             response?.data?.data?.settings?.order_types[2]?.data
//               ?.order_tolerance?.upper_tolerance
//           );
//           setLowerTol(
//             response?.data?.data?.settings?.order_types[2]?.data
//               ?.order_tolerance?.lower_tolerance
//           );
//           setDefaultMixedGrain(
//             response.data.data.settings.order_types[1].mixed_grain
//           );
//           const typeData =
//             reelValue && sheetValue
//               ? [
//                   { label: "Reel", value: "reel" },
//                   { label: "Sheet", value: "sheet" },
//                 ]
//               : reelValue
//               ? [{ label: "Reel", value: "reel" }]
//               : sheetValue
//               ? [{ label: "Sheet", value: "sheet" }]
//               : [];
//           setOrderTypes(typeData);
//         })
//         .catch((error) => console.log(error));

//       try {
//         const unitData = await getUnitData();
//         if (!unitData.error) {
//           setMeasurementData(unitData);
//           setDimesionUnitList(unitData.data.units_management.length.data);
//           setWeightUnitList(unitData.data.units_management.weight.data);
//           let currencyData = currency_List?.filter((item) =>
//             unitData.data.units_management.currency.data.includes(item.code)
//           );
//           setCurrencyUnitData(currencyData);
//         }
//       } catch (err) {
//         console.log(err);
//       }

//       try {
//         const resp = await getPackagingList("", "active");
//         if (!resp.error) {
//           setReelPackagingData(resp.data.filter((item) => item.type == "reel"));
//           setSheetPackagingData(
//             resp.data.filter((item) => item.type == "sheet")
//           );
//           setRerendering(true);
//         }
//       } catch (err) {
//         console.log(err);
//       }

//       try {
//         const response = await getAllGradesForConfig();
//         const gradeOptions = response.map((grade) => ({
//           label: grade?.name,
//           value: grade?.name,
//           alias: grade?.alias,
//         }));
//         setAllGrades(gradeOptions);
//       } catch (e) {
//         console.log(e);
//       }

//       try {
//         const settings = await getJobCardSerialNumberParam();
//         setOrderConfigSettings(settings?.data?.order_creation_config);
//       } catch (e) {
//         console.log(e);
//       }

//       let orderstoshow = [];
//       filteredOrders?.map((item, index) => {
//         if (index < 25) {
//           orderstoshow.push(item);
//         }
//       });
//       setOrdersToShow(filteredOrders);
//     })();

//     return () => {
//       setOrderTypes([]);
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   useEffect(() => {
//     console.log("productSpecFormat updated:", productSpecFormat);
//   }, [productSpecFormat]);

//   const setRowCount = () => {
//     rowCount.current = true;
//   };

//   const filterRecords = (filterParam) => {
//     let orders = ordersForSelectedPo;
//     let failedOrders = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.filter((item) => (filterParam ? item.error_count > 0 : item));
//     setFilteredOrders(failedOrders);
//     setOrdersToShow(failedOrders);
//     // setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   // useEffect(() => {
//   //   if (rerendering) {
//   //     // form.resetFields();
//   //     // console.log("rerendering");
//   //     setOrdersToShow((
//   //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex].orders
//   //     ));
//   //     setRerendering(false);
//   //   }
//   // }, [rerendering]);

//   const handleScroll = () => {
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//     }, 1000);
//   };

//   const onGrainChangesChange = (e, orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.rotaion = e.target.checked;
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .rotaion
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["rotaion"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//     }
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onGrainMixingChange = (e, orderNumber) => {
//     let orders = ordersForSelectedPo;
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[
//       index
//     ].order.grain_mixing = e.target.checked;
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .grain_mixing
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["grain_mixing"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//     }
//     setOrdersForSelectedPo(orders);
//     setRerendering(true);
//   };

//   const onPageChange = (page, pageSize) => {
//     let start = page * pageSize - pageSize;
//     let end = page * pageSize;
//     if (end > filteredOrders.length) {
//       end = filteredOrders.length;
//     }
//     setOrdersToShow(filteredOrders.slice(start, end));
//   };

//   const addNewProduct = (index) => {
//     setProductDrawerVisible(true);
//     setSelectedOrderIndex(index);
//   };

//   const closeProductDrawer = () => {
//     setProductDrawerVisible(false);
//   };

//   const checkSaveDisabled = () => {
//     let isDisabled =
//       ordersForSelectedPo.data.pos[location?.state?.selectedPoIndex] 
//         ?.error_count;
//     let poSaved = ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//       .isPOSaved
//       ? true
//       : false
//     ordersForSelectedPo.data.pos[
//       location?.state?.selectedPoIndex
//     ]?.orders?.forEach((order) => {
//       isDisabled = isDisabled || order?.error_count || poSaved;
//     });
//     return isDisabled;
//   };

//   const getFrontendKeyForState = (state) => {
//     if (state == "completed" || state == "complete") return "Produced";
//     if (state == "approved") return "Active";
//   };

//   const isDisabled = (index, field) => {
//     return !ordersToShow[index].errors.hasOwnProperty(field);
//   };

//   const onReelODChange = (orderNumber,value) => {
//     // const coreODFieldValue = form.getFieldValue(`core_OD${orderNumber}`);
//     // const coreODParts = coreODFieldValue ? String(coreODFieldValue).trim().split(/\s+/) : [];
//     // let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreODParts[1]] ?? orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
//     // let reelodConversion = orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
//     // let coreODValue = (parseFloat(coreODParts[0]) || 0) * (coreodConversion ?? 0);
//     // let reelOdValue = (parseFloat(value?.split(" ")[0]) || 0) * (reelodConversion ?? 0);
//     // if (coreODValue > reelOdValue) {
//     //   setReelError(true);
//     //   return;
//     // }
//     // setReelError(false);
//     let orders = ordersForSelectedPo;
//     let reelODValue = value?.split(" ")[0];
//     let reelODUnit = value?.split(" ")[1];
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.reel_od =
//       parseFloat(reelODValue);
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.units.reel_od_unit = reelODUnit;
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .reel_od
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["reel_od"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     console.log('orders',orders);
    
//     setOrdersForSelectedPo(orders);
//   }

//   const onCoreODChange = (orderNumber,value) => {
//     // const reelODFieldValue = form.getFieldValue(`reel_OD${orderNumber}`);
//     // const reelODParts = reelODFieldValue ? String(reelODFieldValue).trim().split(/\s+/) : [];
//     // let coreodConversion = orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
//     // let reelodConversion = orderDim_Rewinder_Unit_Conversion[reelODParts[1]] ?? orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
//     // let coreODValue = (parseFloat(value?.split(" ")[0]) || 0) * (coreodConversion ?? 0);
//     // let reelOdValue = (parseFloat(reelODParts[0]) || 0) * (reelodConversion ?? 0);
//     // if (coreODValue > reelOdValue) {
//     //   setCoreError(true);
//     //   return;
//     // }
//     // setCoreError(false);
//     let orders = ordersForSelectedPo;
//     let coreIdValue = value?.split(" ")[0];
//     let coreIdUnit = value?.split(" ")[1];
//     const index = orders.data.pos[
//       location.state.selectedPoIndex
//     ].orders.findIndex(function (item, i) {
//       return item.order.orderNumber === orderNumber;
//     });
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.core_id =
//       parseFloat(coreIdValue);
//     orders.data.pos[location.state.selectedPoIndex].orders[index].order.units.core_id_unit = coreIdUnit;
//     if (
//       orders.data.pos[location.state.selectedPoIndex].orders[index].errors
//         .core_id
//     ) {
//       delete orders.data.pos[location.state.selectedPoIndex].orders[index]
//         .errors["core_id"];
//       orders.data.pos[location.state.selectedPoIndex].orders[
//         index
//       ].error_count =
//         orders.data.pos[location.state.selectedPoIndex].orders[index]
//           .error_count - 1;
//       let failedOrders = orders.data.pos[
//         location.state.selectedPoIndex
//       ].orders.filter((item) => (show ? item.error_count > 0 : item));
//       setFilteredOrders(failedOrders);
//     }
//     setOrdersForSelectedPo(orders);
//   }

//   const RowData = ({ index, style }) =>
//     index !== undefined && (
//       <div>
//         <Row
//           gutter={[10, 10]}
//           className="groupForm"
//           style={{ width: "298%", marginBottom: "10px", paddingBottom: "10px" }}
//         >
//           {/* <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
//                           {(ordersToShow[index].error_count || ordersToShow[index].errors.hasOwnProperty(ordersToShow[index])) ? (
//                             <Iconmoon icon="wrong" size={14} color="#EA655B" />
//                           ) : (
//                             <div style={{ width: "14px" }}></div>
//                           )
//                           }
//                         </Col> */}
//           <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
//             <Styled>
//               {/* {(ordersToShow[index].error_count || ordersToShow[index].errors.hasOwnProperty(ordersToShow[index])) && */}
//               <Tooltip
//                 placement="bottomRight"
//                 title={
//                   ordersToShow[index].error_count ||
//                   Object.keys(ordersToShow[index]?.errors || {})?.length > 0
//                     ? "This order has failed validation"
//                     : ""
//                 }
//                 className="edit-tooltip"
//                 getPopupContainer={(triggerNode) => triggerNode}
//               >
//                 <div style={{ cursor: "default" }}>
//                   {(ordersToShow[index].error_count ||
//                   Object.keys(ordersToShow[index]?.errors || {})?.length > 0) ? (
//                     <Iconmoon icon="wrong" size={14} color="#EA655B" />
//                   ) : (
//                     <div style={{ width: "14px" }}></div>
//                   )}
//                 </div>
//               </Tooltip>
//               {/* } */}
//             </Styled>
//           </Col>
//           <Col
//             style={{
//               paddingTop: index == 0 ? "40px" : "10px",
//               width: "22px",
//               margin: "2px 5px 0px 5px",
//             }}
//           >
//             <Styled>
//               {ordersToShow[index].errors?.active_jobcard_conflict && (
//                 <Tooltip
//                   placement="bottomRight"
//                   title={ordersToShow[index].errors?.active_jobcard_conflict}
//                   className="edit-tooltip"
//                   overlayStyle={{ maxWidth: 800, whiteSpace: "normal" }}
//                   getPopupContainer={(triggerNode) => triggerNode}
//                 >
//                   <div>
//                     <Iconmoon icon="warning-icon" size={18} color="#EA655B" />
//                   </div>
//                 </Tooltip>
//               )}
//             </Styled>
//           </Col>
//           <Col style={{ width: "70px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 || !rowCount.current ? "S.No." : ""}
//                 name={`sno${ordersToShow[index].order.orderNumber}`}
//                 rules={[]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index].order.orderNumber}
//               >
//                 <Input
//                   disabled={true}
//                   style={{ textTransform: "capitalize" }}
//                 />
//               </Form.Item>
//             </div>
//           </Col>
//           <Col style={{ width: "100px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Type" : ""}
//                 name={`type${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "This field is required",
//                   },
//                 ]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index].order.type}
//               >
//                 <Select
//                   placeholder="Type"
//                   suffixIcon={<DownArrowDraw />}
//                   onChange={() =>
//                     handleType(ordersToShow[index].order.orderNumber)
//                   }
//                   disabled={isDisabled(index, "type")}
//                 >
//                   {orderTypes.map((orderType) => (
//                     <Option key={orderType.value}>{orderType.label}</Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("type") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.type}
//               </span>
//             ) : null}
//           </Col>
//           <Col style={{ width: "250px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Product" : ""}
//                 name={`product${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "This field is required",
//                   },
//                 ]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index].order.product}
//                 // validateStatus={ordersToShow[index].errors.hasOwnProperty('product') ? "error" : null}
//                 // help={ordersToShow[index].errshowSearchsaors.hasOwnProperty('product') ? ordersToShow[index].errors.product : null}
//               >
//                 <Select
//                   placeholder="Select Product"
//                   suffixIcon={<DownArrowDraw />}
//                   // onBlur={OnProductToggleSelect}
//                   // onFocus={OnProductToggleSelect}
//                   showSearch
//                   optionFilterProp="children"
//                   onChange={(e) =>
//                     handleProduct(ordersToShow[index].order.orderNumber, e)
//                   }
//                   className="dBlock"
//                   style={{ textTransform: "capitalize" }}
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // disabled={isDisabled(index, "product") && isDisabled(index, "grade") && isDisabled(index, "quality") && isDisabled(index, "gsm")}
//                 >
//                   {products.map((product) => (
//                     <Option key={product.code}>
//                       {product.code} - {product.name}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//               <p style={{ marginTop: "5px", marginLeft: "5px" }}>
//                 {ordersToShow[index].order.product_spec}
//               </p>
//             </div>
//             <p
//               className="errorText"
//               style={{ color: "#ea4e2c" }}
//               dangerouslySetInnerHTML={{
//                 __html: ordersToShow[index].errors.product,
//               }}
//             ></p>
//             {/* Shah papers changes */}
//             {/* "GRADE" in case of empty field and "Grade" in case of new value */}
//             {/* {(!ordersToShow[index].errors.product?.includes("GRADE") &&
//               !ordersToShow[index].errors.product?.includes("gsm* is empty") &&
//               !ordersToShow[index].errors.product?.includes("Grade")) ? ( */}
//               {(ordersToShow[index].errors.product?.includes("Product having parameters")) ||
//               (ordersToShow[index].errors.product?.includes("Product not found")) && (
//                 <Button
//                 className="textTypeBtn"
//                 style={{
//                   margin: "1px 2px 1px auto",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "3px",
//                 }}
//                 onClick={() => addNewProduct(index)}
//               >
//                 <Iconmoon icon="addcircle" color="#ea4e2c" size={12} />
//                 Add Product
//               </Button>
//               )}
//             {/* ) : null
//             } */}
//           </Col>
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "grade"
//           ) || orderConfigSettings?.upload_orders?.config?.grade?.visibility ? (
//             <Col style={{ width: "150px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "Grade" : ""}
//                   name={`grade${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required: true,
//                       message: "This field is required",
//                     },
//                   ]}
//                   className="dBlock"
//                   initialValue={ordersToShow[index]?.order?.product_data?.grade}
//                 >
//                   <Select
//                     options={allGrades}
//                     onChange={(e) =>
//                       handleGradeChange(
//                         ordersToShow[index].order.orderNumber,
//                         e
//                       )
//                     }
//                     suffixIcon={<DownArrowDraw />}
//                     disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                     // disabled={isDisabled(index, "grade")}
//                   >
//                     {allGrades.map((grade) => (
//                     <Option key={grade.label}>
//                       {grade.label}
//                     </Option>
//                   ))}
//                   </Select>
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("grade") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.grade}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {/* Shah paper changes */}
//           {/* {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "quality"
//           ) ||
//           orderConfigSettings?.upload_orders?.config?.quality?.visibility ? (
//             <Col style={{ width: "150px" }}>
//               <div
//                 className="boxFormType"
//                 onFocus={() => getAllQualities(index)}
//               >
//                 <Form.Item
//                   label={index == 0 ? "Quality" : ""}
//                   name={`quality${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required: true,
//                       message: "This field is required",
//                     },
//                   ]}
//                   className="dBlock"
//                   initialValue={
//                     ordersToShow[index]?.order?.product_data?.quality
//                   }
//                 >
//                     <Select
//                       options={allQualities}
//                       onChange={(e) =>
//                         handleQualityChange(
//                           ordersToShow[index].order.orderNumber,
//                           e
//                         )
//                       }
//                       suffixIcon={<DownArrowDraw />}
//                       disabled={isDisabled(index, "quality")}
//                     ></Select>
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("quality") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.quality}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )} */}
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty("gsm") ||
//           orderConfigSettings?.upload_orders?.config?.gsm?.visibility ? (
//             <Col style={{ width: "100px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "GSM" : ""}
//                   name={`gsm${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required: true,
//                       message: "This field is required",
//                     }
//                   ]}
//                   className="dBlock"
//                   initialValue={ordersToShow[index]?.order?.product_data?.gsm}
//                 >
//                   <Input
//                     placeholder="Enter GSM"
//                     // value={ordersToShow[index]?.order?.product_data?.gsm}
//                     onChange={(e) =>
//                       onGSMChange(ordersToShow[index].order.orderNumber, e)
//                     }
//                     disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                     // disabled={isDisabled(index, "gsm")}
//                   />
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("gsm") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.gsm}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "bulk"
//           ) || orderConfigSettings?.upload_orders?.config?.bulk?.visibility ? (
//             <Col style={{ width: "100px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "Bulk" : ""}
//                   name={`bulk${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required: true,
//                       message: "This field is required",
//                     }
//                   ]}
//                   className="dBlock"
//                   initialValue={ordersToShow[index]?.order?.product_data?.bulk}
//                 >
//                   <Input
//                     placeholder="Enter Bulk"
//                     // value={ordersToShow[index]?.order?.product_data?.bulk}
//                     onChange={(e) =>
//                     onBulkChange(ordersToShow[index].order.orderNumber,e)
//                   }
//                     disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                     // disabled={isDisabled(index, "bulk")}
//                   />
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("bulk") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.bulk}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {/* shah paper changes
//            {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "burst_factor"
//           ) ||
//           orderConfigSettings?.upload_orders?.config?.burst_factor
//             ?.visibility ? (
//             <Col style={{ width: "120px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "Burst Factor" : ""}
//                   name={`burst_factor${ordersToShow[index].order.orderNumber}`}
//                   rules={[]}
//                   className="dBlock"
//                   initialValue={
//                     ordersToShow[index]?.order?.product_data?.burst_factor ||
//                     "NA"
//                   }
//                 >
//                   <Input
//                     placeholder="Enter Burst Factor"
//                     disabled={isDisabled(index, "burst_factor")}
//                   />
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("burst_factor") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.burst_factor}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "moisture"
//           ) ||
//           orderConfigSettings?.upload_orders?.config?.moisture?.visibility ? (
//             <Col style={{ width: "100px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "Moisture" : ""}
//                   name={`moisture${ordersToShow[index].order.orderNumber}`}
//                   rules={[]}
//                   className="dBlock"
//                   initialValue={
//                     ordersToShow[index]?.order?.product_data?.moisture || "NA"
//                   }
//                 >
//                   <Input
//                     placeholder="Enter Moisture"
//                     disabled={isDisabled(index, "moisture")}
//                   />
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("moisture") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.moisture}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty("ply") ||
//           orderConfigSettings?.upload_orders?.config?.ply?.visibility ? (
//             <Col style={{ width: "100px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "PLY" : ""}
//                   name={`ply${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required:
//                         ordersToShow[index].order.type === "sheet"
//                           ? false
//                           : true,
//                       message: "This field is required",
//                     },
//                   ]}
//                   className="dBlock"
//                   initialValue={ordersToShow[index].order.ply}
//                 >
//                   <Select
//                     placeholder="Select Ply"
//                     suffixIcon={<DownArrowDraw />}
//                     showSearch
//                     optionFilterProp="children"
//                     onChange={() =>
//                       handlePly(ordersToShow[index].order.orderNumber)
//                     }
//                     className="dBlock"
//                     style={{ textTransform: "capitalize" }}
//                     disabled={isDisabled(index, "ply")}
//                   >
//                     {plyData.map((item) => (
//                       <Option key={item.value} value={item.value}>
//                         {item.label}
//                       </Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("ply") ? (
//                 <span
//                   className="errorText"
//                   style={{ color: "#ea4e2c" }}
//                   dangerouslySetInnerHTML={{
//                     __html: ordersToShow[index].errors.ply,
//                   }}
//                 ></span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )} */}
//           {/* <Col style={{ width: "250px" }}>
//                           <div className="boxFormType">
//                             <Form.Item
//                               label={index == 0 ? "Grade/GSM/BF/Quality/Moisture" : ""}
//                               name={`product_spec${ordersToShow[index].order.orderNumber}`}
//                               rules={[
//                                 {
//                                   required: true,
//                                   message: "This field is required",
//                                 }
//                               ]}
//                               className="dBlock"
//                               initialValue={ordersToShow[index].order.product_spec}
//                             >
//                               <Input
//                                 disabled
//                                 placeholder="Grade/GSM/BF/Quality/Moisture"
//                                 style={{ textTransform: "capitalize" }}
//                               />
//                             </Form.Item>
//                           </div>
//                           {ordersToShow[index].errors.hasOwnProperty('product_spec') ? (
//                             <span
//                               className="errorText"
//                               style={{ color: "#ea4e2c" }}
//                             >
//                               {ordersToShow[index].errors.product_spec}
//                             </span>
//                           ) : null}
//                         </Col> */}
//           <Col style={{ width: "150px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Size(WxL)" : ""}
//                 name={`size${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "This field is required",
//                   },
//                   {
//                     validator(_, value) {
//                       if (
//                         ordersToShow[index].order.type === "sheet" &&
//                         /^(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9])x(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9])$/.test(
//                           value
//                         )
//                       ) {
//                         return Promise.resolve();
//                       } else if (
//                         ordersToShow[index].order.type === "reel" &&
//                         /^(?!0+(\.0+)?$)\d+(\.\d+)?$/.test(value)
//                       ) {
//                         return Promise.resolve();
//                       } else {
//                         return Promise.reject("Valid size is required");
//                       }
//                     },
//                   },
//                 ]}
//                 className="dBlock"
//                 initialValue={
//                   ordersToShow[index].order.type === "reel"
//                     ? ordersToShow[index].order.width
//                     : ordersToShow[index].order.width +
//                       "x" +
//                       ordersToShow[index].order.length
//                 }
//               >
//                 <Input
//                   placeholder="Enter size"
//                   onChange={() =>
//                     onSizeChange(ordersToShow[index].order.orderNumber)
//                   }
//                   style={{ textTransform: "capitalize" }}
//                     disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // disabled={isDisabled(index, "width") && isDisabled(index, "length")}
//                 />
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("width") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.width}
//               </span>
//             ) : ordersToShow[index].errors.hasOwnProperty("length") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.length}
//               </span>
//             ) : null}
//           </Col>
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "length_unit"
//           ) ||
//           orderConfigSettings?.upload_orders?.config?.length_unit
//             ?.visibility ? (
//             <Col style={{ width: "90px" }}>
//               <div className="boxFormType">
//                 <Form.Item
//                   label={index == 0 ? "Unit" : ""}
//                   name={`sizeUnit${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required: true,
//                       message: "This field is required",
//                     },
//                   ]}
//                   className="dBlock"
//                   initialValue={ordersToShow[index].order.size_unit}
//                 >
//                   <Select
//                     placeholder="Unit"
//                     suffixIcon={<DownArrowDraw />}
//                     className="dBlock"
//                     // style={{ textTransform: "capitalize" }}
//                     onChange={(e) =>
//                       onSizeUnitChange(ordersToShow[index].order.orderNumber, e)
//                     }
//                     disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                     // disabled={isDisabled(index, "size_unit")}
//                   >
//                     {dimesionUnitList?.map((unit) => (
//                       <Option
//                         key={`${unit}${ordersToShow[index].order.orderNumber}`}
//                         value={unit}
//                       >
//                         {lengthUnit[unit]?.displayName}
//                       </Option>
//                     ))}{" "}
//                     */
//                   </Select>
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("size_unit") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.size_unit}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {isVisible && (
//             <Col style={{ width: "90px" }}>
//               {index == 0 && (
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "row",
//                     padding: "2px 0px 6px 5px",
//                   }}
//                 >
//                   {ordersToShow[index].order.type === "sheet" && (
//                     <div className="mandatorySymbolColumnHeader">*</div>
//                   )}
//                   <div>
//                     <span className="columnHeader">Grain</span>
//                     <Styled style={{ display: "inline-flex" }}>
//                       <Tooltip
//                         placement="bottomRight"
//                         title={"Mandatory for sheet orders."}
//                         className="edit-tooltip"
//                         getPopupContainer={(triggerNode) => triggerNode}
//                       >
//                         <span className="infoIcon"></span>
//                       </Tooltip>
//                     </Styled>
//                   </div>
//                 </div>
//               )}
//               <div className="boxFormType">
//                 <Form.Item
//                   name={`grain${ordersToShow[index].order.orderNumber}`}
//                   rules={
//                     ordersToShow[index].order.type === "sheet" && [
//                       {
//                         required: true,
//                         message: "This field is required",
//                       },
//                     ]
//                   }
//                   className="dBlock"
//                   initialValue={
//                     ordersToShow[index].order.type === "sheet"
//                       ? ordersToShow[index].order.grain
//                       : ""
//                   }
//                 >
//                   <Select
//                     placeholder="Select Grain"
//                     suffixIcon={<DownArrowDraw />}
//                     className="dBlock"
//                     // style={{ textTransform: "capitalize" }}
//                     onChange={(e) =>
//                       onGrainChanges(ordersToShow[index].order.orderNumber, e)
//                     }
//                     disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                     // disabled={isDisabled(index, "grain") || ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   >
//                     {["short", "long"].map((grain) => (
//                       <Option
//                         key={`${grain}${ordersToShow[index].order.orderNumber}`}
//                         value={grain}
//                       >
//                         {grain}
//                       </Option>
//                     ))}{" "}
//                     */
//                   </Select>
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("grain") &&
//               ordersToShow[index].order.type === "sheet" ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.grain}
//                 </span>
//               ) : null}
//             </Col>
//           )}
//           {/* shah paper changes
//           {ordersToShow[index].order.type === "sheet" && (
//             <Col>
//               {index == 0 && (
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "row",
//                     padding: "2px 0px 6px 5px",
//                   }}
//                 >
//                   <span
//                     className="columnHeader"
//                     style={{ verticalAlign: "bottom", display: "contents" }}
//                   >
//                     Grain Settings
//                   </span>
//                 </div>
//               )}
//               <div className="boxFormType">
//                 <Form.Item
//                   name={`grainChanges${ordersToShow[index].order.orderNumber}`}
//                 >
//                   <GlobalSet>
//                     <div
//                       className="checklist-address"
//                       style={{ paddingTop: "0px" }}
//                     >
//                       <Checkbox
//                         type="checkbox"
//                         onChange={(e) =>
//                           onGrainChangesChange(
//                             e,
//                             ordersToShow[index].order.orderNumber
//                           )
//                         }
//                         checked={
//                           ordersToShow[index].order.rotaion ? true : false
//                         }
//                         disabled={
//                           ordersForSelectedPo.data.pos[
//                             location.state.selectedPoIndex
//                           ].isPOSaved
//                             ? true
//                             : ordersToShow[index].order.type === "reel"
//                             ? true
//                             : false
//                         }
//                       />
//                       <p
//                         style={{
//                           fontSize: "14px",
//                           fontStyle: "normal",
//                           lineHeight: "20px",
//                           fontFamily: "var(--sf-pro-text)",
//                           color: "var(--para-text)",
//                           margin: "0",
//                           marginTop: "-7px",
//                         }}
//                       >
//                         Allow grain changes
//                       </p>
//                     </div>
//                   </GlobalSet>
//                 </Form.Item>
//               </div>
//               <div className="boxFormType">
//                 <Form.Item
//                   name={`grainMixing${ordersToShow[index].order.orderNumber}`}
//                 >
//                   <GlobalSet>
//                     <div
//                       className="checklist-address"
//                       style={{ marginTop: "-32px" }}
//                     >
//                       <Checkbox
//                         type="checkbox"
//                         onChange={(e) =>
//                           onGrainMixingChange(
//                             e,
//                             ordersToShow[index].order.orderNumber
//                           )
//                         }
//                         checked={
//                           ordersToShow[index].order.grain_mixing ? true : false
//                         }
//                         disabled={
//                           !defaultMixedGrain ||
//                           (ordersForSelectedPo.data.pos[
//                             location.state.selectedPoIndex
//                           ].isPOSaved
//                             ? true
//                             : ordersToShow[index].order.type === "reel"
//                             ? true
//                             : false)
//                         }
//                       />
//                       <p
//                         style={{
//                           fontSize: "14px",
//                           fontStyle: "normal",
//                           lineHeight: "20px",
//                           fontFamily: "var(--sf-pro-text)",
//                           color: "var(--para-text)",
//                           margin: "0",
//                           marginTop: "-5px",
//                         }}
//                       >
//                         Allow mixed grain
//                       </p>
//                     </div>
//                     {ordersToShow[index].order.type === "sheet" &&
//                       !defaultMixedGrain && (
//                         <p
//                           style={{
//                             fontSize: "13px",
//                             fontStyle: "normal",
//                             lineHeight: "20px",
//                             fontFamily: "var(--sf-pro-text)",
//                             color: "var(--para-text)",
//                             fontStyle: "italic",
//                             marginTop: "-20px",
//                             marginRight: "40px",
//                           }}
//                         >
//                           Disabled in Config
//                         </p>
//                       )}
//                   </GlobalSet>
//                 </Form.Item>
//               </div>
//             </Col>
//           )} */}

//           <Col style={{ width: "140px" }}>
//             {index == 0 && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   padding: "2px 0px 6px 5px",
//                 }}
//               >
//                 <div className="mandatorySymbolColumnHeader">*</div>
//                 <div>
//                   <span className="columnHeader">Order Weight</span>
//                   <Styled style={{ display: "inline-flex" }}>
//                     <Tooltip
//                       placement="bottomRight"
//                       title={
//                         "Either Order weight or quantity should be present. If both are present, order weight will be considered."
//                       }
//                       className="edit-tooltip"
//                       getPopupContainer={(triggerNode) => triggerNode}
//                     >
//                       <span className="infoIcon"></span>
//                     </Tooltip>
//                   </Styled>
//                 </div>
//               </div>
//             )}
//             <div className="boxFormType">
//               <Form.Item
//                 name={`orderWeight${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required:
//                       ordersToShow[index].order.quantity_type == "weight"
//                         ? true
//                         : false,
//                     message: "This field is required",
//                   },
//                   // {
//                   //   pattern: ordersToShow[index].order.quantity_type == "weight" ? (new RegExp(
//                   //     /^\d+(\.\d{0,3})?$/
//                   //   )) : (""),
//                   //   message:
//                   //     "This value should be a non-zero positive value",
//                   // },
//                   // {
//                   //     pattern: ordersToShow[index].order.quantity_type == "weight" ? (new RegExp(
//                   //     /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
//                   //     )) : (""),
//                   //     message:
//                   //     "Weight should be a number greater than zero",
//                   // },
//                 ]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index].order.weight}
//               >
//                 <Input
//                   placeholder="Enter weight"
//                   onChange={() =>
//                     onOrderWeightChange(ordersToShow[index].order.orderNumber)
//                   }
//                   style={{ textTransform: "capitalize" }}
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // disabled={isDisabled(index,"weight")}
//                 />
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("weight") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.weight}
//               </span>
//             ) : null}
//           </Col>
//           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
//             "weight_unit"
//           ) ||
//           orderConfigSettings?.upload_orders?.config?.weight_unit
//             ?.visibility ? (
//             <Col style={{ width: "140px" }}>
//               <div className="boxFormType unitSelect">
//                 <Form.Item
//                   label={index == 0 ? "Unit" : ""}
//                   name={`orderWeightUnit${ordersToShow[index].order.orderNumber}`}
//                   rules={[
//                     {
//                       required:
//                         !ordersToShow[index].order.weight &&
//                         !ordersToShow[index].order.no_of_reel_sheet
//                           ? true
//                           : ordersToShow[index].order.weight
//                           ? true
//                           : false,
//                       message: "This field is required",
//                     },
//                   ]}
//                   className="dBlock"
//                   initialValue={ordersToShow[index].order.weight_unit}
//                 >
//                   <Select
//                     placeholder="Unit"
//                     suffixIcon={<DownArrowDraw />}
//                     className="dBlock"
//                     style={{ textTransform: "capitalize" }}
//                     onChange={() =>
//                       onOrderWeightUnitChange(
//                         ordersToShow[index].order.orderNumber
//                       )
//                     }
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                     // disabled={isDisabled(index,"weight_unit")}
//                   >
//                     {weightUnitList?.map((unit) => (
//                       <Option
//                         key={`${unit}${ordersToShow[index].order.orderNumber}`}
//                         value={unit}
//                       >
//                         {capitalize(weightUnit[unit]?.displayName)}
//                       </Option>
//                     ))}{" "}
//                     */
//                   </Select>
//                 </Form.Item>
//               </div>
//               {ordersToShow[index].errors.hasOwnProperty("weight_unit") ? (
//                 <span className="errorText" style={{ color: "#ea4e2c" }}>
//                   {ordersToShow[index].errors.weight_unit}
//                 </span>
//               ) : null}
//             </Col>
//           ) : (
//             <></>
//           )}
//           {/* shah paper changes
//           <Col style={{ width: "140px" }}>
//             {index == 0 && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   padding: "2px 0px 6px 5px",
//                 }}
//               >
//                 <div className="mandatorySymbolColumnHeader">*</div>
//                 <div>
//                   <span className="columnHeader">Quantity</span>
//                   <Styled style={{ display: "inline-flex" }}>
//                     <Tooltip
//                       placement="bottomRight"
//                       title={
//                         "It represents number of reel or sheets. Either order weight or quantity should be present. If both are present, order weight will be considered."
//                       }
//                       className="edit-tooltip"
//                       getPopupContainer={(triggerNode) => triggerNode}
//                     >
//                       <span className="infoIcon"></span>
//                     </Tooltip>
//                   </Styled>
//                 </div>
//               </div>
//             )}
//             <div className="boxFormType">
//               <Form.Item
//                 name={`quantity${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "This field is required",
//                   },
//                 ]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index].order.no_of_reel_sheet}
//               >
//                 <Input
//                   placeholder={savedState ? "Enter quantity" : ""}
//                   onChange={() =>
//                     onQuantityChange(ordersToShow[index].order.orderNumber)
//                   }
//                   // style={{ textTransform: "capitalize" }}
//                   disabled={isDisabled(index,"no_of_reel_sheet")}
//                 />
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("no_of_reel_sheet") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.no_of_reel_sheet}
//               </span>
//             ) : null}
//           </Col> */}
//           {/* shah paper changes
//            <Col style={{ width: "150px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Order State" : ""}
//                 name={`state${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "This field is required",
//                   },
//                 ]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index]?.order?.state}
//               >
//                   <Select
//                     placeholder="Order State"
//                     options={[
//                       { label: "Active", value: "approved" },
//                       { label: "Produced", value: "complete" },
//                     ]}
//                     suffixIcon={<DownArrowDraw />}
//                     value={ordersToShow[index]?.order?.state}
//                     disabled={isDisabled(index,"state")}
//                   />
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("state") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.state}
//               </span>
//             ) : null}
//           </Col> */}
//           <Col style={{ width: "150px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Balance Quantity" : ""}
//                 name={`balance_quantity${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "This field is required",
//                   },
//                 ]}
//                 className="dBlock"
//                 initialValue={ordersToShow[index]?.order?.balance_weight}
//               >
//                 <Input
//                   placeholder="Enter Balance Quantity"
//                   value={ordersToShow[index]?.order?.balance_weight}
//                   onChange={(e) =>
//                       onBalanceQtyChange(ordersToShow[index].order.orderNumber, e)
//                   }
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // disabled={isDisabled(index,"balance_weight")}
//                 />
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("balance_weight") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.balance_weight}
//               </span>
//             ) : null}
//           </Col>
//           {/* Shah paper changes */}
//           <Col style={{ width: "260px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Reel OD" : ""}
//                 className="dBlock"
//                 name={`reel_OD${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     validator: (_, value) => {
//                       const coreODFieldValue = form.getFieldValue(`core_OD${ordersToShow[index].order.orderNumber}`);

//                       if (!value?.trim() || !coreODFieldValue?.trim()) return Promise.resolve();

//                       const coreParts = String(coreODFieldValue).trim().split(/\s+/);
//                       const reelParts = String(value).trim().split(/\s+/);

//                       let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
//                       let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

//                       let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
//                       let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

//                       if (coreVal > reelVal) {
//                         return Promise.reject(new Error("Core OD should be less than Reel OD"));
//                       }

//                       return Promise.resolve();
//                     }
//                   }
//                 ]}
//                 initialValue={(ordersToShow[index]?.order?.reel_od ? ordersToShow[index]?.order?.reel_od : "") + " " + (ordersToShow[index]?.order?.reel_od ? ordersToShow[index]?.order?.reel_od_unit : "")}
//               >
//                 <Select
//                   placeholder="Select Reel OD"
//                   suffixIcon={<DownArrowDraw />}
//                   showSearch
//                   optionFilterProp="children"
//                   className="dBlock"
//                   onChange={(value) => {
//                     form.setFieldsValue({
//                       [`reel_OD${ordersToShow[index].order.orderNumber}`]: value,
//                     });

//                     const coreValue = form.getFieldValue(`core_OD${ordersToShow[index].order.orderNumber}`);

//                     onReelODChange(ordersToShow[index].order.orderNumber, value)

//                     if (!value || !coreValue) return;

//                     const coreParts = String(coreValue).trim().split(/\s+/);
//                     const reelParts = String(value).trim().split(/\s+/);

//                     let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
//                     let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

//                     let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
//                     let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

//                     if (coreVal <= reelVal) {
//                       form.setFields([
//                         { name: `core_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
//                         { name: `reel_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
//                       ]);
//                     }
//                   }}
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // style={{ width: "331px" }}
//                   // disabled={
//                   //   // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
//                   //   // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
//                   //   props?.actionType == "view"
//                   // }
//                 >
//                   {reelvalues?.map((data) => (
//                     <Option key={data.value}>{data.value}</Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("reel_od") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.reel_od}
//               </span>
//             ) : null}
//           </Col>
//           <Col style={{ width: "260px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Core ID" : ""}
//                 name={`core_OD${ordersToShow[index].order.orderNumber}`}
//                 rules={[
//                   {
//                     validator: (_, value) => {
//                       const reelODFieldValue = form.getFieldValue(`reel_OD${ordersToShow[index].order.orderNumber}`);

//                       if (!value?.trim() || !reelODFieldValue?.trim()) return Promise.resolve();

//                       const coreParts = String(value).trim().split(/\s+/);
//                       const reelParts = String(reelODFieldValue).trim().split(/\s+/);

//                       let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
//                       let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

//                       let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
//                       let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

//                       if (coreVal > reelVal) {
//                         return Promise.reject(new Error("Core OD should be less than Reel OD"));
//                       }

//                       return Promise.resolve();
//                     }
//                   }
//                 ]}
//                 className="dBlock"
//                 initialValue={(ordersToShow[index]?.order?.core_id ? ordersToShow[index]?.order?.core_id : "") + " " + (ordersToShow[index]?.order?.core_id ? ordersToShow[index]?.order?.core_id_unit : "")}
//               >
//                 <Select
//                   placeholder="Select Core OD"
//                   suffixIcon={<DownArrowDraw />}
//                   showSearch
//                   optionFilterProp="children"
//                   onChange={(value) => {
//                     form.setFieldsValue({
//                       [`core_OD${ordersToShow[index].order.orderNumber}`]: value,
//                     });

//                     const reelValue = form.getFieldValue(`reel_OD${ordersToShow[index].order.orderNumber}`);

//                     onCoreODChange(ordersToShow[index].order.orderNumber, value)

//                     if (!value || !reelValue) return;

//                     const coreParts = String(value).trim().split(/\s+/);
//                     const reelParts = String(reelValue).trim().split(/\s+/);

//                     let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
//                     let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

//                     let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
//                     let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

//                     // ✅ VALID → CLEAR ERRORS
//                     if (coreVal <= reelVal) {
//                       form.setFields([
//                         { name: `core_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
//                         { name: `reel_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
//                       ]);
//                     }
//                   }}
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // style={{ width: "331px" }}
//                   // disabled={
//                   //   // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
//                   //   // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
//                   //   props?.actionType == "view"
//                   // }
//                 >
//                   {corevalues?.map((data) => (
//                     <Option key={data.value}>{data.value}</Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </div>
//             {ordersToShow[index].errors.hasOwnProperty("core_id") ? (
//               <span className="errorText" style={{ color: "#ea4e2c" }}>
//                 {ordersToShow[index].errors.core_id}
//               </span>
//             ) : null}
//           </Col>
//           <Col style={{ width: "260px" }}>
//             <div className="boxFormType">
//               <Form.Item
//                 label={index == 0 ? "Remarks" : ""}
//                 name={`remark${ordersToShow[index].order.orderNumber}`}
//                 className="dBlock"
//                 initialValue={ordersToShow[index].order.remarks}
//               >
//                 <Input
//                   placeholder="Enter Remark"
//                   onChange={(e) =>
//                     onRemarkChange(ordersToShow[index].order.orderNumber, e)
//                   }
//                   disabled={ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
//                   // style={{ textTransform: "capitalize" }}
//                   // disabled={
//                   //   ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//                   //     .isPOSaved
//                   //     ? true
//                   //     : false
//                   // }
//                 />
//               </Form.Item>
//             </div>
//           </Col>
//           {setRowCount()}
//         </Row>
//       </div>
//     );

//   return filteredOrders ? (
//     <RightLayoutContainer>
//       <PageTitleComp
//         className="marginRightAdg"
//         style={{ marginBottom: "12px" }}
//       >
//         <PageHeader
//           title="Uploaded Summary"
//           extra={[
//             <Button
//               key="3"
//               className="themeBtn noBg"
//               loading={gobackLoading}
//               onClick={() => goBack()}
//               disabled={loadings}
//             >
//               {!gobackLoading && (
//                 <Iconmoon icon="left-to-thin" size={14} color="#EA655B" />
//               )}
//               {!gobackLoading ? "Go Back" : ""}
//             </Button>,
//             <Button
//               key="1"
//               className="themeBtn"
//               onClick={() => saveDetails()}
//               loading={loadings}
//               disabled={checkSaveDisabled()}
//               // disabled={
//               //   savedState ||
//               //   !products?.length ||
//               //   (!ordersForSelectedPo &&
//               //     Object.keys(
//               //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//               //         .orders
//               //     ).length != 0) ||
//               //   (ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//               //     .error_count != 0 &&
//               //     Object.keys(
//               //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//               //         .errors
//               //     ).length != 0) ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .delivery_address_line_1 ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .delivery_state ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .delivery_city ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .delivery_pincode ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .delivery_country ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .shipping_address_line_1 ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .shipping_state ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .shipping_city ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .shipping_pincode ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .shipping_country ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .billing_address_line_1 ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .billing_state ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .billing_city ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .billing_pincode ||
//               //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               //     .billing_country ||
//               //   (ordersForSelectedPo.data.pos[
//               //     location.state.selectedPoIndex
//               //   ].orders.filter((e) => e.error_count > 0).length == 0
//               //     ? ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//               //         .isPOSaved
//               //       ? true
//               //       : false
//               //     : true) ||
//               //   resendAppOtherButtonLoading
//               // }
//             >
//               {!loadings && (
//                 <Iconmoon icon="addcircle" size={14} color="#ffffff" />
//               )}
//               {!loadings ? "Save Details" : ""}
//             </Button>,
//             // <Button
//             //   key="2"
//             //   className="themeBtn"
//             //   onClick={() => saveDetails("pending")}
//             //   loading={resendAppLoading}
//             //   disabled={
//             //     savedState ||
//             //     !products?.length ||
//             //     (ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//             //       .error_count == 0 &&
//             //     Object.keys(
//             //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//             //         .errors
//             //     ).length == 0 &&
//             //     ordersForSelectedPo.data.pos[
//             //       location.state.selectedPoIndex
//             //     ].orders.filter((e) => e.error_count > 0).length == 0
//             //       ? ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
//             //           .isPOSaved
//             //         ? true
//             //         : false
//             //       : true) ||
//             //     otherButtonLoading
//             //   }
//             // >
//             //   {!resendAppLoading && (
//             //     <Iconmoon icon="addcircle" size={14} color="#ffffff" />
//             //   )}
//             //   {!resendAppLoading ? "Save & Send for Approval" : ""}
//             // </Button>,
//           ]}
//         ></PageHeader>
//       </PageTitleComp>

//       <div
//         className="showPriorityOrder"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginBottom: "10px",
//         }}
//       >
//         <div
//           style={{
//             marginTop: "10px",
//             fontSize: "14px",
//             fontFamily: "var(--sf-pro-display)",
//             lineHeight: "16px",
//           }}
//         >
//           {location.state.isSOOrders ? "SO" : "PO"}:{" "}
//           {
//             ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
//               .number
//           }
//         </div>
//         <div style={{ display: "flex", flexDirection: "row" }}>
//           <div>
//             <DisabledButtonStyle style={{ displayFlex: "end" }}>
//               <Button
//                 className={
//                   show
//                     ? "themeBtn noBg approveAllOrders"
//                     : "themeBtn noBg disabledstyle approve-header"
//                 }
//                 onClick={() => {
//                   setShow(!show);
//                   filterRecords(!show);
//                   rowCount.current = false;
//                 }}
//               >
//                 <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
//                 {show ? "Show All Orders" : "Show Only Failed Orders"}
//               </Button>
//             </DisabledButtonStyle>
//           </div>
//           <div
//             style={{
//               marginTop: "10px",
//               marginRight: "15px",
//               fontSize: "14px",
//               fontFamily: "var(--sf-pro-display)",
//               lineHeight: "16px",
//             }}
//           >
//             Failed Orders:{" "}
//             {
//               ordersForSelectedPo.data.pos[
//                 location.state.selectedPoIndex
//               ].orders.filter((e) => e.error_count > 0).length
//             }
//           </div>
//           <div
//             style={{
//               marginTop: "10px",
//               fontSize: "14px",
//               fontFamily: "var(--sf-pro-display)",
//               lineHeight: "16px",
//             }}
//           >
//             Verified Orders:{" "}
//             {
//               ordersForSelectedPo.data.pos[
//                 location.state.selectedPoIndex
//               ].orders.filter((e) => e.error_count == 0).length
//             }
//           </div>
//         </div>
//       </div>
//       <OrderSummary>
//         <div
//           className="orderSummaryStyle"
//           style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
//         >
//           <div style={{ maxWidth: "410px", marginRight: "1%" }}>
//             <span
//               className="orderWeightStyle"
//               style={{ textAlign: "left", fontStyle: "italic" }}
//             >
//               Note: The default tolerance +{upperTolerance} to -{lowerTolerance}{" "}
//               defined in settings will be used to set tolerance values for
//               orders
//             </span>
//           </div>
//         </div>
//       </OrderSummary>
//       <DetailFields>
//         <HaberForm>
//           <div className="groupDetailWrap">
//             <Form
//               form={form}
//               name="basic"
//               autoComplete="off"
//               className="haberLogin"
//               onFinish={onFinish}
//             >
//               <div
//                 style={{
//                   overflow: "auto",
//                   width: window.screen.width < 1500 ? "103.5%" : "102%",
//                   height: window.screen.width > 1400 ? "600px" : "400px",
//                 }}
//               >
//                 <AutoSizer>
//                   {({ height, width }) => (
//                     <FixedSizeList
//                       height={height}
//                       itemCount={ordersToShow?.length}
//                       itemSize={120}
//                       width={width}
//                       overscanCount={2}
//                       onScroll={handleScroll}
//                       itemKey={(index) => ordersToShow[index].order.orderNumber}
//                     >
//                       {RowData}
//                     </FixedSizeList>
//                   )}
//                 </AutoSizer>
//                 {loading && (
//                   <div style={{ position: "relative" }}>
//                     <div style={{ marginTop: "33%", marginLeft: "2%" }}>
//                       {"Loading..."}
//                     </div>
//                   </div>
//                 )}
//                 {/* <Pagination
//                     total={filteredOrders?.length}
//                     showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} results`}
//                     defaultPageSize={25}
//                     defaultCurrent={currentPage}
//                     onChange={onPageChange}
//                     showSizeChanger={false}
//                   /> */}
//               </div>
//             </Form>
//           </div>
//         </HaberForm>
//       </DetailFields>
//       {/* Toasters */}

//       {visibleToaster && !actionToaster.error && (
//         <AlertContainer
//           color="green toaster"
//           icon={alertGreen}
//           msg={actionToaster.msg}
//         />
//       )}
//       {visibleToaster && actionToaster.error && (
//         <AlertContainer
//           color="red toaster"
//           icon={alertRed}
//           msg={actionToaster.msg}
//         />
//       )}
//       {productDrawerVisible && (
//         <AddProductDrawer
//           closeProductDrawer={closeProductDrawer}
//           productDrawer={productDrawerVisible}
//           setNewProductData={setNewProductData}
//           selectedRecord={{
//             quality:
//               ordersToShow[selectedOrderIndex]?.order?.product_data?.quality,
//             grade: ordersToShow[selectedOrderIndex]?.order?.product_data?.grade,
//             gsm: ordersToShow[selectedOrderIndex]?.order?.product_data?.gsm,
//             burst_factor:
//               ordersToShow[selectedOrderIndex]?.order?.product_data
//                 ?.burst_factor,
//             bulk: ordersToShow[selectedOrderIndex]?.order?.product_data?.bulk,
//             ply: ordersToShow[selectedOrderIndex]?.order?.ply,
//             moisture:
//               ordersToShow[selectedOrderIndex]?.order?.product_data?.moisture,
//             type: ordersToShow[selectedOrderIndex]?.order?.type,
//             productName: `${
//               ordersToShow[selectedOrderIndex]?.order?.product_data?.quality +
//               "-" +
//               ordersToShow[selectedOrderIndex]?.order?.product_data?.gsm +
//               "-" +
//               ordersToShow[selectedOrderIndex]?.order?.product_data
//                 ?.burst_factor +
//               "-" +
//                 Number(
//                   parseFloat(ordersToShow[
//                     selectedOrderIndex
//                   ]?.order?.product_data?.bulk)?.toFixed(2)
//                 )
//             }`,
//           }}
//         />
//       )}
//     </RightLayoutContainer>
//   ) : null;
// };
// export default UploadedPoOrders;


import { React, useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
  TableLayoutData,
  // PaginationStyle
} from "../../styledElements";
import {
  Styled,
  DatePickerY,
  DisabledButtonStyle,
  GlobalSet,
} from "../../pageStyled";
import { DatePicker } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tooltip,
  Pagination,
} from "antd";
import { HaberForm } from "../../styledElements";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
import {
  getProductDetails,
  getProductsData,
} from "../../../Services/productServices";
import {
  saveUploadedOrders,
  getPackagingList,
} from "../../../Services/orderServices";
import {
  getAllGradesForConfig,
  getGradeQualitiesForConfig,
  getJobCardSerialNumberParam,
  getMachineGradeSelect,
  getReelCoreValues,
} from "../../../Services/settingsServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import moment from "moment";
import {
  calculatePlannedReels,
  calculatePlannedWeight,
  plannedReelsCalculations
} from "../../../Utils/helper/calculatePlannedWeight";
import styled from "styled-components";
import { VariableSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { getUnitData } from "../../../Services/measurementService";
import {
  lengthUnit,
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
} from "../../../Utils/Constant/MeasurementUnitList";
import AddProductDrawer from "../ConflictingOrders/AddProductDrawer";
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const UploadedPoOrders = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const { height, width } = useWindowDimensions();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [ordersForSelectedPo, setOrdersForSelectedPo] = useState(
    location.state.uploadedData
  );
  const [filteredOrders, setFilteredOrders] = useState(
    location.state.uploadedData.data.pos[location.state.selectedPoIndex].orders
  );
  const [ordersToShow, setOrdersToShow] = useState();
  const [poDataToSave, setPoDataToSave] = useState();
  const [orderWeightUnit, setOrderWeightUnit] = useState("");
  const [rerendering, setRerendering] = useState(false);
  const [products, setProducts] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [savedState, setSavedState] = useState(false);
  const [isProductDropdownOpen, setProductDropdown] = useState(false);
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [show, setShow] = useState(false);
  const [defaultMixedGrain, setDefaultMixedGrain] = useState(false);
  const [upperTolerance, setUpperTol] = useState("");
  const [lowerTolerance, setLowerTol] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [dimesionUnitList, setDimesionUnitList] = useState([]);
  const [measurementData, setMeasurementData] = useState();
  const [weightUnitList, setWeightUnitList] = useState([]);
  const [currencyUnitData, setCurrencyUnitData] = useState([]);
  const [reelPackagingData, setReelPackagingData] = useState([]);
  const [sheetPackagingData, setSheetPackagingData] = useState([]);
  const [otherButtonLoading, setOtherButtonLoadingLoadings] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [resendAppLoading, setResendApprovalLoading] = useState(false);
  const [resendAppOtherButtonLoading, setResendAppOtherButtonLoading] =
    useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [gobackLoading, setGobackLoading] = useState(false);
  const listRef = useRef(null);
  const rowSizesRef = useRef({});
  const rowObserversRef = useRef({});

  const [productDrawerVisible, setProductDrawerVisible] = useState(false);
  const [allGrades, setAllGrades] = useState([]);
  const [allQualities, setAllQualities] = useState([]);
  const [orderConfigSettings, setOrderConfigSettings] = useState(null);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState();
  const [reelvalues,setReelvalues] = useState([]);
  const [corevalues,setCoreValues] = useState([]);
  const [productSpecFormat, setProductSpecFormat] = useState("");

  const [plyData, setPlyData] = useState([
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
  ]);

  const OrderSummary = styled.div`
  .orderSummaryStyle {
    display: block;
    padding-bottom: 16px;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    color: black;
    font-style: italic,
    line-height: 16px;
  }
  .orderWeightStyle {
    margin-right: -10px;
  }
`;
  const rowCount = useRef(false);
  const gsmMatchTimeoutRef = useRef({});
  const bulkMatchTimeoutRef = useRef({});
  const ordersForSelectedPoRef = useRef(ordersForSelectedPo);
  const productsRef = useRef(products);
  const productSpecFormatRef = useRef(productSpecFormat);
  const allGradesRef = useRef(allGrades);

  const getItemSize = useCallback(
    (index) => rowSizesRef.current[index] || (index === 0 ? 140 : 80),
    [],
  );

  const registerRow = useCallback((index, node) => {
    rowObserversRef.current[index]?.disconnect();
    delete rowObserversRef.current[index];

    if (!node) return;

    const row = node.querySelector(".measured-row-content");
    if (!row) return;

    const updateRowSize = () => {
      const nextSize = Math.ceil(row.getBoundingClientRect().height) + 12;

      if (nextSize > 12 && rowSizesRef.current[index] !== nextSize) {
        rowSizesRef.current[index] = nextSize;
        listRef.current?.resetAfterIndex(index, true);
      }
    };

    updateRowSize();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(updateRowSize);
      observer.observe(row);
      rowObserversRef.current[index] = observer;
    }
  }, []);

  useEffect(() => {
    rowSizesRef.current = {};
    listRef.current?.resetAfterIndex(0, true);
  }, [ordersToShow]);

  useEffect(
    () => () => {
      Object.values(rowObserversRef.current).forEach((observer) =>
        observer.disconnect(),
      );
    },
    [],
  );

  useEffect(() => {
    ordersForSelectedPoRef.current = ordersForSelectedPo;
  }, [ordersForSelectedPo]);

  useEffect(() => {
    productsRef.current = products;
  }, [products]);

  useEffect(() => {
    productSpecFormatRef.current = productSpecFormat;
  }, [productSpecFormat]);

  useEffect(() => {
    allGradesRef.current = allGrades;
  }, [allGrades]);

  const OnProductToggleSelect = () => {
    setProductDropdown((prevState) => !prevState);
  };

  const onFinish = async () => {
    // let dataToSave = poDataToSave.data;
    // try {
    //   const response = await getReelCoreValues();
    //   if (!response.error) {
    //     for (let index = 0; index < dataToSave.pos[0].orders.length; index++) {
    //       let order = dataToSave.pos[0].orders[index].order;
    //       order["category"] = dataToSave.pos[0].po["po/so"];
    //       let productNo = order.product.split(" -");
    //       if (
    //         dataToSave.pos[0].po["po/so"] === "so" &&
    //         dataToSave.pos[0].po.number
    //       ) {
    //         dataToSave.pos[0].po["reference_number"] =
    //           dataToSave.pos[0].po.number;
    //       }
    //       else{
    //         dataToSave.pos[index].po.number =`${dataToSave.pos[index].po.number}#%#${dataToSave.pos[index].po.customer?.split(" - ")[0] ?? ''}`;
    //       }
    //       if (dataToSave.pos[0].po["po/so"] === "so") {
    //         order.po = "";
    //         order.delivery_date = null;
    //       }
    //       else{
    //         order.po = dataToSave.pos[index].po.number;
    //         // order.delivery_date = dataToSave.pos[index].po.delivery_date;
    //       }
    //       // await getProductDetails(productNo[0]).then((productResp) => {
    //       let productResp = products?.filter(
    //         (ele) => productNo[0] === ele.code
    //       );
    //       let coreIdUnit;
    //       let reelOdUnit;
    //       if (
    //         order.type === "reel" &&
    //         response.default_reel_od &&
    //         response.default_core_id
    //       ) {
    //         if (order.type === "reel") {
    //           let widthData = (
    //             order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
    //           ).toFixed(3);
    //           let diaArr = [];
    //           order.reel_od = response.default_reel_od
    //             ? response.default_reel_od
    //             : 0;
    //           order.core_id = response.default_core_id
    //             ? response.default_core_id
    //             : 0;

    //           // let productNo = order.product.split(" -");
    //           // await getProductDetails(productNo[0]).then((productResp) => {
    //           if (
    //             (order.outer_dia?.length && order.inner_dia) ||
    //             (order.outer_dia?.length &&
    //               (order.inner_dia == 0 || order.inner_dia == ""))
    //           ) {
    //             coreIdUnit = response.default_reel_unit;
    //             reelOdUnit = response.default_reel_unit;
    //           } else if (order.outer_dia?.length == 0 && order.inner_dia) {
    //             coreIdUnit = response.default_core_unit;
    //             reelOdUnit = response.default_core_unit;
    //           } else if (
    //             order.outer_dia?.length == 0 &&
    //             (order.inner_dia == 0 || order.inner_dia == "")
    //           ) {
    //             coreIdUnit =
    //               measurementData.data.units_management.length.default;
    //             reelOdUnit =
    //               measurementData.data.units_management.length.default;
    //           }

    //           let outerDiaArr = [];
    //           outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
    //           order.outer_dia = response.default_reel_od ? outerDiaArr : diaArr;
    //           order.inner_dia = response.default_core_id
    //             ? response.default_core_id + " " + coreIdUnit
    //             : "";

    //           if (
    //             order.type === "reel" &&
    //             order.quantity_type === "reel_sheet" &&
    //             order.no_of_reel_sheet
    //           ) {
    //             order.quantity = order.no_of_reel_sheet;
    //             order.weight_unit =
    //               measurementData.data.units_management.weight.default;
    //             order["planning_quantity"] = order.no_of_reel_sheet;
    //           } else {
    //             let plannedReels = calculatePlannedReels(
    //               parseFloat(widthData),
    //               order.weight * weight_Unit_Conversions[order.weight_unit],
    //               productResp[0].bulk,
    //               order.outer_dia[0]?.split(" ")[0] *
    //                 orderDim_Rewinder_Unit_Conversion[reelOdUnit],
    //               order.inner_dia?.split(" ")[0] *
    //                 orderDim_Rewinder_Unit_Conversion[coreIdUnit]
    //             );
    //             order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
    //               ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
    //               : 1;
    //             order["planning_weight"] = order.weight;
    //           }
    //           let planned_weight = calculatePlannedWeight(
    //             parseFloat(widthData),
    //             productResp[0].bulk,
    //             order.outer_dia[0]?.split(" ")[0] *
    //               orderDim_Rewinder_Unit_Conversion[reelOdUnit],
    //             order.inner_dia?.split(" ")[0] *
    //               orderDim_Rewinder_Unit_Conversion[coreIdUnit],
    //             order.quantity
    //           );
    //           let plannedWt =
    //             planned_weight *
    //             conversionFactorTonneToUnits[order.weight_unit];
    //           order.planned_weight = plannedWt
    //             ? parseFloat(plannedWt).toFixed(3)
    //             : 0;

    //           let plannedWtConversion;
    //           if (
    //             productResp[0]?.units.per_weight_unit.toLowerCase() !==
    //             order?.per_weight_unit.toLowerCase()
    //           ) {
    //             order.per_weight_unit = productResp[0]?.units.per_weight_unit;
    //           }
    //           // if(order?.weight_unit?.toLowerCase() !== order?.per_weight_unit?.toLowerCase()){
    //           //   let unitToTonneConv = order.planned_weight * weight_Unit_Conversions[order?.weight_unit];
    //           //   plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[order?.per_weight_unit];
    //           // } else{
    //           //     plannedWtConversion  = order.planned_weight;
    //           // }
    //           // const netPrice = parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
    //           //       ? parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
    //           //       : "";
    //           let netPrice;
    //           if (order.quantity_type == "weight") {
    //             netPrice =
    //               parseFloat(order.dealer_price) *
    //               parseFloat(order.weight)?.toFixed(3);
    //           }
    //           order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
    //           order.quantity = Math.round(order.quantity);
    //         }
    //       } else if (order.type === "sheet") {
    //         let widthData = (
    //           order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
    //         ).toFixed(3);
    //         let lengthData = (
    //           order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
    //         ).toFixed(3);

    //         if (
    //           order.outer_dia?.length == 0 &&
    //           (order.inner_dia == 0 || order.inner_dia == "")
    //         ) {
    //           if (order.quantity_type === "reel_sheet") {
    //             let widthValue = parseFloat(widthData);
    //             let lengthValue = parseFloat(lengthData);
    //             order.weight_unit =
    //               measurementData.data.units_management.weight.default;
    //             const plannedWeight =
    //               (lengthValue *
    //                 widthValue *
    //                 order.no_of_reel_sheet *
    //                 productResp[0].gsm) /
    //               (10000 * 1000000);
    //             let plannedWt =
    //               plannedWeight *
    //               conversionFactorTonneToUnits[order.weight_unit];
    //             order.planned_weight = plannedWt?.toFixed(3);
    //             order["planning_quantity"] = order.no_of_reel_sheet;
    //             // if(order.planned_weight){
    //             //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
    //             //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
    //             //   // order.lower_tolerance = lowerTolerance;
    //             //   // order.upper_tolerance = upperTolerance;
    //             //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
    //             //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
    //             // }else{
    //             //   // order.lower_tolerance = lowerTolerance;
    //             //   // order.upper_tolerance = upperTolerance;
    //             //   // order.calculated_lower_tolerance = parseFloat(order.calculated_lower_tolerance)?.toFixed(3);
    //             //   // order.calculated_upper_tolerance = parseFloat(order.calculated_upper_tolerance)?.toFixed(3);
    //             // }
    //           } else {
    //             order.weight = order.weight?.toFixed(3);
    //             order.planned_weight = order.weight;
    //             order["planning_weight"] = order.weight;
    //             // if(order.planned_weight){
    //             //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
    //             //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
    //             //   order.lower_tolerance = lowerTolerance;
    //             //   order.upper_tolerance = upperTolerance;
    //             //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
    //             //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
    //             // }else{
    //             //   order.lower_tolerance = lowerTolerance;
    //             //   order.upper_tolerance = upperTolerance;
    //             //   // order.calculated_lower_tolerance = order.calculated_lower_tolerance?.toFixed(3);
    //             //   // order.calculated_upper_tolerance = order.calculated_upper_tolerance?.toFixed(3);
    //             // }
    //             delete order.no_of_reel_sheet;
    //           }
    //           let plannedWtConversion;
    //           if (
    //             productResp[0]?.units.per_weight_unit.toLowerCase() !==
    //             order?.per_weight_unit.toLowerCase()
    //           ) {
    //             order.per_weight_unit = productResp[0]?.units.per_weight_unit;
    //           }
    //           if (
    //             order?.weight_unit?.toLowerCase() !==
    //             order?.per_weight_unit?.toLowerCase()
    //           ) {
    //             let unitToTonneConv =
    //               order.planned_weight *
    //               weight_Unit_Conversions[order?.weight_unit];
    //             plannedWtConversion =
    //               unitToTonneConv *
    //               conversionFactorTonneToUnits[order?.per_weight_unit];
    //           } else {
    //             plannedWtConversion = order.planned_weight;
    //           }
    //           const netPrice =
    //             parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
    //               ? parseFloat(order.dealer_price) *
    //                 parseFloat(plannedWtConversion)
    //               : "";
    //           order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
    //         }
    //         order.quantity = Math.round(order.quantity);
    //       } else if (
    //         order.type === "reel" &&
    //         (!response.default_reel_od || !response.default_core_id)
    //       ) {
    //         if (order.type === "reel" && order.quantity_type === "reel_sheet") {
    //           order.quantity = order.no_of_reel_sheet;
    //           order.weight_unit =
    //             measurementData.data.units_management.weight.default;
    //           order["planning_quantity"] = order.no_of_reel_sheet;
    //         } else {
    //           order.quantity = 0;
    //           order["planning_weight"] = order.weight;
    //         }
    //       }

    //       if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
    //         order["planned_sheets"] = order.no_of_reel_sheet;
    //       }

    //       if (order.quantity_type === "weight") {
    //         let calculated_lower_tolerance = 0;
    //         let calculated_upper_tolerance = 0;
    //         if (order.weight) {
    //           let upperTol =
    //             (parseFloat(order.weight)?.toFixed(3) *
    //               (100 + parseFloat(upperTolerance))) /
    //             100;
    //           let lowerTol =
    //             (parseFloat(order.weight)?.toFixed(3) *
    //               (100 - parseFloat(lowerTolerance))) /
    //             100;
    //           calculated_lower_tolerance = lowerTol.toFixed(3);
    //           calculated_upper_tolerance = upperTol.toFixed(3);
    //         }
    //         order["tolerances"] = {
    //           weight: {
    //             upper_tolerance: parseFloat(upperTolerance),
    //             lower_tolerance: parseFloat(lowerTolerance),
    //             calculated_lower_tolerance: parseFloat(
    //               calculated_lower_tolerance
    //             ),
    //             calculated_upper_tolerance: parseFloat(
    //               calculated_upper_tolerance
    //             ),
    //             units: order.weight_unit
    //               ? order.weight_unit
    //               : measurementData.data.units_management.weight.default,
    //           },
    //         };
    //       } else {
    //         order["tolerances"] = {};
    //       }

    //       order["packaging_details"] = order.packaging_details.id;
    //       order["ply"] = parseFloat(order.ply);
    //       order.units = {
    //         weight: order.weight_unit
    //           ? order.weight_unit
    //           : measurementData.data.units_management.weight.default,
    //         ...(order.type === "sheet" && { length: order.size_unit }),
    //         width: order.size_unit,
    //         planned_weight:
    //           order.quantity_type === "reel_sheet"
    //             ? measurementData.data.units_management.weight.default
    //             : order.weight_unit,
    //         // ...order.type === "sheet" && {calculated_upper_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
    //         // ...order.type === "sheet" && {calculated_lower_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
    //         // core_id: order.type === "sheet" ? measurementData?.data.units_management.length.default : coreIdUnit,
    //         // reel_od: order.type === "sheet" ? measurementData?.data.units_management.length.default : reelOdUnit,
    //         dealer_price: order.currency,
    //         customer_price: order.currency,
    //         net_price: order.currency,
    //         per_weight_unit: order?.per_weight_unit,
    //       };
    //       dataToSave.pos[0].orders[index].order = order;
    //       // });
    //     }
    //   }
    // } catch (error) {
    //   console.log(error);
    //   setLoadings(false);
    //   setResendApprovalLoading(false);
    // }
    // console.log(dataToSave);

    let dataToSave = poDataToSave.data;
    try {
      const response = await getReelCoreValues();
      if (!response.error) {
        for (let index = 0; index < dataToSave.pos[0].orders.length; index++) {
          let order = dataToSave.pos[0].orders[index].order;
          order["category"] = dataToSave.pos[0].po["po/so"];
          let productNo = order.product.split(" -");
          if (
            dataToSave.pos[0].po["po/so"] === "so" &&
            dataToSave.pos[0].po.number
          ) {
            dataToSave.pos[0].po["reference_number"] =
              dataToSave.pos[0].po.number;
          }
          if (dataToSave.pos[0].po["po/so"] === "so") {
            order.po = "";
            order.delivery_date = null;
          }
          // await getProductDetails(productNo[0]).then((productResp) => {
          let productResp = products?.filter(
            (ele) => productNo[0] === ele.code
          );
          let coreIdUnit;
          let reelOdUnit;

          if (!order?.reel_od && !order?.core_id) {
            if (
              order.type === "reel" &&
              response.default_reel_od &&
              response.default_core_id
            ) {
              if (order.type === "reel") {
                let widthData = (
                  order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);
                let diaArr = [];
                order.reel_od = response.default_reel_od
                  ? response.default_reel_od
                  : 0;
                order.core_id = response.default_core_id
                  ? response.default_core_id
                  : 0;

                // let productNo = order.product.split(" -");
                // await getProductDetails(productNo[0]).then((productResp) => {
                if (
                  (order.outer_dia?.length && order.inner_dia) ||
                  (order.outer_dia?.length &&
                    (order.inner_dia == 0 || order.inner_dia == ""))
                ) {
                  coreIdUnit = response.default_reel_unit;
                  reelOdUnit = response.default_reel_unit;
                } else if (order.outer_dia?.length == 0 && order.inner_dia) {
                  coreIdUnit = response.default_core_unit;
                  reelOdUnit = response.default_core_unit;
                } else if (
                  order.outer_dia?.length == 0 &&
                  (order.inner_dia == 0 || order.inner_dia == "")
                ) {
                  coreIdUnit =
                    measurementData.data.units_management.length.default;
                  reelOdUnit =
                    measurementData.data.units_management.length.default;
                }

                let outerDiaArr = [];
                outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
                order.outer_dia = response.default_reel_od ? outerDiaArr : diaArr;
                order.inner_dia = response.default_core_id
                  ? response.default_core_id + " " + coreIdUnit
                  : "";

                if (
                  order.type === "reel" &&
                  order.quantity_type === "reel_sheet" &&
                  order.no_of_reel_sheet
                ) {
                  order.quantity = order.no_of_reel_sheet;
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  let plannedReels = calculatePlannedReels(
                    parseFloat(widthData),
                    order.weight * weight_Unit_Conversions[order.weight_unit],
                    productResp[0].bulk,
                    order.outer_dia[0]?.split(" ")[0] *
                    orderDim_Rewinder_Unit_Conversion[reelOdUnit],
                    order.inner_dia?.split(" ")[0] *
                    orderDim_Rewinder_Unit_Conversion[coreIdUnit]
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_weight"] = order.weight;
                }
                let planned_weight = calculatePlannedWeight(
                  parseFloat(widthData),
                  productResp[0].bulk,
                  parseFloat(order.outer_dia[0]?.split(" ")[0]) *
                  orderDim_Rewinder_Unit_Conversion[reelOdUnit],
                  parseFloat(order.inner_dia?.split(" ")[0]) *
                  orderDim_Rewinder_Unit_Conversion[coreIdUnit],
                  order.quantity
                );
                let plannedWt =
                  planned_weight *
                  conversionFactorTonneToUnits[order.weight_unit];
                order.planned_weight = plannedWt
                  ? parseFloat(plannedWt).toFixed(3)
                  : 0;

                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                // if(order?.weight_unit?.toLowerCase() !== order?.per_weight_unit?.toLowerCase()){
                //   let unitToTonneConv = order.planned_weight * weight_Unit_Conversions[order?.weight_unit];
                //   plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[order?.per_weight_unit];
                // } else{
                //     plannedWtConversion  = order.planned_weight;
                // }
                // const netPrice = parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                //       ? parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                //       : "";
                let netPrice;
                if (order.quantity_type == "weight") {
                  netPrice =
                    parseFloat(order.dealer_price) *
                    parseFloat(order.weight)?.toFixed(3);
                }
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                order.quantity = Math.round(order.quantity);
              }
            } else if (order.type === "sheet") {
              let widthData = (
                order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);
              let lengthData = (
                order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);

              if (!order?.core_id) {
                order.core_id = response.default_core_id ? response.default_core_id : 0;
                if (!order.units.core_id_unit) {
                  order.units.core_id_unit = response.default_core_id
                    ? response.default_core_unit
                    : measurementData.data.units_management.default;
                }
                order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
              }

              if (
                order.outer_dia?.length == 0 &&
                (order.inner_dia == 0 || order.inner_dia == "")
              ) {
                if (order.quantity_type === "reel_sheet") {
                  let widthValue = parseFloat(widthData);
                  let lengthValue = parseFloat(lengthData);
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  const plannedWeight =
                    (lengthValue *
                      widthValue *
                      order.no_of_reel_sheet *
                      productResp[0].gsm) /
                    (10000 * 1000000);
                  let plannedWt =
                    plannedWeight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt?.toFixed(3);
                  order["planning_quantity"] = order.no_of_reel_sheet;
                  // if(order.planned_weight){
                  //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
                  //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
                  //   // order.lower_tolerance = lowerTolerance;
                  //   // order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
                  //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
                  // }else{
                  //   // order.lower_tolerance = lowerTolerance;
                  //   // order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = parseFloat(order.calculated_lower_tolerance)?.toFixed(3);
                  //   // order.calculated_upper_tolerance = parseFloat(order.calculated_upper_tolerance)?.toFixed(3);
                  // }
                } else {
                  order.weight = order.weight?.toFixed(3);
                  order.planned_weight = order.weight;
                  order["planning_weight"] = order.weight;
                  // if(order.planned_weight){
                  //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
                  //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
                  //   order.lower_tolerance = lowerTolerance;
                  //   order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
                  //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
                  // }else{
                  //   order.lower_tolerance = lowerTolerance;
                  //   order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = order.calculated_lower_tolerance?.toFixed(3);
                  //   // order.calculated_upper_tolerance = order.calculated_upper_tolerance?.toFixed(3);
                  // }
                  delete order.no_of_reel_sheet;
                }
                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                if (
                  order?.weight_unit?.toLowerCase() !==
                  order?.per_weight_unit?.toLowerCase()
                ) {
                  let unitToTonneConv =
                    order.planned_weight *
                    weight_Unit_Conversions[order?.weight_unit];
                  plannedWtConversion =
                    unitToTonneConv *
                    conversionFactorTonneToUnits[order?.per_weight_unit];
                } else {
                  plannedWtConversion = order.planned_weight;
                }
                const netPrice =
                  parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                    ? parseFloat(order.dealer_price) *
                    parseFloat(plannedWtConversion)
                    : "";
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
              }
              order.quantity = Math.round(order.quantity);
            } else if (
              order.type === "reel" &&
              (!response.default_reel_od || !response.default_core_id)
            ) {
              if (order.type === "reel" && order.quantity_type === "reel_sheet") {
                order.quantity = order.no_of_reel_sheet;
                order.weight_unit =
                  measurementData.data.units_management.weight.default;
                order["planning_quantity"] = order.no_of_reel_sheet;
              } else {
                order.quantity = 0;
                order["planning_weight"] = order.weight;
              }
            }
          } else {
            // if sheet and core id but no reel od = it will work like !reel and !core id
            if (order?.type == "sheet" && !order?.reel_od && order?.core_id) {
              let widthData = (
                order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);
              let lengthData = (
                order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);

              if (
                order.outer_dia?.length == 0 &&
                (order.inner_dia == 0 || order.inner_dia == "")
              ) {
                order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
                if (order.quantity_type === "reel_sheet") {
                  let widthValue = parseFloat(widthData);
                  let lengthValue = parseFloat(lengthData);
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  const plannedWeight =
                    (lengthValue *
                      widthValue *
                      order.no_of_reel_sheet *
                      productResp[0].gsm) /
                    (10000 * 1000000);
                  let plannedWt =
                    plannedWeight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt?.toFixed(3);
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  order.weight = order.weight?.toFixed(3);
                  order.planned_weight = order.weight;
                  order["planning_weight"] = order.weight;
                  delete order.no_of_reel_sheet;
                }
                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                if (
                  order?.weight_unit?.toLowerCase() !==
                  order?.per_weight_unit?.toLowerCase()
                ) {
                  let unitToTonneConv =
                    order.planned_weight *
                    weight_Unit_Conversions[order?.weight_unit];
                  plannedWtConversion =
                    unitToTonneConv *
                    conversionFactorTonneToUnits[order?.per_weight_unit];
                } else {
                  plannedWtConversion = order.planned_weight;
                }
                const netPrice =
                  parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                    ? parseFloat(order.dealer_price) *
                    parseFloat(plannedWtConversion)
                    : "";
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
              }
              order.quantity = Math.round(order.quantity);
            } else {
              if (!order?.reel_od) {
                order.reel_od = response.default_reel_od ? response.default_reel_od : 0;
                if (!order.units.reel_od_unit) {
                  order.units.reel_od_unit = response.default_reel_od
                    ? response.default_reel_unit
                    : measurementData.data.units_management.default;
                }
              }

              if (!order?.core_id) {
                order.core_id = response.default_core_id ? response.default_core_id : 0;
                if (!order.units.core_id_unit) {
                  order.units.core_id_unit = response.default_core_id
                    ? response.default_core_unit
                    : measurementData.data.units_management.default;
                }
              }

              let outerDiaArr = [];
              outerDiaArr.push(order?.reel_od + " " + (order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit));
              order.outer_dia = outerDiaArr;
              order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);

              if (order.type === "reel") {
                let widthData = (
                  order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);

                if (
                  order.type === "reel" &&
                  order.quantity_type === "reel_sheet" &&
                  order.no_of_reel_sheet
                ) {
                  order.quantity = order.no_of_reel_sheet;
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  let plannedReels = calculatePlannedReels(
                    parseFloat(widthData),
                    order.weight * weight_Unit_Conversions[order.weight_unit],
                    productResp[0].bulk,
                    order.outer_dia[0]?.split(" ")[0] *
                    orderDim_Rewinder_Unit_Conversion[order.units.reel_od_unit],
                    order.inner_dia?.split(" ")[0] *
                    orderDim_Rewinder_Unit_Conversion[order.units.core_id_unit]
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_weight"] = order.weight;
                }
                //calculate planned weight
                let planned_weight = calculatePlannedWeight(
                  parseFloat(widthData),
                  productResp[0].bulk,
                  parseFloat(order.outer_dia[0]?.split(" ")[0]) *
                  orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
                  parseFloat(order.inner_dia?.split(" ")[0]) *
                  orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
                  order.quantity
                );
                let plannedWt =
                  planned_weight *
                  conversionFactorTonneToUnits[order.weight_unit];
                order.planned_weight = plannedWt
                  ? parseFloat(plannedWt).toFixed(3)
                  : 0;

                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                let netPrice;
                if (order.quantity_type == "weight") {
                  netPrice =
                    parseFloat(order.dealer_price) *
                    parseFloat(order.weight)?.toFixed(3);
                }
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                order.quantity = Math.round(order.quantity);

              }
              // else if (order.type === "reel" && (!order?.reel_od || !order?.core_id)) {
              //   if (order.type === "reel" && order.quantity_type === "reel_sheet") {
              //     order.quantity = order.no_of_reel_sheet;
              //     order.weight_unit =
              //       measurementData.data.units_management.weight.default;
              //     order["planning_quantity"] = order.no_of_reel_sheet;
              //   } else {
              //     order.quantity = 0;
              //     order["planning_weight"] = order.weight;
              //   }
              // } else
              else {
                let size =
                  (order?.grain === "Long Grain" ||
                    order?.grain === "long" ||
                    order?.grain === "long grain"
                    ? parseFloat(order?.width) > parseFloat(order?.length)
                      ? order?.length
                      : order?.width
                    : parseFloat(order?.length) > parseFloat(order?.width)
                      ? order?.length
                      : order?.width);

                let widthData = (
                  size * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);

                let quantityValue;
                let plannedReels;

                if (order?.quantity_type == "weight") {
                  quantityValue = order.weight * weight_Unit_Conversions[order.weight_unit];
                  plannedReels = plannedReelsCalculations(
                    parseFloat(widthData),
                    order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    productResp[0].bulk,
                    productResp[0].gsm,
                    order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
                    order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
                    quantityValue,
                    order?.quantity_type
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_weight"] = order.weight;
                } else {
                  //in ordertype = sheet && quantity type = sheet ? order?.no_of_reel_sheet means user entered value and same in planning qty
                  // quantity = calculated reels
                  quantityValue = order.no_of_reel_sheet;
                  plannedReels = plannedReelsCalculations(
                    parseFloat(widthData),
                    order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    productResp[0].bulk,
                    productResp[0].gsm,
                    order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
                    order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
                    quantityValue,
                    order?.quantity_type
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                }

                //calculate planned weight
                let planned_weight = calculatePlannedWeight(
                  parseFloat(widthData),
                  productResp[0].bulk,
                  parseFloat(order.outer_dia[0]?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
                  parseFloat(order.inner_dia?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
                  order.quantity
                );
                let plannedWt =
                  planned_weight *
                  conversionFactorTonneToUnits[order.weight_unit];
                order.planned_weight = plannedWt
                  ? parseFloat(plannedWt).toFixed(3)
                  : 0;

                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                let netPrice;
                if (order.quantity_type == "weight") {
                  netPrice =
                    parseFloat(order.dealer_price) *
                    parseFloat(order.weight)?.toFixed(3);
                }
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                order.quantity = Math.round(order.quantity);
              }

            }
          }

          if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
            order["planned_sheets"] = order.no_of_reel_sheet;
          }

          if (order.quantity_type === "weight") {
            let calculated_lower_tolerance = 0;
            let calculated_upper_tolerance = 0;
            if (order.weight) {
              let upperTol =
                (parseFloat(order.weight)?.toFixed(3) *
                  (100 + parseFloat(upperTolerance))) /
                100;
              let lowerTol =
                (parseFloat(order.weight)?.toFixed(3) *
                  (100 - parseFloat(lowerTolerance))) /
                100;
              calculated_lower_tolerance = lowerTol.toFixed(3);
              calculated_upper_tolerance = upperTol.toFixed(3);
            }
            order["tolerances"] = {
              weight: {
                upper_tolerance: parseFloat(upperTolerance),
                lower_tolerance: parseFloat(lowerTolerance),
                calculated_lower_tolerance: parseFloat(
                  calculated_lower_tolerance
                ),
                calculated_upper_tolerance: parseFloat(
                  calculated_upper_tolerance
                ),
                units: order.weight_unit
                  ? order.weight_unit
                  : measurementData.data.units_management.weight.default,
              },
            };
          } else {
            order["tolerances"] = {};
          }

          order["packaging_details"] = order.packaging_details.id;
          order["ply"] = parseFloat(order.ply);
          order.units = {
            weight: order.weight_unit
              ? order.weight_unit
              : measurementData.data.units_management.weight.default,
            ...(order.type === "sheet" && { length: order.size_unit }),
            width: order.size_unit,
            planned_weight:
              order.quantity_type === "reel_sheet"
                ? measurementData.data.units_management.weight.default
                : order.weight_unit,
            // ...order.type === "sheet" && {calculated_upper_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
            // ...order.type === "sheet" && {calculated_lower_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
            // core_id: order.type === "sheet" ? measurementData?.data.units_management.length.default : coreIdUnit,
            // reel_od: order.type === "sheet" ? measurementData?.data.units_management.length.default : reelOdUnit,
            dealer_price: order.currency,
            customer_price: order.currency,
            net_price: order.currency,
            per_weight_unit: order?.per_weight_unit,
          };
          dataToSave.pos[0].orders[index].order = order;
          // });
        }
      }
    } catch (error) {
      console.log(error);
      setLoadings(false);
      setResendApprovalLoading(false);
    }
    console.log(dataToSave);

    await saveUploadedOrders(dataToSave, location.state.format)
      .then((response) => {
        if (!response.error) {
          setSavedState(true);
        } else {
          setSavedState(false);
        }
        let orders = ordersForSelectedPo;
        orders.data.pos[location.state.selectedPoIndex]["isPOSaved"] = true;
        setOrdersForSelectedPo(orders);
        setActionToaster({
          error: response.error,
          msg: "Orders are successfully uploaded",
        });
        setLoadings(false);
        showToaster();
        setTimeout(() => {
          history("../order-records/upload-summary", {
            state: { action: orders, format: location.state.format },
          });
        }, 2000);
      })
      .catch((error) => {
        setLoadings(false);
        setResendApprovalLoading(false);
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        showToaster();
      });
  };

  const handleType = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.type =
      form.getFieldValue(`type${orderNumber}`);
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors.type
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["type"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const handleProduct = (orderNumber,e) => {
    let orders = ordersForSelectedPoRef.current || ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });

    // Normalize to "code - name" so dropdown and GSM/Bulk rematch stay consistent.
    const selectedProduct = (productsRef.current || products || []).find(
      (product) =>
        product.code === e ||
        `${product.code} - ${product.name}` === e
    );
    const productValue = selectedProduct
      ? `${selectedProduct.code} - ${selectedProduct.name}`
      : e;
    const productCode = selectedProduct?.code || String(e).split(" - ")[0];

    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.product = productValue;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .product
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["product"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }

    form.setFields([
      {
        name: `product${orderNumber}`,
        value: productValue,
        errors: [],
      },
    ]);

    getProductDetails(productCode)
      .then((response) => {
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].order.product_spec = response.data.product_spec;
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].order.product_data = {
          grade: response.data.grade,
          quality: response.data.quality,
          bulk: response.data?.bulk,
          gsm: response.data?.gsm,
          burst_factor: response.data?.burst_factor,
          moisture: response.data?.moisture,
        };
        setPlyData(
          response.data.ply.map((ply) => ({ label: ply, value: ply }))
        );
        form.setFieldsValue({
          [`gsm${orderNumber}`]: response.data?.gsm,
          [`bulk${orderNumber}`]: response.data?.bulk,
          [`grade${orderNumber}`]: response.data.grade,
        });

        ordersForSelectedPoRef.current = orders;
        setOrdersForSelectedPo({ ...orders });
        setRerendering(true);
      })
      .catch((error) => {
        console.log("Error in getting product specification list");
      });
  };

  const handlePly = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.ply =
      form.getFieldValue(`ply${orderNumber}`);
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors.ply
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["ply"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onSizeChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].order
        .type == "sheet"
    ) {
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].order.width = form.getFieldValue(`size${orderNumber}`).split("x")[0]
        ? parseFloat(form.getFieldValue(`size${orderNumber}`).split("x")[0])
        : "";
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].order.length = form.getFieldValue(`size${orderNumber}`).split("x")[1]
        ? parseFloat(form.getFieldValue(`size${orderNumber}`).split("x")[1])
        : "";
    } else {
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].order.width = form.getFieldValue(`size${orderNumber}`)
        ? parseFloat(form.getFieldValue(`size${orderNumber}`))
        : "";
    }
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .width ||
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .length
    ) {
      if (
        orders.data.pos[location.state.selectedPoIndex].orders[index].errors
          .width
      ) {
        delete orders.data.pos[location.state.selectedPoIndex].orders[index]
          .errors["width"];
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].error_count =
          orders.data.pos[location.state.selectedPoIndex].orders[index]
            .error_count - 1;
      } else if (
        orders.data.pos[location.state.selectedPoIndex].orders[index].errors
          .length
      ) {
        delete orders.data.pos[location.state.selectedPoIndex].orders[index]
          .errors["length"];
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].error_count =
          orders.data.pos[location.state.selectedPoIndex].orders[index]
            .error_count - 1;
      }
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onSizeUnitChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'cm') {
          //   order.order.width = (order.order.width * 10).toFixed(3);
          // }
          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'inch') {
          //   order.order.width = (order.order.width * 25.4).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'inch') {
          //   order.order.width = (order.order.width * 2.54).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'mm') {
          //   order.order.width = (order.order.width / 10).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'mm') {
          //   order.order.width = (order.order.width / 25.4).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'cm') {
          //   order.order.width = (order.order.width / 2.54).toFixed(3);
          // }

          // form.setFieldsValue({ [`size${order.order.orderNumber}`]: order.order.width });

          // if(order.order.type == 'sheet')
          // {
          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'cm') {
          //     order.order.length = (order.order.length * 10).toFixed(3);
          //   }
          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'inch') {
          //     order.order.length = (order.order.length * 25.4).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'inch') {
          //     order.order.length = (order.order.length * 2.54).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'mm') {
          //     order.order.length = (order.order.length / 10).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'mm') {
          //     order.order.length = (order.order.length / 25.4).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'cm') {
          //     order.order.length = (order.order.length / 2.54).toFixed(3);
          //   }
          //   form.setFieldsValue({ [`size${order.order.orderNumber}`]: order.order.length });

          // }
          order.order.size_unit = form.getFieldValue(`sizeUnit${orderNumber}`);
          form.setFieldsValue({
            [`sizeUnit${order.order.orderNumber}`]: form.getFieldValue(
              `sizeUnit${orderNumber}`
            ),
          });
          if (order.errors.size_unit) {
            delete order.errors["size_unit"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    // form.resetFields();
    setRerendering(true);
  };

  const onOrderWeightChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.weight =
      form.getFieldValue(`orderWeight${orderNumber}`)
        ? parseFloat(form.getFieldValue(`orderWeight${orderNumber}`))
        : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .weight
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["weight"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onOrderWeightUnitChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          // if (order.order.weight_unit == 'tonne' && form.getFieldValue(`orderWeightUnit${orderNumber}`) == 'kg') {
          //   order.order.weight = order.order.weight * 1000;
          // }
          // else {
          //   order.order.weight = order.order.weight / 1000;
          // }
          // form.setFieldsValue({ [`orderWeight${order.order.orderNumber}`]: order.order.weight });
          order.order.weight_unit = form.getFieldValue(
            `orderWeightUnit${orderNumber}`
          );
          form.setFieldsValue({
            [`orderWeightUnit${order.order.orderNumber}`]: form.getFieldValue(
              `orderWeightUnit${orderNumber}`
            ),
          });

          if (order.errors.weight_unit) {
            delete order.errors["weight_unit"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onCurrencyChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          order.order.currency = form.getFieldValue(`currency${orderNumber}`);
          form.setFieldsValue({
            [`currency${order.order.orderNumber}`]: form.getFieldValue(
              `currency${orderNumber}`
            ),
          });
          if (order.errors.currency) {
            delete order.errors["currency"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onWeightUnitChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          order.order.per_weight_unit = form.getFieldValue(
            `per_weight_unit${orderNumber}`
          );
          form.setFieldsValue({
            [`per_weight_unit${order.order.orderNumber}`]: form.getFieldValue(
              `per_weight_unit${orderNumber}`
            ),
          });
          if (order.errors.per_weight_unit) {
            delete order.errors["per_weight_unit"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onPackagingChange = (orderNumber, e) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        let packagingValue;
        if (orderNumber === order.order.orderNumber) {
          order.order.packaging_details = {};
          if (order?.order?.type?.toLowerCase() == "sheet") {
            packagingValue = sheetPackagingData?.filter(
              (ele) =>
                ele.id == form.getFieldValue(`packagingType${orderNumber}`)
            );
          } else {
            packagingValue = reelPackagingData?.filter(
              (ele) =>
                ele.id == form.getFieldValue(`packagingType${orderNumber}`)
            );
          }
          order.order.packaging_details = packagingValue[0];
          form.setFieldsValue({
            [`packagingType${order.order.orderNumber}`]: form
              .getFieldValue(`packagingType${orderNumber}`)
              .toString(),
          });

          if (order.errors.packaging_details) {
            delete order.errors["packaging_details"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onQuantityChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.no_of_reel_sheet = form.getFieldValue(`quantity${orderNumber}`)
      ? parseFloat(form.getFieldValue(`quantity${orderNumber}`))
      : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .no_of_reel_sheet
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["no_of_reel_sheet"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onPriceChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.dealer_price = form.getFieldValue(`price${orderNumber}`)
      ? parseFloat(form.getFieldValue(`price${orderNumber}`))
      : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .dealer_price
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["dealer_price"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onCustPriceChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.customer_price = form.getFieldValue(`customerPrice${orderNumber}`)
      ? parseFloat(form.getFieldValue(`customerPrice${orderNumber}`))
      : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .dealer_price
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["customer_price"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onDeliveryDateChange = (orderNumber, newDate) => {
    if (!newDate || !moment(newDate).isValid()) return;

    const orders = { ...ordersForSelectedPo };
    const poIndex = location.state.selectedPoIndex;
    const dateStr = moment(newDate).format("YYYY-MM-DD 00:00:00");

    const index = orders.data.pos[poIndex].orders.findIndex(
      (item) => item.order.orderNumber === orderNumber
    );
    const targetOrder = orders.data.pos[poIndex].orders[index];
    targetOrder.order.delivery_date = dateStr;

    form.setFieldsValue({
      [`deliveryDate${orderNumber}`]: moment(dateStr),
    });

    if (targetOrder.errors.delivery_date) {
      delete targetOrder.errors["delivery_date"];
      targetOrder.error_count -= 1;
    }

    if (orders.data.pos[poIndex].errors.delivery_date) {
      delete orders.data.pos[poIndex].errors["delivery_date"];
      orders.data.pos[poIndex].error_count -= 1;
    }

    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onGrainChanges = (orderNumber,e) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.grain =
      e;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors.grain
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["grain"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const handleGradeChange = async (orderNumber, e) => {
    const orders = ordersForSelectedPoRef.current;
    const poIndex = location.state.selectedPoIndex;
    const index = orders.data.pos[poIndex].orders.findIndex(
      (item) => item.order.orderNumber === orderNumber
    );
    if (index === -1) return;

    // Ant Design Select passes the value directly (not a DOM event).
    const gradeValue =
      e !== undefined && e !== null && typeof e !== "object"
        ? e
        : e?.target?.value ?? form.getFieldValue(`grade${orderNumber}`);

    orders.data.pos[poIndex].orders[index].order.product_data.grade = gradeValue;

    if (orders.data.pos[poIndex].orders[index].errors?.grade) {
      delete orders.data.pos[poIndex].orders[index].errors["grade"];
      orders.data.pos[poIndex].orders[index].error_count = Math.max(
        0,
        (orders.data.pos[poIndex].orders[index].error_count || 0) - 1
      );
    }

    ordersForSelectedPoRef.current = orders;
    applyProductMatchForOrder(orderNumber);
  };

  const applyProductMatchForOrder = (orderNumber, overrides = {}) => {
    const latestOrders = ordersForSelectedPoRef.current;
    const poIndex = location.state.selectedPoIndex;
    const latestIndex = latestOrders.data.pos[poIndex].orders.findIndex(
      (item) => item.order.orderNumber === orderNumber
    );
    if (latestIndex === -1) return;

    const orderRow = latestOrders.data.pos[poIndex].orders[latestIndex];
    const existingProductData = orderRow.order.product_data || {};

    // Prefer Form values when present; do not blank quality/bf/moisture from missing fields.
    const pickField = (formKey, dataKey) => {
      const formVal = form.getFieldValue(`${formKey}${orderNumber}`);
      if (formVal !== undefined && formVal !== null && formVal !== "") {
        return formVal;
      }
      return existingProductData[dataKey];
    };

    const syncedProductData = {
      ...existingProductData,
      grade: pickField("grade", "grade"),
      gsm: pickField("gsm", "gsm"),
      bulk: pickField("bulk", "bulk"),
      quality: pickField("quality", "quality"),
      burst_factor: pickField("burst_factor", "burst_factor"),
      moisture: pickField("moisture", "moisture"),
      // Latest edited values from onChange must win over possibly stale Form values.
      ...overrides,
    };

    orderRow.order.product_data = syncedProductData;

    const format = productSpecFormatRef.current;
    const generatedWithAlias = generateProductSpec(format, syncedProductData);
    const matchedProduct = findProductBySpec(generatedWithAlias, syncedProductData);

    if (matchedProduct) {
      const productValue = matchedProduct?.name
        ? `${matchedProduct.code} - ${matchedProduct.name}`
        : matchedProduct?.code;
      orderRow.order.product_spec =
        matchedProduct.complete_product_spec || generatedWithAlias;
      orderRow.order.product = productValue;

      const nextErrors = { ...(orderRow.errors || {}) };
      if (nextErrors.product) {
        delete nextErrors.product;
        orderRow.error_count = Math.max(0, (orderRow.error_count || 0) - 1);
      }
      orderRow.errors = nextErrors;

      form.setFields([
        {
          name: `product${orderNumber}`,
          value: productValue,
          errors: [],
        },
      ]);
    } else {
      orderRow.order.product_spec = "";
      orderRow.order.product = "";

      const nextErrors = { ...(orderRow.errors || {}) };
      const hasProductError = !!nextErrors.product;
      nextErrors.product = "Product not found";
      orderRow.errors = nextErrors;
      if (!hasProductError) {
        orderRow.error_count = (orderRow.error_count || 0) + 1;
      }

      form.setFields([
        {
          name: `product${orderNumber}`,
          value: undefined,
          errors: [],
        },
      ]);
    }

    const nextOrders = {
      ...latestOrders,
      data: {
        ...latestOrders.data,
        pos: latestOrders.data.pos.map((po, ind) =>
          ind === poIndex
            ? {
                ...po,
                orders: po.orders.map((row, i) =>
                  i === latestIndex
                    ? {
                        ...orderRow,
                        error_count: orderRow.error_count,
                        order: {
                          ...orderRow.order,
                          product: orderRow.order.product,
                          product_spec: orderRow.order.product_spec,
                          product_data: { ...orderRow.order.product_data },
                        },
                        errors: { ...(orderRow.errors || {}) },
                      }
                    : row
                ),
              }
            : po
        ),
      },
    };
    ordersForSelectedPoRef.current = nextOrders;
    setOrdersForSelectedPo(nextOrders);
    setRerendering(true);

    const fieldsToValidate = [];
    const gsmVal = orderRow.order.product_data?.gsm;
    const bulkVal = orderRow.order.product_data?.bulk;
    if (gsmVal === "" || gsmVal == null) fieldsToValidate.push(`gsm${orderNumber}`);
    if (bulkVal === "" || bulkVal == null) fieldsToValidate.push(`bulk${orderNumber}`);
    if (fieldsToValidate.length) {
      setTimeout(() => {
        form.validateFields(fieldsToValidate).catch(() => {});
      }, 0);
    }
  };

  const onGSMChange = (orderNumber, e) => {
    const gsmValue =
      e?.target?.value ?? form.getFieldValue(`gsm${orderNumber}`);
    const orders = ordersForSelectedPoRef.current;
    const poIndex = location.state.selectedPoIndex;
    const index = orders.data.pos[poIndex].orders.findIndex(
      (item) => item.order.orderNumber === orderNumber
    );
    if (index === -1) return;

    if (!orders.data.pos[poIndex].orders[index].order.product_data) {
      orders.data.pos[poIndex].orders[index].order.product_data = {};
    }
    orders.data.pos[poIndex].orders[index].order.product_data.gsm = gsmValue;
    form.setFieldsValue({ [`gsm${orderNumber}`]: gsmValue });

    if (orders.data.pos[poIndex].orders[index].errors?.gsm) {
      delete orders.data.pos[poIndex].orders[index].errors["gsm"];
      orders.data.pos[poIndex].orders[index].error_count = Math.max(
        0,
        (orders.data.pos[poIndex].orders[index].error_count || 0) - 1
      );
    }

    clearTimeout(gsmMatchTimeoutRef.current[orderNumber]);
    gsmMatchTimeoutRef.current[orderNumber] = setTimeout(() => {
      applyProductMatchForOrder(orderNumber, { gsm: gsmValue });
    }, 400);
  };

  const onBulkChange = (orderNumber, e) => {
    const bulkValue =
      e?.target?.value ?? form.getFieldValue(`bulk${orderNumber}`);
    const orders = ordersForSelectedPoRef.current;
    const poIndex = location.state.selectedPoIndex;
    const index = orders.data.pos[poIndex].orders.findIndex(
      (item) => item.order.orderNumber === orderNumber
    );
    if (index === -1) return;

    if (!orders.data.pos[poIndex].orders[index].order.product_data) {
      orders.data.pos[poIndex].orders[index].order.product_data = {};
    }
    orders.data.pos[poIndex].orders[index].order.product_data.bulk = bulkValue;
    form.setFieldsValue({ [`bulk${orderNumber}`]: bulkValue });

    if (orders.data.pos[poIndex].orders[index].errors?.bulk) {
      delete orders.data.pos[poIndex].orders[index].errors["bulk"];
      orders.data.pos[poIndex].orders[index].error_count = Math.max(
        0,
        (orders.data.pos[poIndex].orders[index].error_count || 0) - 1
      );
    }

    clearTimeout(bulkMatchTimeoutRef.current[orderNumber]);
    bulkMatchTimeoutRef.current[orderNumber] = setTimeout(() => {
      applyProductMatchForOrder(orderNumber, { bulk: bulkValue });
    }, 400);
  };

  const onRemarkChange = (orderNumber,e) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.remarks = (form.getFieldValue(`remark${orderNumber}`));
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .remarks
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["remarks"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onBalanceQtyChange = (orderNumber, e) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.balance_weight =
      parseFloat(e.target.value)
        ? parseFloat(e.target.value)
        : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .balance_weight
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["balance_weight"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const saveDetails = () => {
    // let orders = ordersForSelectedPo;
    let orders = {
      data: {
        pos: [ordersForSelectedPo.data.pos[location.state.selectedPoIndex]],
        mark_orders_complete: location.state?.checkBoxValue ? location.state?.checkBoxValue : false
      },
    };
    setPoDataToSave(orders);
    setIsVisible(false);
    // setOrdersForSelectedPo(orders);
    // setRerendering(true);
      setLoadings(true);
      setOtherButtonLoadingLoadings(true);
    form.submit();
  };

  const goBack = () => {
    setGobackLoading(true);
    let originalArr = location.state.originalArr;
    // let selectedPOInd = originalArr.data.pos.findIndex(
    //   (ele) =>
    //     ele.po.number ==
    //     ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po.number
    // );
    originalArr.data.pos[location.state.selectedPoIndex]["orders"] =
      ordersForSelectedPo.data.pos[location.state.selectedPoIndex].orders;

    setTimeout(() => {
      history("../order-records/upload-summary", {
        state: {
          // action: ordersForSelectedPo,
          action: originalArr,
          // filterState: location.state.filterState,
          format: location.state.format,
          checkBoxValue: location.state?.checkBoxValue ? location.state?.checkBoxValue : false,
          currentPage: location.state.currentPage,
        },
      });
    }, 400);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  const setNewProductData = async (response) => {
    try {
      const productLabel = `${response.code} - ${response.name}`;
      const latestOrders = ordersForSelectedPoRef.current || ordersForSelectedPo;
      const formUpdates = [];

      const updatedData = {
        ...latestOrders,
        data: {
          ...latestOrders.data,
          pos: latestOrders.data.pos.map((po) => ({
            ...po,
            orders: po.orders.map((orderRow) => {
              const productData = orderRow.order?.product_data || {};
              const orderMatches = Object.keys(productData).every(
                (item) =>
                  response[item] === undefined ||
                  productData[item] == response[item]
              );

              if (!(orderRow.error_count && orderMatches)) {
                return orderRow;
              }

              const nextErrors = { ...(orderRow.errors || {}) };
              let nextErrorCount = orderRow.error_count || 0;
              const nextProductData = { ...productData };

              Object.keys(nextErrors).forEach((item) => {
                if (Object.keys(response).includes(item)) {
                  delete nextErrors[item];
                  nextErrorCount = Math.max(0, nextErrorCount - 1);
                  nextProductData[item] = response[item];
                }
              });

              if (nextErrors.product) {
                delete nextErrors.product;
                nextErrorCount = Math.max(0, nextErrorCount - 1);
              }

              const orderNumber = orderRow.order.orderNumber;
              formUpdates.push(
                {
                  name: `product${orderNumber}`,
                  value: productLabel,
                  errors: [],
                },
                {
                  name: `grade${orderNumber}`,
                  value: response.grade ?? nextProductData.grade,
                },
                {
                  name: `gsm${orderNumber}`,
                  value: response.gsm ?? nextProductData.gsm,
                },
                {
                  name: `bulk${orderNumber}`,
                  value: response.bulk ?? nextProductData.bulk,
                }
              );

              return {
                ...orderRow,
                error_count: nextErrorCount,
                errors: nextErrors,
                order: {
                  ...orderRow.order,
                  product: productLabel,
                  product_spec:
                    response.complete_product_spec ||
                    response.product_spec ||
                    orderRow.order.product_spec,
                  product_data: {
                    ...nextProductData,
                    grade: response.grade ?? nextProductData.grade,
                    gsm: response.gsm ?? nextProductData.gsm,
                    bulk: response.bulk ?? nextProductData.bulk,
                    quality: response.quality ?? nextProductData.quality,
                    burst_factor:
                      response.burst_factor ?? nextProductData.burst_factor,
                    moisture: response.moisture ?? nextProductData.moisture,
                  },
                },
              };
            }),
          })),
        },
      };

      // Keep Select options in sync so the newly created product is visible.
      try {
        const productsResponse = await getProductsData({ status: "active" });
        setProducts(productsResponse);
        productsRef.current = productsResponse;
      } catch (productsError) {
        console.log("Error refreshing products list:", productsError);
      }

      if (formUpdates.length) {
        form.setFields(formUpdates);
      }

      ordersForSelectedPoRef.current = updatedData;
      setOrdersForSelectedPo(updatedData);
      setRerendering(true);
    } catch (e) {
      console.log(e);
    }
  };

  // const generateProductSpec = (format, productData) => {
  //   if (!format) return "";

  //   const fieldMap = {
  //     grade: "grade",
  //     gsm: "gsm",
  //     bf: "burst_factor",
  //     quality: "quality",
  //     bulk: "bulk",
  //     moisture: "moisture",
  //   };

  //   // return format
  //   //   .split("/")
  //   //   .map((field) => {
  //   //     const key = fieldMap[field.trim().toLowerCase()];
  //   //     return key ? productData[key] ?? "" : "";
  //   //   })
  //   //   .join("/");

  //   return format
  // .split("/")
  // .map((field) => {
  //   const fieldName = field.trim().toLowerCase();
  //   const key = fieldMap[fieldName];

  //   if (!key) return "";

  //   if (fieldName === "grade") {
  //     const gradeData = allGrades?.find(
  //       (ele) => ele.value === productData.grade
  //     );
  //     return gradeData?.alias ?? "";
  //   }

  //   return productData[key] ?? "";
  // })
  // .join("/");
  // };

  const normalizeSpecPart = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const asString = String(value).trim();
    if (asString === "") return "";
    const asNumber = Number(asString);
    // Normalize 80, "80", "80.0" → "80" so rematch works after typing.
    if (!Number.isNaN(asNumber) && /^-?\d+(\.\d+)?$/.test(asString)) {
      return String(asNumber);
    }
    return asString;
  };

  const normalizeProductSpec = (spec) =>
    String(spec || "")
      .split("/")
      .map((part) => normalizeSpecPart(part))
      .join("/");

  const resolveGradeAlias = (gradeValue) => {
    if (gradeValue === null || gradeValue === undefined || gradeValue === "") {
      return "";
    }
    const normalizedValue = String(gradeValue).trim().toLowerCase();
    const gradeData = allGradesRef.current?.find((ele) => {
      const value = String(ele.value ?? "").trim().toLowerCase();
      const label = String(ele.label ?? "").trim().toLowerCase();
      const alias = String(ele.alias ?? "").trim().toLowerCase();
      return (
        value === normalizedValue ||
        label === normalizedValue ||
        alias === normalizedValue
      );
    });
    // Prefer alias; if alias is not configured, keep selected/spec grade value
    // (same behavior as the original working alias path).
    return normalizeSpecPart(gradeData?.alias ?? gradeValue ?? "");
  };

  const normalizeSpecGradeToAlias = (spec) => {
    const format = productSpecFormatRef.current;
    if (!format) return normalizeProductSpec(spec);

    const fields = format.split("/").map((field) => field.trim().toLowerCase());
    const parts = String(spec || "").split("/");
    const gradeIdx = fields.indexOf("grade");

    return fields
      .map((_, index) => {
        if (index === gradeIdx) {
          return resolveGradeAlias(parts[index] ?? "");
        }
        return normalizeSpecPart(parts[index] ?? "");
      })
      .join("/");
  };

  const generateProductSpec = (format, productData) => {
    if (!format) return "";

    const fieldMap = {
      grade: "grade",
      gsm: "gsm",
      bf: "burst_factor",
      quality: "quality",
      bulk: "bulk",
      moisture: "moisture",
    };

    return format
      .split("/")
      .map((field) => {
        const fieldName = field.trim().toLowerCase();
        const key = fieldMap[fieldName];

        if (!key) return "";

        if (fieldName === "grade") {
          return resolveGradeAlias(productData.grade);
        }

        return normalizeSpecPart(productData[key] ?? "");
      })
      .join("/");
  };

  const findProductBySpec = (generatedProductSpec, productData) => {
    const normalizedGenerated = normalizeProductSpec(generatedProductSpec);
    if (
      !normalizedGenerated ||
      normalizedGenerated.split("/").every((p) => p === "")
    ) {
      return null;
    }

    const target = normalizedGenerated.toLowerCase();
    const products = productsRef.current || [];
    const bySpec = products.find((product) => {
      const candidate = product.complete_product_spec;
      if (!candidate) return false;

      const candidateRaw = normalizeProductSpec(candidate).toLowerCase();
      const candidateAsAlias = normalizeSpecGradeToAlias(candidate).toLowerCase();

      // Alias-first compare, plus raw compare when spec is already alias-based.
      return candidateAsAlias === target || candidateRaw === target;
    });
    if (bySpec) return bySpec;

    // Fallback: rebuild each product's spec using alias-first grade resolution.
    const format = productSpecFormatRef.current;
    if (!format || !productData) return null;

    return (
      products.find((product) => {
        const pData = {
          grade: product.grade ?? product.product_data?.grade,
          gsm: product.gsm ?? product.product_data?.gsm,
          bulk: product.bulk ?? product.product_data?.bulk,
          quality: product.quality ?? product.product_data?.quality,
          burst_factor:
            product.burst_factor ??
            product.bf ??
            product.product_data?.burst_factor,
          moisture: product.moisture ?? product.product_data?.moisture,
        };
        const fromAlias = normalizeProductSpec(
          generateProductSpec(format, pData)
        );
        return fromAlias.toLowerCase() === target;
      }) || null
    );
  };
  
  const handleQualityChange = (orderNumber, e) => {
    console.log(e);
    const selectedPOIndex = location?.state?.selectedPOIndex;
    const currentOrder = ordersForSelectedPo?.data?.pos[
      selectedPOIndex
    ]?.orders?.find((item) => item?.order?.orderNumber == orderNumber);
    delete currentOrder?.errors?.quality;
    currentOrder.error_count = currentOrder?.error_count - 1;
    currentOrder.order.product_data.quality = e.target.value;
    const updatedPOData = {
      ...ordersForSelectedPo,
      data: {
        ...ordersForSelectedPo.data,
        pos: ordersForSelectedPo?.data?.pos.map((po, ind) => {
          if (ind == selectedPOIndex) {
            return {
              ...ordersForSelectedPo?.data?.pos[selectedPOIndex],
              orders: ordersForSelectedPo?.data?.pos[
                selectedPOIndex
              ]?.orders.map((order) => {
                if (order.orderNumber == orderNumber) {
                  return currentOrder;
                } else return order;
              }),
            };
          } else return po;
        }),
      },
    };

    console.log(updatedPOData);
    setOrdersForSelectedPo(updatedPOData);
    setRerendering(true);
  };

  const getAllQualities = async (grade) => {
    try {
      const response = grade ? await getGradeQualitiesForConfig(grade) : [];
      setAllQualities(
        response.map((quality) => ({
          label: quality?.name,
          value: quality?.name,
        }))
      );
    } catch (e) {
      console.log(e);
    }
  };

  // const onProductChange = (index) => {
  //   let orders = ordersForSelectedPo;
  //   orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = form.getFieldValue(`product${index}`);
  //   if (orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product) {
  //     delete orders.data.pos[location.state.selectedPoIndex].orders[index].errors['product'];
  //     orders.data.pos[location.state.selectedPoIndex].orders[index].error_count = orders.data.pos[location.state.selectedPoIndex].orders[index].error_count - 1;
  //     setOrdersForSelectedPo(orders);
  //     setRerendering(true);
  //   }
  // }

  useEffect(() => {
    (async () => {
      document.body.style.overflow = "hidden";
      ordersForSelectedPo.data.pos[0].orders.map((item) => {
        if (item.order.type === "sheet") {
          setIsVisible(true);
        }
      });

      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          // setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);
        }
      } catch (error) {
        console.log(error);
      }

      getProductsData({ status: "active" })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => {
          console.log("Error in fetching products list:", error);
        });

      getMachineGradeSelect()
        .then((response) => {
          const reelValue = response.data.data.settings.order_types[0].value;
          const sheetValue = response.data.data.settings.order_types[1].value;
          let productSpecValue = response?.data?.data?.settings?.product_spec?.format;
          setProductSpecFormat(productSpecValue);
          setUpperTol(
            response?.data?.data?.settings?.order_types[2]?.data
              ?.order_tolerance?.upper_tolerance
          );
          setLowerTol(
            response?.data?.data?.settings?.order_types[2]?.data
              ?.order_tolerance?.lower_tolerance
          );
          setDefaultMixedGrain(
            response.data.data.settings.order_types[1].mixed_grain
          );
          const typeData =
            reelValue && sheetValue
              ? [
                  { label: "Reel", value: "reel" },
                  { label: "Sheet", value: "sheet" },
                ]
              : reelValue
              ? [{ label: "Reel", value: "reel" }]
              : sheetValue
              ? [{ label: "Sheet", value: "sheet" }]
              : [];
          setOrderTypes(typeData);
        })
        .catch((error) => console.log(error));

      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
          setDimesionUnitList(unitData.data.units_management.length.data);
          setWeightUnitList(unitData.data.units_management.weight.data);
          let currencyData = currency_List?.filter((item) =>
            unitData.data.units_management.currency.data.includes(item.code)
          );
          setCurrencyUnitData(currencyData);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const resp = await getPackagingList("", "active");
        if (!resp.error) {
          setReelPackagingData(resp.data.filter((item) => item.type == "reel"));
          setSheetPackagingData(
            resp.data.filter((item) => item.type == "sheet")
          );
          setRerendering(true);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const response = await getAllGradesForConfig();
        const gradeOptions = response.map((grade) => ({
          label: grade?.name,
          value: grade?.name,
          alias: grade?.alias,
        }));
        setAllGrades(gradeOptions);
      } catch (e) {
        console.log(e);
      }

      try {
        const settings = await getJobCardSerialNumberParam();
        setOrderConfigSettings(settings?.data?.order_creation_config);
      } catch (e) {
        console.log(e);
      }

      let orderstoshow = [];
      filteredOrders?.map((item, index) => {
        if (index < 25) {
          orderstoshow.push(item);
        }
      });
      setOrdersToShow(filteredOrders);
    })();

    return () => {
      setOrderTypes([]);
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    console.log("productSpecFormat updated:", productSpecFormat);
  }, [productSpecFormat]);

  const setRowCount = () => {
    rowCount.current = true;
  };

  const filterRecords = (filterParam) => {
    let orders = ordersForSelectedPo;
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (filterParam ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersToShow(failedOrders);
    // setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  useEffect(() => {
    if (rerendering) {
      const ordersList =
        ordersForSelectedPoRef.current?.data?.pos?.[
          location.state.selectedPoIndex
        ]?.orders || [];
      // New array reference so product error / product_spec UI always refreshes.
      setOrdersToShow([...ordersList]);
      setRerendering(false);
    }
  }, [rerendering]);

  const handleScroll = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const onGrainChangesChange = (e, orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.rotaion = e.target.checked;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .rotaion
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["rotaion"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onGrainMixingChange = (e, orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.grain_mixing = e.target.checked;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .grain_mixing
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["grain_mixing"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onPageChange = (page, pageSize) => {
    let start = page * pageSize - pageSize;
    let end = page * pageSize;
    if (end > filteredOrders.length) {
      end = filteredOrders.length;
    }
    setOrdersToShow(filteredOrders.slice(start, end));
  };

  const addNewProduct = (index) => {
    setProductDrawerVisible(true);
    setSelectedOrderIndex(index);
  };

  const closeProductDrawer = () => {
    setProductDrawerVisible(false);
  };

  const checkSaveDisabled = () => {
    let isDisabled =
      ordersForSelectedPo.data.pos[location?.state?.selectedPoIndex] 
        ?.error_count;
    let poSaved = ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
      .isPOSaved
      ? true
      : false
    ordersForSelectedPo.data.pos[
      location?.state?.selectedPoIndex
    ]?.orders?.forEach((order) => {
      isDisabled = isDisabled || order?.error_count || poSaved;
    });
    return isDisabled;
  };

  const getFrontendKeyForState = (state) => {
    if (state == "completed" || state == "complete") return "Produced";
    if (state == "approved") return "Active";
  };

  const isDisabled = (index, field) => {
    return !ordersToShow[index].errors.hasOwnProperty(field);
  };

  const onReelODChange = (orderNumber,value) => {
    // const coreODFieldValue = form.getFieldValue(`core_OD${orderNumber}`);
    // const coreODParts = coreODFieldValue ? String(coreODFieldValue).trim().split(/\s+/) : [];
    // let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreODParts[1]] ?? orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let reelodConversion = orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let coreODValue = (parseFloat(coreODParts[0]) || 0) * (coreodConversion ?? 0);
    // let reelOdValue = (parseFloat(value?.split(" ")[0]) || 0) * (reelodConversion ?? 0);
    // if (coreODValue > reelOdValue) {
    //   setReelError(true);
    //   return;
    // }
    // setReelError(false);
    let orders = ordersForSelectedPo;
    let reelODValue = value?.split(" ")[0];
    let reelODUnit = value?.split(" ")[1];
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.reel_od =
      parseFloat(reelODValue);
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.reel_od_unit = reelODUnit;
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.units.reel_od_unit = reelODUnit;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .reel_od
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["reel_od"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    console.log('orders',orders);
    
    setOrdersForSelectedPo(orders);
  }

  const onCoreODChange = (orderNumber,value) => {
    // const reelODFieldValue = form.getFieldValue(`reel_OD${orderNumber}`);
    // const reelODParts = reelODFieldValue ? String(reelODFieldValue).trim().split(/\s+/) : [];
    // let coreodConversion = orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let reelodConversion = orderDim_Rewinder_Unit_Conversion[reelODParts[1]] ?? orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let coreODValue = (parseFloat(value?.split(" ")[0]) || 0) * (coreodConversion ?? 0);
    // let reelOdValue = (parseFloat(reelODParts[0]) || 0) * (reelodConversion ?? 0);
    // if (coreODValue > reelOdValue) {
    //   setCoreError(true);
    //   return;
    // }
    // setCoreError(false);
    let orders = ordersForSelectedPo;
    let coreIdValue = value?.split(" ")[0];
    let coreIdUnit = value?.split(" ")[1];
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.core_id =
      parseFloat(coreIdValue);
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.core_id_unit = coreIdUnit;
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.units.core_id_unit = coreIdUnit;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .core_id
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["core_id"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  }

  const rowRendererRef = useRef(null);
  // Keep latest row renderer in a ref so the virtual list can use a stable component
  // identity (avoids remounting Form fields and wiping validation errors).
  rowRendererRef.current = ({ index, style }) =>
    index !== undefined && (
      <div
        ref={(node) => registerRow(index, node)}
        style={{ ...style, boxSizing: "border-box" }}
      >
        <div
          className="measured-row-content"
          style={{
            width: "298%",
            boxSizing: "border-box",
          }}
        >
          <Row
            gutter={[10, 10]}
            className="groupForm"
            style={{
              width: "100%",
              marginBottom: 0,
              paddingBottom: 0,
              boxSizing: "border-box",
              alignContent: "flex-start",
              borderBottom: "none",
            }}
          >
          {/* <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
                          {(ordersToShow[index].error_count || ordersToShow[index].errors.hasOwnProperty(ordersToShow[index])) ? (
                            <Iconmoon icon="wrong" size={14} color="#EA655B" />
                          ) : (
                            <div style={{ width: "14px" }}></div>
                          )
                          }
                        </Col> */}
          <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
            <Styled>
              {/* {(ordersToShow[index].error_count || ordersToShow[index].errors.hasOwnProperty(ordersToShow[index])) && */}
              <Tooltip
                placement="bottomRight"
                title={
                  ordersToShow[index].error_count ||
                  Object.keys(ordersToShow[index]?.errors || {})?.length > 0
                    ? "This order has failed validation"
                    : ""
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <div style={{ cursor: "default" }}>
                  {ordersToShow[index].error_count ||
                  Object.keys(ordersToShow[index]?.errors || {})?.length > 0 ? (
                    <Iconmoon icon="wrong" size={14} color="#EA655B" />
                  ) : (
                    <div style={{ width: "14px" }}></div>
                  )}
                </div>
              </Tooltip>
              {/* } */}
            </Styled>
          </Col>
          <Col
            style={{
              paddingTop: index == 0 ? "40px" : "10px",
              width: "22px",
              margin: "2px 5px 0px 5px",
            }}
          >
            <Styled>
              {ordersToShow[index].errors?.active_jobcard_conflict && (
                <Tooltip
                  placement="bottomRight"
                  title={ordersToShow[index].errors?.active_jobcard_conflict}
                  className="edit-tooltip"
                  overlayStyle={{ maxWidth: 800, whiteSpace: "normal" }}
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <div>
                    <Iconmoon icon="warning-icon" size={18} color="#EA655B" />
                  </div>
                </Tooltip>
              )}
            </Styled>
          </Col>
          <Col style={{ width: "70px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 || !rowCount.current ? "S.No." : ""}
                name={`sno${ordersToShow[index].order.orderNumber}`}
                rules={[]}
                className="dBlock"
                initialValue={ordersToShow[index].order.orderNumber}
              >
                <Input
                  disabled={true}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ width: "100px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Type" : ""}
                name={`type${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.type}
              >
                <Select
                  placeholder="Type"
                  suffixIcon={<DownArrowDraw />}
                  onChange={() =>
                    handleType(ordersToShow[index].order.orderNumber)
                  }
                  disabled={isDisabled(index, "type")}
                >
                  {orderTypes.map((orderType) => (
                    <Option key={orderType.value}>{orderType.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("type") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.type}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "250px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Product" : ""}
                name={`product${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.product}
                // validateStatus={ordersToShow[index].errors.hasOwnProperty('product') ? "error" : null}
                // help={ordersToShow[index].errshowSearchsaors.hasOwnProperty('product') ? ordersToShow[index].errors.product : null}
              >
                <Select
                  placeholder="Select Product"
                  suffixIcon={<DownArrowDraw />}
                  // onBlur={OnProductToggleSelect}
                  // onFocus={OnProductToggleSelect}
                  showSearch
                  optionFilterProp="children"
                  onChange={(e) =>
                    handleProduct(ordersToShow[index].order.orderNumber, e)
                  }
                  className="dBlock"
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // disabled={isDisabled(index, "product") && isDisabled(index, "grade") && isDisabled(index, "quality") && isDisabled(index, "gsm")}
                >
                  {products.map((product) => (
                    <Option
                      key={product.code}
                      value={`${product.code} - ${product.name}`}
                    >
                      {product.code} - {product.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <p style={{ margin: "5px 5px 0" }}>
                {ordersToShow[index].order.product_spec}
              </p>
            </div>
            {ordersToShow[index].errors?.product ? (
              <p
                className="errorText"
                style={{
                  color: "#ea4e2c",
                  margin: "4px 5px 0",
                  lineHeight: "16px",
                }}
                dangerouslySetInnerHTML={{
                  __html: ordersToShow[index].errors.product,
                }}
              ></p>
            ) : null}
            {/* Shah papers changes */}
            {/* "GRADE" in case of empty field and "Grade" in case of new value */}
            {/* {(!ordersToShow[index].errors.product?.includes("GRADE") &&
              !ordersToShow[index].errors.product?.includes("gsm* is empty") &&
              !ordersToShow[index].errors.product?.includes("Grade")) ? ( */}
            {(ordersToShow[index].errors.product?.includes(
              "Product having parameters",
            ) ||
              ordersToShow[index].errors.product?.includes(
                "Product not found",
              )) && (
              <Button
                className="textTypeBtn"
                style={{
                  margin: "1px 2px 1px auto",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
                onClick={() => addNewProduct(index)}
              >
                <Iconmoon icon="addcircle" color="#ea4e2c" size={12} />
                Add Product
              </Button>
            )}
            {/* ) : null
            } */}
          </Col>
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "grade",
          ) || orderConfigSettings?.upload_orders?.config?.grade?.visibility ? (
            <Col style={{ width: "150px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Grade" : ""}
                  name={`grade${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={ordersToShow[index]?.order?.product_data?.grade}
                >
                  <Select
                    options={allGrades}
                    onChange={(e) =>
                      handleGradeChange(
                        ordersToShow[index].order.orderNumber,
                        e,
                      )
                    }
                    suffixIcon={<DownArrowDraw />}
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                    }
                    // disabled={isDisabled(index, "grade")}
                  >
                    {allGrades.map((grade) => (
                      <Option key={grade.label}>{grade.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("grade") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.grade}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {/* Shah paper changes */}
          {/* {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "quality"
          ) ||
          orderConfigSettings?.upload_orders?.config?.quality?.visibility ? (
            <Col style={{ width: "150px" }}>
              <div
                className="boxFormType"
                onFocus={() => getAllQualities(index)}
              >
                <Form.Item
                  label={index == 0 ? "Quality" : ""}
                  name={`quality${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={
                    ordersToShow[index]?.order?.product_data?.quality
                  }
                >
                    <Select
                      options={allQualities}
                      onChange={(e) =>
                        handleQualityChange(
                          ordersToShow[index].order.orderNumber,
                          e
                        )
                      }
                      suffixIcon={<DownArrowDraw />}
                      disabled={isDisabled(index, "quality")}
                    ></Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("quality") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.quality}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )} */}
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty("gsm") ||
          orderConfigSettings?.upload_orders?.config?.gsm?.visibility ? (
            <Col style={{ width: "150px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "GSM" : ""}
                  name={`gsm${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                      message:
                        "Only numeric characters are allowed upto 3 decimal points",
                    },
                  ]}
                  validateTrigger={["onChange", "onBlur"]}
                  className="dBlock"
                  initialValue={ordersToShow[index]?.order?.product_data?.gsm}
                >
                  <Input
                    placeholder="Enter GSM"
                    onChange={(e) =>
                      onGSMChange(ordersToShow[index].order.orderNumber, e)
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                    }
                  />
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("gsm") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.gsm}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "bulk",
          ) || orderConfigSettings?.upload_orders?.config?.bulk?.visibility ? (
            <Col style={{ width: "150px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Bulk" : ""}
                  name={`bulk${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                      message:
                        "Only numeric characters are allowed upto 3 decimal points",
                    },
                  ]}
                  validateTrigger={["onChange", "onBlur"]}
                  className="dBlock"
                  initialValue={ordersToShow[index]?.order?.product_data?.bulk}
                >
                  <Input
                    placeholder="Enter Bulk"
                    onChange={(e) =>
                      onBulkChange(ordersToShow[index].order.orderNumber, e)
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                    }
                    // disabled={isDisabled(index, "bulk")}
                  />
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("bulk") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.bulk}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {/* shah paper changes
           {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "burst_factor"
          ) ||
          orderConfigSettings?.upload_orders?.config?.burst_factor
            ?.visibility ? (
            <Col style={{ width: "120px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Burst Factor" : ""}
                  name={`burst_factor${ordersToShow[index].order.orderNumber}`}
                  rules={[]}
                  className="dBlock"
                  initialValue={
                    ordersToShow[index]?.order?.product_data?.burst_factor ||
                    "NA"
                  }
                >
                  <Input
                    placeholder="Enter Burst Factor"
                    disabled={isDisabled(index, "burst_factor")}
                  />
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("burst_factor") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.burst_factor}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "moisture"
          ) ||
          orderConfigSettings?.upload_orders?.config?.moisture?.visibility ? (
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Moisture" : ""}
                  name={`moisture${ordersToShow[index].order.orderNumber}`}
                  rules={[]}
                  className="dBlock"
                  initialValue={
                    ordersToShow[index]?.order?.product_data?.moisture || "NA"
                  }
                >
                  <Input
                    placeholder="Enter Moisture"
                    disabled={isDisabled(index, "moisture")}
                  />
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("moisture") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.moisture}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty("ply") ||
          orderConfigSettings?.upload_orders?.config?.ply?.visibility ? (
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "PLY" : ""}
                  name={`ply${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required:
                        ordersToShow[index].order.type === "sheet"
                          ? false
                          : true,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={ordersToShow[index].order.ply}
                >
                  <Select
                    placeholder="Select Ply"
                    suffixIcon={<DownArrowDraw />}
                    showSearch
                    optionFilterProp="children"
                    onChange={() =>
                      handlePly(ordersToShow[index].order.orderNumber)
                    }
                    className="dBlock"
                    style={{ textTransform: "capitalize" }}
                    disabled={isDisabled(index, "ply")}
                  >
                    {plyData.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("ply") ? (
                <span
                  className="errorText"
                  style={{ color: "#ea4e2c" }}
                  dangerouslySetInnerHTML={{
                    __html: ordersToShow[index].errors.ply,
                  }}
                ></span>
              ) : null}
            </Col>
          ) : (
            <></>
          )} */}
          {/* <Col style={{ width: "250px" }}>
                          <div className="boxFormType">
                            <Form.Item
                              label={index == 0 ? "Grade/GSM/BF/Quality/Moisture" : ""}
                              name={`product_spec${ordersToShow[index].order.orderNumber}`}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                }
                              ]}
                              className="dBlock"
                              initialValue={ordersToShow[index].order.product_spec}
                            >
                              <Input
                                disabled
                                placeholder="Grade/GSM/BF/Quality/Moisture"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </div>
                          {ordersToShow[index].errors.hasOwnProperty('product_spec') ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              {ordersToShow[index].errors.product_spec}
                            </span>
                          ) : null}
                        </Col> */}
          <Col style={{ width: "150px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Size(WxL)" : ""}
                name={`size${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    validator(_, value) {
                      if (
                        ordersToShow[index].order.type === "sheet" &&
                        /^(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9])x(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9])$/.test(
                          value,
                        )
                      ) {
                        return Promise.resolve();
                      } else if (
                        ordersToShow[index].order.type === "reel" &&
                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/.test(value)
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject("Valid size is required");
                      }
                    },
                  },
                ]}
                className="dBlock"
                initialValue={
                  ordersToShow[index].order.type === "reel"
                    ? ordersToShow[index].order.width
                    : ordersToShow[index].order.width +
                      "x" +
                      ordersToShow[index].order.length
                }
              >
                <Input
                  placeholder="Enter size"
                  onChange={() =>
                    onSizeChange(ordersToShow[index].order.orderNumber)
                  }
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // disabled={isDisabled(index, "width") && isDisabled(index, "length")}
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("width") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.width}
              </span>
            ) : ordersToShow[index].errors.hasOwnProperty("length") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.length}
              </span>
            ) : null}
          </Col>
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "length_unit",
          ) ||
          orderConfigSettings?.upload_orders?.config?.length_unit
            ?.visibility ? (
            <Col style={{ width: "90px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Unit" : ""}
                  name={`sizeUnit${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={ordersToShow[index].order.size_unit}
                >
                  <Select
                    placeholder="Unit"
                    suffixIcon={<DownArrowDraw />}
                    className="dBlock"
                    // style={{ textTransform: "capitalize" }}
                    onChange={(e) =>
                      onSizeUnitChange(ordersToShow[index].order.orderNumber, e)
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                    }
                    // disabled={isDisabled(index, "size_unit")}
                  >
                    {dimesionUnitList?.map((unit) => (
                      <Option
                        key={`${unit}${ordersToShow[index].order.orderNumber}`}
                        value={unit}
                      >
                        {lengthUnit[unit]?.displayName}
                      </Option>
                    ))}{" "}
                    */
                  </Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("size_unit") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.size_unit}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {isVisible && (
            <Col style={{ width: "90px" }}>
              {index == 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "2px 0px 6px 5px",
                  }}
                >
                  {ordersToShow[index].order.type === "sheet" && (
                    <div className="mandatorySymbolColumnHeader">*</div>
                  )}
                  <div>
                    <span className="columnHeader">Grain</span>
                    <Styled style={{ display: "inline-flex" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"Mandatory for sheet orders."}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <span className="infoIcon"></span>
                      </Tooltip>
                    </Styled>
                  </div>
                </div>
              )}
              <div className="boxFormType">
                <Form.Item
                  name={`grain${ordersToShow[index].order.orderNumber}`}
                  rules={
                    ordersToShow[index].order.type === "sheet" && [
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]
                  }
                  className="dBlock"
                  initialValue={
                    ordersToShow[index].order.type === "sheet"
                      ? ordersToShow[index].order.grain
                      : ""
                  }
                >
                  <Select
                    placeholder="Select Grain"
                    suffixIcon={<DownArrowDraw />}
                    className="dBlock"
                    // style={{ textTransform: "capitalize" }}
                    onChange={(e) =>
                      onGrainChanges(ordersToShow[index].order.orderNumber, e)
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                    }
                    // disabled={isDisabled(index, "grain") || ordersForSelectedPo.data.pos[location.state.selectedPoIndex].isPOSaved}
                  >
                    {["short", "long"].map((grain) => (
                      <Option
                        key={`${grain}${ordersToShow[index].order.orderNumber}`}
                        value={grain}
                      >
                        {grain}
                      </Option>
                    ))}{" "}
                    */
                  </Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("grain") &&
              ordersToShow[index].order.type === "sheet" ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.grain}
                </span>
              ) : null}
            </Col>
          )}
          {/* shah paper changes
          {ordersToShow[index].order.type === "sheet" && (
            <Col>
              {index == 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "2px 0px 6px 5px",
                  }}
                >
                  <span
                    className="columnHeader"
                    style={{ verticalAlign: "bottom", display: "contents" }}
                  >
                    Grain Settings
                  </span>
                </div>
              )}
              <div className="boxFormType">
                <Form.Item
                  name={`grainChanges${ordersToShow[index].order.orderNumber}`}
                >
                  <GlobalSet>
                    <div
                      className="checklist-address"
                      style={{ paddingTop: "0px" }}
                    >
                      <Checkbox
                        type="checkbox"
                        onChange={(e) =>
                          onGrainChangesChange(
                            e,
                            ordersToShow[index].order.orderNumber
                          )
                        }
                        checked={
                          ordersToShow[index].order.rotaion ? true : false
                        }
                        disabled={
                          ordersForSelectedPo.data.pos[
                            location.state.selectedPoIndex
                          ].isPOSaved
                            ? true
                            : ordersToShow[index].order.type === "reel"
                            ? true
                            : false
                        }
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          fontStyle: "normal",
                          lineHeight: "20px",
                          fontFamily: "var(--sf-pro-text)",
                          color: "var(--para-text)",
                          margin: "0",
                          marginTop: "-7px",
                        }}
                      >
                        Allow grain changes
                      </p>
                    </div>
                  </GlobalSet>
                </Form.Item>
              </div>
              <div className="boxFormType">
                <Form.Item
                  name={`grainMixing${ordersToShow[index].order.orderNumber}`}
                >
                  <GlobalSet>
                    <div
                      className="checklist-address"
                      style={{ marginTop: "-32px" }}
                    >
                      <Checkbox
                        type="checkbox"
                        onChange={(e) =>
                          onGrainMixingChange(
                            e,
                            ordersToShow[index].order.orderNumber
                          )
                        }
                        checked={
                          ordersToShow[index].order.grain_mixing ? true : false
                        }
                        disabled={
                          !defaultMixedGrain ||
                          (ordersForSelectedPo.data.pos[
                            location.state.selectedPoIndex
                          ].isPOSaved
                            ? true
                            : ordersToShow[index].order.type === "reel"
                            ? true
                            : false)
                        }
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          fontStyle: "normal",
                          lineHeight: "20px",
                          fontFamily: "var(--sf-pro-text)",
                          color: "var(--para-text)",
                          margin: "0",
                          marginTop: "-5px",
                        }}
                      >
                        Allow mixed grain
                      </p>
                    </div>
                    {ordersToShow[index].order.type === "sheet" &&
                      !defaultMixedGrain && (
                        <p
                          style={{
                            fontSize: "13px",
                            fontStyle: "normal",
                            lineHeight: "20px",
                            fontFamily: "var(--sf-pro-text)",
                            color: "var(--para-text)",
                            fontStyle: "italic",
                            marginTop: "-20px",
                            marginRight: "40px",
                          }}
                        >
                          Disabled in Config
                        </p>
                      )}
                  </GlobalSet>
                </Form.Item>
              </div>
            </Col>
          )} */}

          <Col style={{ width: "140px" }}>
            {index == 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "2px 0px 6px 5px",
                }}
              >
                <div className="mandatorySymbolColumnHeader">*</div>
                <div>
                  <span className="columnHeader">Order Weight</span>
                  <Styled style={{ display: "inline-flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={
                        "Either Order weight or quantity should be present. If both are present, order weight will be considered."
                      }
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <span className="infoIcon"></span>
                    </Tooltip>
                  </Styled>
                </div>
              </div>
            )}
            <div className="boxFormType">
              <Form.Item
                name={`orderWeight${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required:
                      ordersToShow[index].order.quantity_type == "weight"
                        ? true
                        : false,
                    message: "This field is required",
                  },
                  // {
                  //   pattern: ordersToShow[index].order.quantity_type == "weight" ? (new RegExp(
                  //     /^\d+(\.\d{0,3})?$/
                  //   )) : (""),
                  //   message:
                  //     "This value should be a non-zero positive value",
                  // },
                  // {
                  //     pattern: ordersToShow[index].order.quantity_type == "weight" ? (new RegExp(
                  //     /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                  //     )) : (""),
                  //     message:
                  //     "Weight should be a number greater than zero",
                  // },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.weight}
              >
                <Input
                  placeholder="Enter weight"
                  onChange={() =>
                    onOrderWeightChange(ordersToShow[index].order.orderNumber)
                  }
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // disabled={isDisabled(index,"weight")}
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("weight") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.weight}
              </span>
            ) : null}
          </Col>
          {!orderConfigSettings?.upload_orders?.config?.hasOwnProperty(
            "weight_unit",
          ) ||
          orderConfigSettings?.upload_orders?.config?.weight_unit
            ?.visibility ? (
            <Col style={{ width: "140px" }}>
              <div className="boxFormType unitSelect">
                <Form.Item
                  label={index == 0 ? "Unit" : ""}
                  name={`orderWeightUnit${ordersToShow[index].order.orderNumber}`}
                  rules={[
                    {
                      required:
                        !ordersToShow[index].order.weight &&
                        !ordersToShow[index].order.no_of_reel_sheet
                          ? true
                          : ordersToShow[index].order.weight
                            ? true
                            : false,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={ordersToShow[index].order.weight_unit}
                >
                  <Select
                    placeholder="Unit"
                    suffixIcon={<DownArrowDraw />}
                    className="dBlock"
                    style={{ textTransform: "capitalize" }}
                    onChange={() =>
                      onOrderWeightUnitChange(
                        ordersToShow[index].order.orderNumber,
                      )
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                    }
                    // disabled={isDisabled(index,"weight_unit")}
                  >
                    {weightUnitList?.map((unit) => (
                      <Option
                        key={`${unit}${ordersToShow[index].order.orderNumber}`}
                        value={unit}
                      >
                        {capitalize(weightUnit[unit]?.displayName)}
                      </Option>
                    ))}{" "}
                    */
                  </Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("weight_unit") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.weight_unit}
                </span>
              ) : null}
            </Col>
          ) : (
            <></>
          )}
          {/* shah paper changes
          <Col style={{ width: "140px" }}>
            {index == 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "2px 0px 6px 5px",
                }}
              >
                <div className="mandatorySymbolColumnHeader">*</div>
                <div>
                  <span className="columnHeader">Quantity</span>
                  <Styled style={{ display: "inline-flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={
                        "It represents number of reel or sheets. Either order weight or quantity should be present. If both are present, order weight will be considered."
                      }
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <span className="infoIcon"></span>
                    </Tooltip>
                  </Styled>
                </div>
              </div>
            )}
            <div className="boxFormType">
              <Form.Item
                name={`quantity${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.no_of_reel_sheet}
              >
                <Input
                  placeholder={savedState ? "Enter quantity" : ""}
                  onChange={() =>
                    onQuantityChange(ordersToShow[index].order.orderNumber)
                  }
                  // style={{ textTransform: "capitalize" }}
                  disabled={isDisabled(index,"no_of_reel_sheet")}
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("no_of_reel_sheet") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.no_of_reel_sheet}
              </span>
            ) : null}
          </Col> */}
          {/* shah paper changes
           <Col style={{ width: "150px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Order State" : ""}
                name={`state${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index]?.order?.state}
              >
                  <Select
                    placeholder="Order State"
                    options={[
                      { label: "Active", value: "approved" },
                      { label: "Produced", value: "complete" },
                    ]}
                    suffixIcon={<DownArrowDraw />}
                    value={ordersToShow[index]?.order?.state}
                    disabled={isDisabled(index,"state")}
                  />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("state") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.state}
              </span>
            ) : null}
          </Col> */}
          <Col style={{ width: "150px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Balance Quantity" : ""}
                name={`balance_quantity${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index]?.order?.balance_weight}
              >
                <Input
                  placeholder="Enter Balance Quantity"
                  value={ordersToShow[index]?.order?.balance_weight}
                  onChange={(e) =>
                    onBalanceQtyChange(ordersToShow[index].order.orderNumber, e)
                  }
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // disabled={isDisabled(index,"balance_weight")}
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("balance_weight") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.balance_weight}
              </span>
            ) : null}
          </Col>
          {/* Shah paper changes */}
          <Col style={{ width: "260px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Reel OD" : ""}
                className="dBlock"
                name={`reel_OD${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    validator: (_, value) => {
                      const coreODFieldValue = form.getFieldValue(
                        `core_OD${ordersToShow[index].order.orderNumber}`,
                      );

                      if (!value?.trim() || !coreODFieldValue?.trim())
                        return Promise.resolve();

                      const coreParts = String(coreODFieldValue)
                        .trim()
                        .split(/\s+/);
                      const reelParts = String(value).trim().split(/\s+/);

                      let coreConv =
                        orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                      let reelConv =
                        orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                      let coreVal =
                        (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                      let reelVal =
                        (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                      if (coreVal > reelVal) {
                        return Promise.reject(
                          new Error("Core OD should be less than Reel OD"),
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
                initialValue={
                  (ordersToShow[index]?.order?.reel_od
                    ? ordersToShow[index]?.order?.reel_od
                    : "") +
                  " " +
                  (ordersToShow[index]?.order?.reel_od
                    ? ordersToShow[index]?.order?.reel_od_unit
                    : "")
                }
              >
                <Select
                  placeholder="Select Reel OD"
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  className="dBlock"
                  onChange={(value) => {
                    form.setFieldsValue({
                      [`reel_OD${ordersToShow[index].order.orderNumber}`]:
                        value,
                    });

                    const coreValue = form.getFieldValue(
                      `core_OD${ordersToShow[index].order.orderNumber}`,
                    );

                    onReelODChange(
                      ordersToShow[index].order.orderNumber,
                      value,
                    );

                    if (!value || !coreValue) return;

                    const coreParts = String(coreValue).trim().split(/\s+/);
                    const reelParts = String(value).trim().split(/\s+/);

                    let coreConv =
                      orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                    let reelConv =
                      orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                    let coreVal =
                      (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                    let reelVal =
                      (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                    if (coreVal <= reelVal) {
                      form.setFields([
                        {
                          name: `core_OD${ordersToShow[index].order.orderNumber}`,
                          errors: [],
                        },
                        {
                          name: `reel_OD${ordersToShow[index].order.orderNumber}`,
                          errors: [],
                        },
                      ]);
                    }
                  }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // style={{ width: "331px" }}
                  // disabled={
                  //   // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                  //   // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                  //   props?.actionType == "view"
                  // }
                >
                  {reelvalues?.map((data) => (
                    <Option key={data.value}>{data.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("reel_od") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.reel_od}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "260px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Core ID" : ""}
                name={`core_OD${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    validator: (_, value) => {
                      const reelODFieldValue = form.getFieldValue(
                        `reel_OD${ordersToShow[index].order.orderNumber}`,
                      );

                      if (!value?.trim() || !reelODFieldValue?.trim())
                        return Promise.resolve();

                      const coreParts = String(value).trim().split(/\s+/);
                      const reelParts = String(reelODFieldValue)
                        .trim()
                        .split(/\s+/);

                      let coreConv =
                        orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                      let reelConv =
                        orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                      let coreVal =
                        (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                      let reelVal =
                        (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                      if (coreVal > reelVal) {
                        return Promise.reject(
                          new Error("Core OD should be less than Reel OD"),
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
                className="dBlock"
                initialValue={
                  (ordersToShow[index]?.order?.core_id
                    ? ordersToShow[index]?.order?.core_id
                    : "") +
                  " " +
                  (ordersToShow[index]?.order?.core_id
                    ? ordersToShow[index]?.order?.core_id_unit
                    : "")
                }
              >
                <Select
                  placeholder="Select Core OD"
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  onChange={(value) => {
                    form.setFieldsValue({
                      [`core_OD${ordersToShow[index].order.orderNumber}`]:
                        value,
                    });

                    const reelValue = form.getFieldValue(
                      `reel_OD${ordersToShow[index].order.orderNumber}`,
                    );

                    onCoreODChange(
                      ordersToShow[index].order.orderNumber,
                      value,
                    );

                    if (!value || !reelValue) return;

                    const coreParts = String(value).trim().split(/\s+/);
                    const reelParts = String(reelValue).trim().split(/\s+/);

                    let coreConv =
                      orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                    let reelConv =
                      orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                    let coreVal =
                      (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                    let reelVal =
                      (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                    // ✅ VALID → CLEAR ERRORS
                    if (coreVal <= reelVal) {
                      form.setFields([
                        {
                          name: `core_OD${ordersToShow[index].order.orderNumber}`,
                          errors: [],
                        },
                        {
                          name: `reel_OD${ordersToShow[index].order.orderNumber}`,
                          errors: [],
                        },
                      ]);
                    }
                  }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // style={{ width: "331px" }}
                  // disabled={
                  //   // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                  //   // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                  //   props?.actionType == "view"
                  // }
                >
                  {corevalues?.map((data) => (
                    <Option key={data.value}>{data.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("core_id") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.core_id}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "260px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Remarks" : ""}
                name={`remark${ordersToShow[index].order.orderNumber}`}
                className="dBlock"
                initialValue={ordersToShow[index].order.remarks}
              >
                <Input
                  placeholder="Enter Remark"
                  onChange={(e) =>
                    onRemarkChange(ordersToShow[index].order.orderNumber, e)
                  }
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                  }
                  // style={{ textTransform: "capitalize" }}
                  // disabled={
                  //   ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                  //     .isPOSaved
                  //     ? true
                  //     : false
                  // }
                />
              </Form.Item>
            </div>
          </Col>
            {setRowCount()}
          </Row>
          <div
            aria-hidden="true"
            style={{
              width: "100%",
              marginTop: "12px",
              borderBottom: "1px solid #edebe9",
              pointerEvents: "none",
            }}
          />
        </div>
      </div>
    );

  const StableListRow = useCallback((props) => {
    return rowRendererRef.current?.(props) ?? null;
  }, []);

  return filteredOrders ? (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="Uploaded Summary"
          extra={[
            <Button
              key="3"
              className="themeBtn noBg"
              loading={gobackLoading}
              onClick={() => goBack()}
              disabled={loadings}
            >
              {!gobackLoading && (
                <Iconmoon icon="left-to-thin" size={14} color="#EA655B" />
              )}
              {!gobackLoading ? "Go Back" : ""}
            </Button>,
            // <Button
            //   key="1"
            //   className="themeBtn"
            //   onClick={() => saveDetails()}
            //   loading={loadings}
            //   disabled={checkSaveDisabled()}
            //   // disabled={
            //   //   savedState ||
            //   //   !products?.length ||
            //   //   (!ordersForSelectedPo &&
            //   //     Object.keys(
            //   //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //   //         .orders
            //   //     ).length != 0) ||
            //   //   (ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //   //     .error_count != 0 &&
            //   //     Object.keys(
            //   //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //   //         .errors
            //   //     ).length != 0) ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .delivery_address_line_1 ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .delivery_state ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .delivery_city ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .delivery_pincode ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .delivery_country ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .shipping_address_line_1 ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .shipping_state ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .shipping_city ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .shipping_pincode ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .shipping_country ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .billing_address_line_1 ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .billing_state ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .billing_city ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .billing_pincode ||
            //   //   !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
            //   //     .billing_country ||
            //   //   (ordersForSelectedPo.data.pos[
            //   //     location.state.selectedPoIndex
            //   //   ].orders.filter((e) => e.error_count > 0).length == 0
            //   //     ? ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //   //         .isPOSaved
            //   //       ? true
            //   //       : false
            //   //     : true) ||
            //   //   resendAppOtherButtonLoading
            //   // }
            // >
            //   {!loadings && (
            //     <Iconmoon icon="addcircle" size={14} color="#ffffff" />
            //   )}
            //   {!loadings ? "Save Details" : ""}
            // </Button>,
            // <Button
            //   key="2"
            //   className="themeBtn"
            //   onClick={() => saveDetails("pending")}
            //   loading={resendAppLoading}
            //   disabled={
            //     savedState ||
            //     !products?.length ||
            //     (ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //       .error_count == 0 &&
            //     Object.keys(
            //       ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //         .errors
            //     ).length == 0 &&
            //     ordersForSelectedPo.data.pos[
            //       location.state.selectedPoIndex
            //     ].orders.filter((e) => e.error_count > 0).length == 0
            //       ? ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
            //           .isPOSaved
            //         ? true
            //         : false
            //       : true) ||
            //     otherButtonLoading
            //   }
            // >
            //   {!resendAppLoading && (
            //     <Iconmoon icon="addcircle" size={14} color="#ffffff" />
            //   )}
            //   {!resendAppLoading ? "Save & Send for Approval" : ""}
            // </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      <div
        className="showPriorityOrder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            marginTop: "10px",
            fontSize: "14px",
            fontFamily: "var(--sf-pro-display)",
            lineHeight: "16px",
          }}
        >
          {location.state.isSOOrders ? "SO" : "PO"}:{" "}
          {
            ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
              .number
          }
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <DisabledButtonStyle style={{ displayFlex: "end" }}>
              <Button
                className={
                  show
                    ? "themeBtn noBg approveAllOrders"
                    : "themeBtn noBg disabledstyle approve-header"
                }
                onClick={() => {
                  setShow(!show);
                  filterRecords(!show);
                  rowCount.current = false;
                }}
              >
                <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
                {show ? "Show All Orders" : "Show Only Failed Orders"}
              </Button>
            </DisabledButtonStyle>
          </div>
          <div
            style={{
              marginTop: "10px",
              marginRight: "15px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Failed Orders:{" "}
            {
              ordersForSelectedPo.data.pos[
                location.state.selectedPoIndex
              ].orders.filter((e) => e.error_count > 0).length
            }
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Verified Orders:{" "}
            {
              ordersForSelectedPo.data.pos[
                location.state.selectedPoIndex
              ].orders.filter((e) => e.error_count == 0).length
            }
          </div>
        </div>
      </div>
      <OrderSummary>
        <div
          className="orderSummaryStyle"
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <div style={{ maxWidth: "410px", marginRight: "1%" }}>
            <span
              className="orderWeightStyle"
              style={{ textAlign: "left", fontStyle: "italic" }}
            >
              Note: The default tolerance +{upperTolerance} to -{lowerTolerance}{" "}
              defined in settings will be used to set tolerance values for
              orders
            </span>
          </div>
        </div>
      </OrderSummary>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <div
                style={{
                  overflow: "auto",
                  width: window.screen.width < 1500 ? "103.5%" : "102%",
                  height: window.screen.width > 1400 ? "600px" : "400px",
                }}
              >
                <AutoSizer>
                  {({ height, width }) => (
                    <VariableSizeList
                      ref={listRef}
                      height={height}
                      itemCount={ordersToShow?.length}
                      itemSize={getItemSize}
                      estimatedItemSize={120}
                      width={width}
                      overscanCount={2}
                      onScroll={handleScroll}
                      itemKey={(index) => ordersToShow[index].order.orderNumber}
                    >
                      {StableListRow}
                    </VariableSizeList>
                  )}
                </AutoSizer>
                {loading && (
                  <div style={{ position: "relative" }}>
                    <div style={{ marginTop: "33%", marginLeft: "2%" }}>
                      {"Loading..."}
                    </div>
                  </div>
                )}
                {/* <Pagination
                    total={filteredOrders?.length}
                    showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} results`}
                    defaultPageSize={25}
                    defaultCurrent={currentPage}
                    onChange={onPageChange}
                    showSizeChanger={false}
                  /> */}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {/* Toasters */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
      {productDrawerVisible && (
        <AddProductDrawer
          closeProductDrawer={closeProductDrawer}
          productDrawer={productDrawerVisible}
          setNewProductData={setNewProductData}
          selectedRecord={{
            quality:
              ordersToShow[selectedOrderIndex]?.order?.product_data?.quality,
            grade: ordersToShow[selectedOrderIndex]?.order?.product_data?.grade,
            gsm: ordersToShow[selectedOrderIndex]?.order?.product_data?.gsm,
            burst_factor:
              ordersToShow[selectedOrderIndex]?.order?.product_data
                ?.burst_factor,
            bulk: ordersToShow[selectedOrderIndex]?.order?.product_data?.bulk,
            ply: ordersToShow[selectedOrderIndex]?.order?.ply,
            moisture:
              ordersToShow[selectedOrderIndex]?.order?.product_data?.moisture,
            type: ordersToShow[selectedOrderIndex]?.order?.type,
            productName: `${
              ordersToShow[selectedOrderIndex]?.order?.product_data?.quality +
              "-" +
              ordersToShow[selectedOrderIndex]?.order?.product_data?.gsm +
              "-" +
              ordersToShow[selectedOrderIndex]?.order?.product_data
                ?.burst_factor +
              "-" +
                Number(
                  parseFloat(ordersToShow[
                    selectedOrderIndex
                  ]?.order?.product_data?.bulk)?.toFixed(2)
                )
            }`,
          }}
        />
      )}
    </RightLayoutContainer>
  ) : null;
};
export default UploadedPoOrders;